// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseURL: `${string}://${string}` | (string & {});
};

export enum AiSuggestionType {
  KNOWLEDGE = 'KNOWLEDGE',
  COMPOUND = 'COMPOUND',
  DATA_TABLE = 'DATA_TABLE',
  DOCX_EDIT = 'DOCX_EDIT',
  SEARCH = 'SEARCH',
  REFERENCE_SIGN = 'REFERENCE_SIGN',
  SEQUENCE = 'SEQUENCE',
  CHAT_FIGURE = 'CHAT_FIGURE',
  EXTERNAL_FILE = 'EXTERNAL_FILE',
}

export enum AccessType {
  OWNER = 'OWNER',
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER',
}

export type Action = {
  type: 'action';
  details: ActionDetails;
};

export type ActionDetails =
  | ({
      type: 'documentCreationRequired';
    } & DocumentCreationRequired)
  | ({
      type: 'userConfirmationRequired';
    } & UserConfirmationRequired)
  | ({
      type: 'projectDocumentCreationRequired';
    } & ProjectDocumentCreationRequired)
  | ({
      type: 'externalFileSuggestion';
    } & ExternalFileSuggestion);

export type ActiveMessage = {
  status: ActiveMessageStatus;
  prompt: UserChatMessageInfo;
};

export enum ActiveMessageStatus {
  RUNNING = 'RUNNING',
  FAILED = 'FAILED',
}

export type AddCompoundRequest = {
  smiles: string;
  molStructure: string;
  compoundName?: string;
  compoundAlias?: string;
  description?: string;
  sourceCdxml?: string;
};

export type AddCompoundRequestV2 = {
  sourceCdxml: string;
  compoundName?: string;
  compoundAlias?: string;
  description?: string;
};

export type AddPatentDraftReferencePatentFileIdRequest = {
  patentDraftId: string;
  referencePatentFileId: string;
};

export type AddedPatentSuggestion = {
  patentExtractionItemId: string;
  status: 'ADDED';
  folderId: string;
};

export type AdditionalDocument = {
  type: ResourceType;
  id: string;
  content: string;
};

export type AdminCustomField = {
  fieldId: string;
  resourceType: ResourceType;
  displayName: string;
  description?: string;
  fieldType: CustomFieldType;
  showInList: boolean;
  position: number;
};

/**
 * Leave key out for a new option and the server assigns one. Send an existing option's key back to keep its selections.
 */
export type AdminCustomFieldOption = {
  key?: string;
  displayValue: string;
};

export type AdminCustomFieldSettings = {
  displayName: string;
  description?: string;
  fieldType: AdminCustomFieldType;
  showInList: boolean;
  position: number;
};

export type AdminCustomFieldType =
  | ({
      type: 'text';
    } & TextFieldType)
  | ({
      type: 'number';
    } & NumberFieldType)
  | ({
      type: 'boolean';
    } & BooleanFieldType)
  | ({
      type: 'date';
    } & DateFieldType)
  | ({
      type: 'select';
    } & AdminSelectFieldType)
  | ({
      type: 'user';
    } & UserFieldType);

export type AdminFeatureFlag = {
  flagKey: string;
  owner: string;
  releaseTrack: AdminFeatureFlagReleaseTrack;
  removalDate: string;
  backfilledBySetting?: string;
};

export type AdminFeatureFlagReleaseTrack = {
  internal: boolean;
  canary: boolean;
  stable: boolean;
  override?: boolean;
  userOverride?: boolean;
};

export type AdminSelectFieldType = {
  type: 'select';
  options: Array<AdminCustomFieldOption>;
  allowMultiple: boolean;
};

export type AdminSetting = {
  id: string;
  /**
   * Discriminator property for AdminSetting.
   */
  type: string;
};

export type AdminSettingUpdate = {
  id: string;
  /**
   * Discriminator property for AdminSettingUpdate.
   */
  type: string;
};

export type AdminSettings = {
  settings: Array<AdminSetting>;
};

export type AiAutofillColumnSource = {
  type: 'aiAutoFill';
  instructions?: string;
};

export type AiPrefill = {
  type: 'ai';
  instruction: string;
};

export type AlignCompoundsRotationRequest = {
  compoundIds: Array<string>;
  referenceCompoundId: string;
};

export type AlignmentDetails = {
  algorithm: string;
  substitutionMatrix?: string;
  gapOpen: number;
  gapExtend: number;
};

export type AlignmentHit = {
  queryName: string;
  subjectName: string;
  querySeqNoId?: number;
  subjectSeqNoId?: number;
  identityPct: number;
  identityCount: number;
  positivesPct: number;
  positives: number;
  gapsPct: number;
  gaps: number;
  length: number;
  queryAligned: string;
  subjectAligned: string;
  diff: string;
  queryRange: AlignmentRange;
  subjectRange: AlignmentRange;
};

export enum AlignmentMolType {
  PROTEIN = 'protein',
  NUCLEOTIDE = 'nucleotide',
}

export type AlignmentRange = {
  start: number;
  end: number;
};

export type AllSuggestionReviewedEvent = Omit<SuggestionReviewedEvent, 'type'> & {
  type: 'all';
} & {
  type: 'all';
  items: number;
};

export type AnaquaExternalSourceAuthConfig = {
  type: 'anaqua';
};

export type AnaquaExternalSourceConfig = {
  type: 'anaqua';
  baseUrl: string;
};

export type AndSearchCondition = {
  type: 'and';
  conditions: Array<SigmaSearchCondition>;
};

export type AnswerExportValue = {
  type: 'answer';
  key: string;
  fieldId: string;
};

export type ApiKeyExternalSourceCredentials = {
  type: 'apiKey';
  keyId: string;
  key: string;
};

export type AppendDataTableRowsRequest = {
  /**
   * @deprecated
   */
  temporaryFileIds?: Array<string>;
  columns: Array<DataTableRowImportMapping>;
  ranges?: Array<DataTableImportFileRange>;
};

export type AppendDataTableRowsResponse = {
  addedRowCount: number;
};

export type ArchivePatentDraftsRequest = {
  patentDraftIds: Array<string>;
};

export type ArchiveReferenceSignsRequest = {
  referenceSignIds: Array<string>;
};

export type AssistantChatChartMessageBlock = {
  type: 'chart';
  chart: Chart;
  chartId?: string;
};

export type AssistantChatCompoundMessageBlock = {
  type: 'compound';
  compound: AssistantChatMessageCompound;
};

export type AssistantChatContextCompoundsMessageBlock = {
  type: 'contextCompounds';
  contextCompounds: Array<AssistantChatMessageCompound>;
};

export type AssistantChatContextDataTablesMessageBlock = {
  type: 'contextDataTables';
  contextDataTables: Array<DataTableInfo>;
};

export type AssistantChatContextDocsMessageBlock = {
  type: 'contextDocuments';
  contextDocuments: Array<AssistantContextDocument>;
};

export type AssistantChatContextFilesMessageBlock = {
  type: 'contextFiles';
  contextFiles: Array<AssistantContextFile>;
};

export type AssistantChatContextKnowledgeMessageBlock = {
  type: 'contextKnowledge';
  contextKnowledge: Array<KnowledgeInfo>;
};

export type AssistantChatContextObjectionsMessageBlock = {
  type: 'contextObjections';
  objections: Array<AssistantContextInfo>;
};

export type AssistantChatContextSequencesMessageBlock = {
  type: 'contextSequences';
  contextSequences: Array<CitationSequence>;
};

export type AssistantChatContextSkillsMessageBlock = {
  type: 'contextSkills';
  skillIds: Array<string>;
};

export type AssistantChatDataTableChartMessageBlock = {
  type: 'dataTableChart';
  chartId?: string;
  tableId: string;
  chartSpec: DataTableChartSpec;
  filterSpec?: DataTableChartFilterSpec;
  result: DataTableChartResult;
  origin?: DataTableChartOrigin;
};

export type AssistantChatDocumentCreationMessageBlock = {
  type: 'documentCreation';
  documentCreationEventId?: string;
  documentType: OfficeActionDocumentType;
  status: DocumentCreationEventStatus;
};

export type AssistantChatDossierSearchMessageBlock = {
  type: 'dossierSearch';
  dossier: DossierSource;
  applicationReference: string;
  recommendedDocumentIds: Array<string>;
};

export type AssistantChatEditDocumentMessageBlock = {
  type: 'editedDocument';
  editableDocument: EditableDocument;
};

export type AssistantChatEditFormFieldMessageBlock = {
  type: 'editedFormField';
  formId: string;
  fieldKey: string;
  value: FormAnswer;
};

export type AssistantChatFigureDiagramSuggestionMessageBlock = {
  type: 'figureDiagramSuggestion';
  figureDiagram: FigureDiagramSuggestion;
};

export type AssistantChatKnowledgeSuggestionMessageBlock = {
  type: 'knowledgeSuggestion';
  knowledge: KnowledgeSuggestion;
};

export type AssistantChatMessageBlock =
  | ({
      type: 'text';
    } & AssistantChatTextMessageBlock)
  | ({
      type: 'compound';
    } & AssistantChatCompoundMessageBlock)
  | ({
      type: 'contextFiles';
    } & AssistantChatContextFilesMessageBlock)
  | ({
      type: 'editedDocument';
    } & AssistantChatEditDocumentMessageBlock)
  | ({
      type: 'contextDocuments';
    } & AssistantChatContextDocsMessageBlock)
  | ({
      type: 'sequenceSuggestion';
    } & AssistantChatSequenceMessageBlock)
  | ({
      type: 'documentCreation';
    } & AssistantChatDocumentCreationMessageBlock)
  | ({
      type: 'userConfirmation';
    } & AssistantChatUserConfirmationMessageBlock)
  | ({
      type: 'suggestedPrompts';
    } & AssistantChatSuggestedPromptsMessageBlock)
  | ({
      type: 'publicationHighlight';
    } & AssistantChatPublicationHighlightMessageBlock)
  | ({
      type: 'dossierSearch';
    } & AssistantChatDossierSearchMessageBlock)
  | ({
      type: 'chart';
    } & AssistantChatChartMessageBlock)
  | ({
      type: 'table';
    } & AssistantChatTableMessageBlock)
  | ({
      type: 'dataTableChart';
    } & AssistantChatDataTableChartMessageBlock)
  | ({
      type: 'knowledgeSuggestion';
    } & AssistantChatKnowledgeSuggestionMessageBlock)
  | ({
      type: 'searchSuggestion';
    } & AssistantChatSearchSuggestionMessageBlock)
  | ({
      type: 'suggestion';
    } & AssistantChatSuggestionMessageBlock)
  | ({
      type: 'alignment';
    } & AssistantChatSequenceAlignmentMessageBlock)
  | ({
      type: 'contextKnowledge';
    } & AssistantChatContextKnowledgeMessageBlock)
  | ({
      type: 'contextSkills';
    } & AssistantChatContextSkillsMessageBlock)
  | ({
      type: 'contextDataTables';
    } & AssistantChatContextDataTablesMessageBlock)
  | ({
      type: 'contextCompounds';
    } & AssistantChatContextCompoundsMessageBlock)
  | ({
      type: 'contextSequences';
    } & AssistantChatContextSequencesMessageBlock)
  | ({
      type: 'contextObjections';
    } & AssistantChatContextObjectionsMessageBlock)
  | ({
      type: 'figureDiagramSuggestion';
    } & AssistantChatFigureDiagramSuggestionMessageBlock)
  | ({
      type: 'context';
    } & AssistantContextBlock)
  | ({
      type: 'textV2';
    } & TextMessageBlock)
  | ({
      type: 'patentExtraction';
    } & AssistantChatPatentExtractionMessageBlock)
  | ({
      type: 'editedFormField';
    } & AssistantChatEditFormFieldMessageBlock);

export type AssistantChatMessageCitation =
  | ({
      type: 'file';
    } & AssistantChatMessageFileCitation)
  | ({
      type: 'uspto101File';
    } & AssistantChatMessageUspto101FileCitation)
  | ({
      type: 'compound';
    } & AssistantChatMessageCompoundCitation)
  | ({
      type: 'sequence';
    } & AssistantChatMessageSequenceCitation)
  | ({
      type: 'staticFile';
    } & AssistantChatMessageStaticFileCitation)
  | ({
      type: 'patent';
    } & AssistantChatMessagePatentCitation);

export type AssistantChatMessageCompound = {
  compoundId: string;
  smiles?: string;
  isDeleted: boolean;
  alias: string;
  status?: CompoundStatus;
};

export type AssistantChatMessageCompoundCitation = {
  type: 'compound';
  compound: CitationCompound;
  highlightAtomIndices: Array<number>;
  highlightBondIndices: Array<number>;
};

export type AssistantChatMessageFileCitation = {
  type: 'file';
  /**
   * @deprecated
   */
  fileId?: string;
  /**
   * @deprecated
   */
  fileInfo?: CitationFile;
  file: CitationFile;
  boundingBoxes: Array<BoundingBox>;
};

export type AssistantChatMessageInfo = {
  type: 'assistant';
  chatId: string;
  timestamp: string;
  content: Array<AssistantChatMessageBlock>;
  acknowledged: boolean;
  /**
   * @deprecated
   */
  contextFiles?: Array<AssistantContextFile>;
};

export type AssistantChatMessagePatentCitation = {
  type: 'patent';
  patent: PatentInfo;
};

export type AssistantChatMessageSequence = {
  seqNoId: number;
  name: string;
  molType: string;
  sequence: string;
  features: Array<SequenceFeature>;
};

export type AssistantChatMessageSequenceCitation = {
  type: 'sequence';
  sequence: CitationSequence;
  region?: string;
};

export type AssistantChatMessageStaticFileCitation = {
  type: 'staticFile';
  file: StaticFile;
  boundingBoxes: Array<BoundingBox>;
};

export type AssistantChatMessageUspto101FileCitation = {
  type: 'uspto101File';
  file: Uspto101File;
  boundingBoxes: Array<BoundingBox>;
};

export type AssistantChatPatentExtractionMessageBlock = {
  type: 'patentExtraction';
  patents: Array<ExtractedPatent>;
};

export type AssistantChatPublicationHighlightMessageBlock = {
  type: 'publicationHighlight';
  resultId?: string;
};

export type AssistantChatSearchSuggestionMessageBlock = {
  type: 'searchSuggestion';
  searchSuggestion: SearchSuggestionDetail;
};

export type AssistantChatSequenceAlignmentMessageBlock = {
  type: 'alignment';
  alignment: ChatAlignment;
};

export type AssistantChatSequenceMessageBlock = {
  type: 'sequenceSuggestion';
  sequences: Array<AssistantChatMessageSequence>;
};

export type AssistantChatSuggestedPromptsMessageBlock = {
  type: 'suggestedPrompts';
  prompts: Array<string>;
};

export type AssistantChatSuggestionMessageBlock = {
  type: 'suggestion';
  suggestion: ChatSuggestion;
};

export type AssistantChatTableMessageBlock = {
  type: 'table';
  dataTable?: DataTable;
  tableType: TableBlockType;
};

export type AssistantChatTextMessageBlock = {
  type: 'text';
  text: string;
  citations: Array<AssistantChatMessageCitation>;
};

export type AssistantChatUserConfirmationMessageBlock = {
  type: 'userConfirmation';
  confirmationType: UserConfirmationType;
};

export type AssistantContext = {
  contextType: AssistantContextType;
  contextInfo: Array<AssistantContextInfo>;
};

export type AssistantContextBlock = {
  type: 'context';
  assistantContext: AssistantContext;
};

export type AssistantContextDocument = {
  documentId: string;
  documentName: string;
};

export type AssistantContextFile = {
  fileId: string;
  name: string;
  isDeleted: boolean;
  fileType: ContextFileType;
  count?: number;
  /**
   * @deprecated
   */
  fileName?: string;
  /**
   * @deprecated
   */
  isArchived?: boolean;
};

export type AssistantContextInfo = {
  id: string;
  title: string;
  isDeleted: boolean;
};

export enum AssistantContextType {
  FILE = 'FILE',
  STATIC_FILE = 'STATIC_FILE',
  FILE_IMAGES = 'FILE_IMAGES',
  DOCUMENT = 'DOCUMENT',
  KNOWLEDGE = 'KNOWLEDGE',
  OBJECTION = 'OBJECTION',
  EXTERNAL_SOURCE = 'EXTERNAL_SOURCE',
}

export type AttachResourceKnowledgeRequest = {
  knowledgeId: string;
};

export enum BarOrientation {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}

export enum BarSeriesLayout {
  GROUPED = 'GROUPED',
  STACKED = 'STACKED',
}

export type BaseKnowledge = {
  id: string;
  name: string;
  sharedWithOrg: boolean;
  accessType: AccessType;
};

export type BaseOrganization = {
  id: string;
  name: string;
};

export type BaseUser = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
};

export type BasicUserInfo = {
  userId: string;
  username: string;
  email: string;
};

export type BatchAddCompoundsResponse = {
  failedCompounds: Array<FailedCompoundInfo>;
};

export type BatchCreateReferenceSignsRequest = {
  newSigns: Array<NewReferenceSignDetails>;
};

export type BatchCreateSequencesRequest = {
  sequences: Array<CreateSequenceRequest>;
  folderId?: string;
};

export type BatchDeleteFiguresRequest = {
  figureIds: Array<string>;
};

export type BatchDeletePatentDraftFilesRequest = {
  fileIds: Array<string>;
};

export type BatchEditReferenceSignsRequest = {
  signsToEdit: Array<ReferenceSignDetails>;
};

export type BatchExportFiguresToVisioRequest = {
  figureIds: Array<string>;
};

export type BatchImportFromFileRequest = {
  fileFigureIds: Array<string>;
};

export type BatchReferenceSignFigureLinkRequest = {
  linkRequests: Array<ReferenceSignFigureLinkRequest>;
};

export type BatchUploadFiguresRequest = {
  files: Array<unknown>;
  fileNames: Array<string>;
};

export type BatchUploadFiguresResponse = {
  uploadedFigures: Array<FigureResponse>;
  failedUploads: Array<FailedFigureUpload>;
};

export type BlockStart = {
  type: 'blockStart';
  blockType: BlockType;
  location?: EditLocation;
  tableSchema?: TableSchema;
  tableUpdate?: TableUpdateStart;
  details?: BlockStartDetails;
};

export type BlockStartDetails = FormFieldBlockStart;

export type BlockStop = {
  type: 'blockStop';
};

export enum BlockType {
  TEXT = 'TEXT',
  COMPOUND_SUGGESTION = 'COMPOUND_SUGGESTION',
  KNOWLEDGE_SUGGESTION = 'KNOWLEDGE_SUGGESTION',
  SEARCH_SUGGESTION = 'SEARCH_SUGGESTION',
  FIGURE_DIAGRAM_SUGGESTION = 'FIGURE_DIAGRAM_SUGGESTION',
  EDIT_DOCUMENT = 'EDIT_DOCUMENT',
  REFERENCE_SIGN_SUGGESTION = 'REFERENCE_SIGN_SUGGESTION',
  REFERENCE_SIGN_UPDATE_SUGGESTION = 'REFERENCE_SIGN_UPDATE_SUGGESTION',
  REFERENCE_SIGN_DELETE_SUGGESTION = 'REFERENCE_SIGN_DELETE_SUGGESTION',
  SEQUENCE_SUGGESTION = 'SEQUENCE_SUGGESTION',
  PUBLICATION_HIGHLIGHT = 'PUBLICATION_HIGHLIGHT',
  CHART = 'CHART',
  ALIGNMENT = 'ALIGNMENT',
  TABLE = 'TABLE',
  TABLE_UPDATE = 'TABLE_UPDATE',
  DATA_TABLE_CHART = 'DATA_TABLE_CHART',
  DOSSIER_SEARCH = 'DOSSIER_SEARCH',
  EDIT_FORM_FIELD = 'EDIT_FORM_FIELD',
}

export type BooleanFieldAggregate = {
  definition: CustomFieldDefinition;
  /**
   * The type the field belongs to. RESOURCE_FOLDER fields count each project under the value of the folder it is filed in.
   */
  resourceType: ResourceType;
  /**
   * Projects counted: those of `resourceType`, or every project for a RESOURCE_FOLDER field.
   */
  population: number;
  /**
   * How many of `population` have a value.
   */
  filled: number;
  type: 'boolean';
  trueCount: number;
  falseCount: number;
};

export type BooleanFieldType = {
  type: 'boolean';
};

export type BooleanFieldValue = {
  type: 'boolean';
  value?: boolean;
};

export type BooleanFormField = {
  type: 'boolean';
  key: string;
  label: string;
  description?: string;
  placeholder?: string;
  required: boolean;
  requiredWhen?: FormCondition;
  visibleWhen?: FormCondition;
  prefill?: AiPrefill;
};

export type BooleanSetting = Omit<AdminSetting, 'type'> & {
  type: 'boolean';
} & {
  type: 'boolean';
  default: boolean;
  orgOverride?: boolean;
  userOverrides?: {
    [key: string]: unknown;
  };
};

export type BooleanSettingUpdate = Omit<AdminSettingUpdate, 'type'> & {
  type: 'boolean';
} & {
  type: 'boolean';
  orgOverride?: boolean;
  userOverrides?: {
    [key: string]: unknown;
  };
};

export type BooleanValue = {
  type: 'boolean';
  value: boolean;
};

export type BoundingBox = {
  pageNumber: number;
  left: number;
  top: number;
  width: number;
  height: number;
};

export type BulkObjectionRerunRequest = {
  objectionIdentityIds: Array<string>;
};

export type BulkObjectionRerunResponse = {
  failedIds: Array<string>;
  successfulIds: Array<string>;
};

export type BulkRenumberSequencesRequest = {
  seqNoIds: {
    [key: string]: unknown;
  };
};

export type CaptureSuggestionReviewsRequest = {
  events: Array<SuggestionReviewedEvent>;
};

export enum CellEmptyReason {
  NO_VALUE_FOUND = 'NO_VALUE_FOUND',
  SOURCE_UNAVAILABLE = 'SOURCE_UNAVAILABLE',
  INVALID_VALUE = 'INVALID_VALUE',
  GENERATION_FAILED = 'GENERATION_FAILED',
  UNKNOWN = 'UNKNOWN',
}

export enum CellReviewStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export type CellValue =
  | ({
      type: 'stringEnum';
    } & StringEnumCellValue)
  | ({
      type: 'integer';
    } & IntegerCellValue)
  | ({
      type: 'decimal';
    } & DecimalCellValue)
  | ({
      type: 'patent';
    } & PatentCellValue)
  | ({
      type: 'compound';
    } & CompoundCellValue)
  | ({
      type: 'file';
    } & FileCellValue)
  | ({
      type: 'richText';
    } & RichTextCellValue)
  | ({
      type: 'structList';
    } & StructListCellValue);

export type Chart = {
  title: string;
  columns: Array<ChartColumn>;
  /**
   * @deprecated
   */
  data: Array<Array<string | number | number>>;
  dataV2: Array<Array<DiscriminatedChartValue>>;
  render: ChartRender;
};

export type ChartColumn = {
  name: string;
  kind: ChartColumnKind;
};

export enum ChartColumnKind {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL',
  PERCENTAGE = 'PERCENTAGE',
  DATE = 'DATE',
  DATE_BUCKET = 'DATE_BUCKET',
}

export type ChartEvent = {
  type: 'chart';
  chart: Chart;
  chartId: string;
};

export type ChartRender =
  | ({
      type: 'PIE';
    } & ChartRenderPie)
  | ({
      type: 'BAR';
    } & ChartRenderBar)
  | ({
      type: 'LINE';
    } & ChartRenderLine);

export type ChartRenderBar = {
  type: 'BAR';
  orientation: BarOrientation;
  seriesLayout: BarSeriesLayout;
  keyColumn: string;
  valueColumn: string;
  seriesColumn?: string;
};

export type ChartRenderLine = {
  type: 'LINE';
  keyColumn: string;
  valueColumn: string;
  seriesColumn?: string;
};

export type ChartRenderPie = {
  type: 'PIE';
  keyColumn: string;
  valueColumn: string;
};

export type ChatAlignment = {
  molType: AlignmentMolType;
  details: AlignmentDetails;
  hits: Array<AlignmentHit>;
  consensus?: string;
};

export type ChatDocumentCreationDetails = {
  type: 'documentCreation';
  documentName: string;
  createdDocumentId?: string;
};

export type ChatEvent =
  | ({
      type: 'blockStart';
    } & BlockStart)
  | ({
      type: 'blockStop';
    } & BlockStop)
  | ({
      type: 'context';
    } & Context)
  | ({
      type: 'textContent';
    } & TextContent)
  | ({
      type: 'citation';
    } & Citation)
  | ({
      type: 'compound';
    } & Compound)
  | ({
      type: 'knowledgeSuggestion';
    } & KnowledgeSuggestionEvent)
  | ({
      type: 'searchSuggestion';
    } & SearchSuggestionEvent)
  | ({
      type: 'figureDiagramSuggestion';
    } & FigureDiagramSuggestionEvent)
  | ({
      type: 'sequence';
    } & Sequence)
  | ({
      type: 'resuming';
    } & Resuming)
  | ({
      type: 'contextDocuments';
    } & ContextDocument)
  | ({
      type: 'contextKnowledge';
    } & ContextKnowledge)
  | ({
      type: 'contextSkills';
    } & ContextSkills)
  | ({
      type: 'contextDataTables';
    } & ContextDataTables)
  | ({
      type: 'contextCompounds';
    } & ContextCompounds)
  | ({
      type: 'contextSequences';
    } & ContextSequences)
  | ({
      type: 'action';
    } & Action)
  | ({
      type: 'suggestedPrompts';
    } & SuggestedPrompts)
  | ({
      type: 'referenceSignSuggestion';
    } & ReferenceSignSuggestion)
  | ({
      type: 'referenceSignUpdateSuggestion';
    } & ReferenceSignUpdateSuggestion)
  | ({
      type: 'referenceSignDeleteSuggestion';
    } & ReferenceSignDeleteSuggestion)
  | ({
      type: 'sourceRange';
    } & SourceRange)
  | ({
      type: 'publicationHighlight';
    } & PublicationHighlight)
  | ({
      type: 'dossierSearch';
    } & DossierSearch)
  | ({
      type: 'chart';
    } & ChartEvent)
  | ({
      type: 'thinkingStatus';
    } & ThinkingStatus)
  | ({
      type: 'alignment';
    } & SequenceAlignment)
  | ({
      type: 'tableRows';
    } & TableRowsEvent)
  | ({
      type: 'error';
    } & Error)
  | ({
      type: 'contextV2';
    } & ContextEvent)
  | ({
      type: 'citationV2';
    } & CitationEvent)
  | ({
      type: 'tableColumnAdded';
    } & TableColumnAddedEvent)
  | ({
      type: 'tableRowsUpdated';
    } & TableRowsReplacedEvent)
  | ({
      type: 'tableRowsAdded';
    } & TableRowsAddedEvent)
  | ({
      type: 'dataTableChart';
    } & DataTableChartEvent)
  | ({
      type: 'messagesStored';
    } & MessagesStored)
  | ({
      type: 'patentExtraction';
    } & PatentExtractionEvent)
  | ({
      type: 'formFieldValue';
    } & FormFieldValueEvent);

export type ChatExternalFileDetails = {
  type: 'externalFile';
  cardStatus: ExternalFileSuggestionCardStatus;
  sourceId: string;
  sourceType: ExternalSourceType;
  files: Array<SuggestedExternalFile>;
  importedFileIds: Array<string>;
};

export type ChatMessageInfo =
  | ({
      type: 'assistant';
    } & AssistantChatMessageInfo)
  | ({
      type: 'user';
    } & UserChatMessageInfo);

export enum ChatMode {
  DOCUMENT_CREATION = 'DOCUMENT_CREATION',
  CASE_LAW = 'CASE_LAW',
}

export type ChatRequest = {
  prompt: ChatRequestPrompt;
  /**
   * @deprecated
   */
  snippet?: string;
  snippetContext?: SnippetContext;
  highlightedSection?: HighlightedSection;
  highlightedDocumentPortion?: string;
  patentIntelligenceContext?: PatentIntelligenceContext;
  publicationTrackerContext?: PublicationTrackerContext;
  shouldFilterProcessingFiles?: boolean;
  sourceKindsForDiff?: Array<SourceRangeKind>;
  promptOverrides?: Array<PromptOverride>;
  documentContentOverrides?: Array<DocumentContentOverride>;
  additionalDocuments?: Array<AdditionalDocument>;
  archiveChatHistoryCheckpointId?: string;
  userContext?: Array<UserContext>;
};

export type ChatRequestPrompt =
  | ({
      type: 'userPrompt';
    } & UserPrompt)
  | ({
      type: 'linkedResource';
    } & LinkedResourcePrompt)
  | ({
      type: 'multiLinkedResource';
    } & MultiLinkedResourcePrompt)
  | ({
      type: 'endpoint';
    } & EndpointPrompt)
  | ({
      type: 'endpointWithLinkedResources';
    } & EndpointWithLinkedResourcesPrompt);

export type ChatSuggestion = {
  suggestionId: string;
  suggestionType: ChatSuggestionType;
  status: ChatSuggestionStatus;
  details: ChatSuggestionDetails;
};

export enum ChatSuggestionDecision {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
}

export type ChatSuggestionDetails =
  | ({
      type: 'documentCreation';
    } & ChatDocumentCreationDetails)
  | ({
      type: 'externalFile';
    } & ChatExternalFileDetails);

export type ChatSuggestionReviewPayload =
  | ({
      type: 'documentCreation';
    } & DocumentCreationReviewPayload)
  | ({
      type: 'externalFile';
    } & ExternalFileReviewPayload);

export type ChatSuggestionReviewResult =
  | ({
      type: 'documentCreation';
    } & DocumentCreationReviewResult)
  | ({
      type: 'externalFile';
    } & ExternalFileReviewResult);

export enum ChatSuggestionStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export enum ChatSuggestionType {
  DOCUMENT_CREATION = 'DOCUMENT_CREATION',
  EXTERNAL_FILE = 'EXTERNAL_FILE',
}

export type CheckActiveMessageResponse = {
  messages: Array<ActiveMessage>;
};

export enum ChemicalExportType {
  CML = 'CML',
  CDX = 'CDX',
}

/**
 * Chemical drafting. No settings of its own yet.
 */
export type ChemicalPatentDraftSettings = {
  [key: string]: unknown;
};

export enum ChemistryIdentifierType {
  SMILES = 'SMILES',
  INCHIKEY = 'INCHIKEY',
}

export type Citation = {
  type: 'citation';
  citation: AssistantChatMessageCitation;
};

export type CitationCompound = {
  id: string;
  smiles?: string;
  alias: string;
  isDeleted: boolean;
  status?: CompoundStatus;
};

export type CitationDetails = {
  info: CitationInfo;
  citation: CitationV2;
};

export type CitationEvent = {
  type: 'citationV2';
  citation: CitationDetails;
};

export type CitationFile = {
  fileId: string;
  fileName: string;
  fileType: CitationFileType;
  isArchived: boolean;
};

export enum CitationFileType {
  PDF = 'PDF',
  DOCX = 'DOCX',
  PPTX = 'PPTX',
  IMAGE = 'IMAGE',
  CAD = 'CAD',
}

export type CitationInfo = {
  id: string;
  title: string;
  isDeleted: boolean;
};

export type CitationSequence = {
  id: string;
  seqNoId: number;
  name: string;
  isDeleted: boolean;
};

export type CitationV2 = {
  id: string;
  /**
   * Discriminator property for CitationV2.
   */
  type: string;
};

export type ColumnMolTypeSelector = {
  type: 'column';
  columnIndex: number;
};

export type ColumnOrganismSelector = {
  type: 'column';
  columnIndex: number;
};

export type ColumnOrientationSelector = {
  type: 'column';
  columnIndex: number;
};

export type ColumnSource =
  | ({
      type: 'manual';
    } & ManualColumnSource)
  | ({
      type: 'aiAutoFill';
    } & AiAutofillColumnSource)
  | ({
      type: 'searchFeature';
    } & SearchFeatureColumnSource);

export type ColumnType =
  | ({
      type: 'string';
    } & StringColumnType)
  | ({
      type: 'stringEnum';
    } & StringEnumColumnType)
  | ({
      type: 'integer';
    } & IntegerColumnType)
  | ({
      type: 'decimal';
    } & DecimalColumnType)
  | ({
      type: 'patent';
    } & PatentColumnType)
  | ({
      type: 'compound';
    } & CompoundColumnType)
  | ({
      type: 'file';
    } & FileColumnType)
  | ({
      type: 'structList';
    } & StructListColumnType);

export type CombinedAnswerExportValue = {
  type: 'combined_answer';
  keys: Array<string>;
  separator: string;
  fieldId: string;
};

export type CompleteDocxUploadRequest = {
  key: string;
};

export type ComposePromptPreviewRequest =
  | ({
      workflow: 'drafting';
    } & DraftingComposePromptPreviewRequest)
  | ({
      workflow: 'office_actions';
    } & OfficeActionsComposePromptPreviewRequest)
  | ({
      workflow: 'project';
    } & ProjectComposePromptPreviewRequest);

export type ComposePromptPreviewResponse = {
  systemPrompt?: string;
  skills: Array<ComposePromptPreviewSkill>;
};

export type ComposePromptPreviewSkill = {
  name: string;
  description: string;
};

export type Compound = {
  type: 'compound';
  compound: AssistantChatMessageCompound;
};

export type CompoundCellInfo = {
  compoundId: string;
  compoundAlias?: string;
};

export type CompoundCellValue = {
  type: 'compound';
  value?: CompoundCellInfo;
  isUnresolved?: boolean;
};

export type CompoundCitation = Omit<CitationV2, 'type'> & {
  type: 'compound';
} & {
  type: 'compound';
  highlightAtomIndices: Array<number>;
  highlightBondIndices: Array<number>;
};

export type CompoundColumnType = {
  type: 'compound';
};

export type CompoundImportInfo = {
  id: string;
  alias: string;
  description?: string;
  smiles?: string;
  molStructure?: string;
  sourceCdxml?: string;
};

export type CompoundInfo = {
  id: string;
  smiles: string;
  source: CompoundSource;
  molStructure?: string;
  imageFileId?: string;
  compoundName?: string;
  compoundAlias: string;
  description: string;
  status?: CompoundStatus;
  sourceCdxml?: string;
};

export enum CompoundSource {
  USER = 'USER',
  GENERATED = 'GENERATED',
}

export enum CompoundStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export type ConstantExportValue = {
  type: 'constant';
  fieldId: string;
  value: ConstantValue;
};

export type ConstantValue =
  | ({
      type: 'text';
    } & TextValue)
  | ({
      type: 'date';
    } & DateValue)
  | ({
      type: 'integer';
    } & IntegerValue)
  | ({
      type: 'boolean';
    } & BooleanValue)
  | ({
      type: 'options';
    } & OptionsValue)
  | ({
      type: 'users';
    } & UsersValue);

export type ContainerConnectionSpec = {
  type: 'container';
  sourceId: string;
  containerId: string;
};

export type Context = {
  type: 'context';
  contextFiles: Array<AssistantContextFile>;
};

export type ContextCompounds = {
  type: 'contextCompounds';
  contextCompounds: Array<AssistantChatMessageCompound>;
};

export type ContextDataTables = {
  type: 'contextDataTables';
  contextDataTables: Array<DataTableInfo>;
};

export type ContextDocument = {
  type: 'contextDocuments';
  contextDocuments: Array<EditableDocumentInfo>;
};

export type ContextEvent = {
  type: 'contextV2';
  context: AssistantContext;
};

export enum ContextFileType {
  STATIC_FILE = 'STATIC_FILE',
  CASE_FILE = 'CASE_FILE',
  IMAGE = 'IMAGE',
}

export type ContextKnowledge = {
  type: 'contextKnowledge';
  contextKnowledge: Array<KnowledgeInfo>;
};

export type ContextSequences = {
  type: 'contextSequences';
  contextSequences: Array<CitationSequence>;
};

export type ContextSkills = {
  type: 'contextSkills';
  skillIds: Array<string>;
};

export type ConvertChemdrawUploadRequest = {
  fileName: string;
  file: unknown;
  mergeFragments?: boolean;
};

export type CreateAdminCustomFieldsRequest = {
  fields: Array<AdminCustomFieldSettings>;
};

export type CreateDataTableChartRequest = {
  chartSpec: DataTableChartSpec;
  filterSpec?: DataTableChartFilterSpec;
};

export type CreateDataTableRequest = {
  name: string;
  resourceId: string;
  resourceType: ResourceType;
  columns: Array<DataTableSchemaColumn>;
  rows: Array<CreateDataTableRow>;
  templateId?: string;
};

export type CreateDataTableResponse = {
  table: DataTable;
};

export type CreateDataTableRow = {
  cells: Array<DataTableCell>;
};

export type CreateDocumentRequest = {
  name: string;
  content: string;
};

export type CreateDraftFromDisclosureRequest = {
  name: string;
  mode: DraftMode;
  jurisdiction: PatentDraftJurisdiction;
  language: PatentDraftLanguage;
  referencePatentId?: string;
};

export type CreateExternalConnectionsRequest = {
  connections: Array<ExternalConnectionSpec>;
};

export type CreateExternalSourceAuthRequest = OAuth2AuthorizationCodeAuthRequest;

export type CreateExternalSourceRequest = {
  organizationId: string;
  config: ExternalSourceConfig;
};

export type CreateFormRequest = {
  resourceType: ResourceType;
  resourceId: string;
  templateId: string;
  name: string;
};

export type CreateGeneralAssistantRequest = {
  name: string;
  folderId?: string;
};

export type CreateGeneralAssistantV2Request = {
  name: string;
  draftType?: TemplateType;
  jurisdiction?: Jurisdiction;
  language?: Language;
  folderId?: string;
  source: GeneralAssistantDraftSource;
};

export type CreateGeneralAssistantV2Response = {
  generalAssistantId: string;
  documentId?: string;
};

export type CreateInventionAssistantRequest = {
  name: string;
  language?: Language;
  folderId?: string;
};

export type CreateItemFolderRequest = {
  name: string;
  kind?: FolderKind;
};

export type CreateKnowledgeFolderRequest = {
  name: string;
  resourceType: ResourceType;
};

export type CreateKnowledgeRequest = {
  name: string;
  description: string;
  content?: string;
  referenceFileIds?: Array<string>;
  resourceType: ResourceType;
  shareWithOrg: boolean;
  forceActive?: boolean;
  currentResourceId?: string;
  folderId?: string;
};

export type CreateNoveltyAnalysisRequest = {
  fileIds?: Array<string>;
};

export type CreatePatentDraftRequest = {
  draftingMode: DraftMode;
  folderId?: string;
};

export type CreateProjectFolderRequest = {
  name: string;
};

export type CreateSequenceRequest = {
  seqNoId: number;
  name: string;
  molType: MolType;
  sequence: string;
  annotatedSequence?: string;
  featureTable: Array<SequenceFeature>;
};

export type CreateSigmaSearchRequest = {
  title: string;
  context: string;
};

export type CreateSigmaSearchResponse = {
  searchId: string;
};

export type CustomFieldAggregate =
  | ({
      type: 'text';
    } & TextFieldAggregate)
  | ({
      type: 'number';
    } & NumberFieldAggregate)
  | ({
      type: 'boolean';
    } & BooleanFieldAggregate)
  | ({
      type: 'date';
    } & DateFieldAggregate)
  | ({
      type: 'select';
    } & SelectFieldAggregate)
  | ({
      type: 'user';
    } & UserFieldAggregate);

export type CustomFieldAggregateBase = {
  definition: CustomFieldDefinition;
  /**
   * The type the field belongs to. RESOURCE_FOLDER fields count each project under the value of the folder it is filed in.
   */
  resourceType: ResourceType;
  /**
   * Projects counted: those of `resourceType`, or every project for a RESOURCE_FOLDER field.
   */
  population: number;
  /**
   * How many of `population` have a value.
   */
  filled: number;
};

export type CustomFieldDefinition = {
  fieldId: string;
  displayName: string;
  description?: string;
  fieldType: CustomFieldType;
  showInList: boolean;
};

export type CustomFieldFilter =
  | ({
      type: 'text';
    } & TextFieldFilter)
  | ({
      type: 'number';
    } & NumberFieldFilter)
  | ({
      type: 'date';
    } & DateFieldFilter)
  | ({
      type: 'select';
    } & SelectFieldFilter)
  | ({
      type: 'user';
    } & UserFieldFilter);

export type CustomFieldFilterEntry = {
  fieldId: string;
  filter: CustomFieldFilter;
};

export type CustomFieldOption = {
  key: string;
  displayValue: string;
};

export type CustomFieldType =
  | ({
      type: 'text';
    } & TextFieldType)
  | ({
      type: 'number';
    } & NumberFieldType)
  | ({
      type: 'boolean';
    } & BooleanFieldType)
  | ({
      type: 'date';
    } & DateFieldType)
  | ({
      type: 'select';
    } & SelectFieldType)
  | ({
      type: 'user';
    } & UserFieldType);

export type CustomFieldValue =
  | ({
      type: 'text';
    } & TextFieldValue)
  | ({
      type: 'number';
    } & NumberFieldValue)
  | ({
      type: 'boolean';
    } & BooleanFieldValue)
  | ({
      type: 'date';
    } & DateFieldValue)
  | ({
      type: 'select';
    } & SelectFieldValue)
  | ({
      type: 'user';
    } & UserFieldValue);

export type CustomFieldValues = {
  fields: Array<ProjectCustomField>;
};

export type DataTable = {
  id: string;
  name: string;
  resourceId: string;
  resourceType: ResourceType;
  columns: Array<DataTableSchemaColumn>;
  owner: DataTableOwner;
  lockOwner?: DataTableLockOwner;
  templateId?: string;
};

export type DataTableCell = {
  columnId: string;
  isLoading?: boolean;
  value?: CellValue;
  pendingValue?: CellValue;
  emptyReason?: CellEmptyReason;
  pendingEmptyReason?: CellEmptyReason;
};

export type DataTableCellReview = {
  rowId: string;
  columnId?: string;
  status: CellReviewStatus;
};

export type DataTableChartBarRender = {
  type: 'bar';
  orientation: BarOrientation;
  seriesLayout: BarSeriesLayout;
};

export type DataTableChartBubbleRender = {
  type: 'bubble';
  x: DataTableChartMeasure;
  y: DataTableChartMeasure;
};

export type DataTableChartColumnField = {
  type: 'column';
  columnId: string;
  columnType: ColumnType;
};

export type DataTableChartCountDistinctMeasure = {
  type: 'countDistinct';
  field: DataTableChartField;
};

export type DataTableChartDerivedField = {
  type: 'derived';
  columnId: string;
  field: DataTableChartDerivedFieldName;
};

export enum DataTableChartDerivedFieldName {
  FILING_YEAR = 'FILING_YEAR',
  PRIORITY_YEAR = 'PRIORITY_YEAR',
  PUBLICATION_YEAR = 'PUBLICATION_YEAR',
  CPC_SUBCLASS = 'CPC_SUBCLASS',
  CPC_GROUP = 'CPC_GROUP',
  FAMILY_SIZE = 'FAMILY_SIZE',
  FAMILY_SIZE_BAND = 'FAMILY_SIZE_BAND',
  ASSIGNEE_GROUP = 'ASSIGNEE_GROUP',
}

export type DataTableChartDetail = {
  chartId: string;
  tableId: string;
  position: number;
  origin: DataTableChartOrigin;
  chartSpec: DataTableChartSpec;
  filterSpec?: DataTableChartFilterSpec;
  result?: DataTableChartResult;
  refreshedAt?: string;
  pending?: DataTableChartDetail;
  warnings: Array<DataTableChartWarning>;
  error?: DataTableChartError;
};

export type DataTableChartDimension = {
  field: DataTableChartField;
  sort: DataTableChartDimensionSort;
  topN?: number;
  groupRemainderAsOther: boolean;
};

export type DataTableChartDimensionSort =
  | ({
      type: 'measure';
    } & DataTableChartMeasureSort)
  | ({
      type: 'label';
    } & DataTableChartLabelSort)
  | ({
      type: 'seriesValue';
    } & DataTableChartSeriesValueSort);

export type DataTableChartError = {
  code: DataTableChartErrorCode;
  message?: string;
};

export enum DataTableChartErrorCode {
  TIMEOUT = 'TIMEOUT',
  TOO_MANY_VALUES = 'TOO_MANY_VALUES',
  AGGREGATION_FAILED = 'AGGREGATION_FAILED',
}

export type DataTableChartEvent = {
  type: 'dataTableChart';
  chartId: string;
  tableId: string;
  chartSpec: DataTableChartSpec;
  filterSpec?: DataTableChartFilterSpec;
  result: DataTableChartResult;
};

export type DataTableChartField =
  | ({
      type: 'column';
    } & DataTableChartColumnField)
  | ({
      type: 'patent';
    } & DataTableChartPatentField)
  | ({
      type: 'derived';
    } & DataTableChartDerivedField);

export type DataTableChartFilterSpec = {
  filters: Array<DataTableFilter>;
};

export type DataTableChartHeatMapRender = {
  type: 'heatMap';
  bubbles?: boolean;
};

export type DataTableChartLabelSort = {
  type: 'label';
  order: SortOrder;
};

export type DataTableChartLineRender = {
  type: 'line';
};

export type DataTableChartMeasure =
  | ({
      type: 'patentCount';
    } & DataTableChartPatentCountMeasure)
  | ({
      type: 'countDistinct';
    } & DataTableChartCountDistinctMeasure);

export type DataTableChartMeasureSort = {
  type: 'measure';
  order: SortOrder;
};

export enum DataTableChartOrigin {
  GENERATE = 'GENERATE',
  CHAT = 'CHAT',
}

export type DataTableChartPatentCountMeasure = {
  type: 'patentCount';
};

export type DataTableChartPatentField = {
  type: 'patent';
  columnId: string;
  field: DataTableChartPatentFieldName;
};

export enum DataTableChartPatentFieldName {
  ASSIGNEE = 'ASSIGNEE',
  JURISDICTION = 'JURISDICTION',
  LEGAL_STATUS = 'LEGAL_STATUS',
}

export type DataTableChartPieRender = {
  type: 'pie';
};

export type DataTableChartRender =
  | ({
      type: 'pie';
    } & DataTableChartPieRender)
  | ({
      type: 'bar';
    } & DataTableChartBarRender)
  | ({
      type: 'line';
    } & DataTableChartLineRender)
  | ({
      type: 'heatMap';
    } & DataTableChartHeatMapRender)
  | ({
      type: 'bubble';
    } & DataTableChartBubbleRender)
  | ({
      type: 'treemap';
    } & DataTableChartTreemapRender);

export type DataTableChartResult = {
  dimensions: Array<DataTableChartResultColumn>;
  measures: Array<DataTableChartResultColumn>;
  rows: Array<DataTableChartResultRow>;
};

export type DataTableChartResultColumn = {
  key: string;
  label: string;
  kind: DataTableChartValueKind;
};

export type DataTableChartResultRow = {
  keys: Array<string>;
  values: Array<number>;
};

export enum DataTableChartReviewAction {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
}

export type DataTableChartSeriesValueSort = {
  type: 'seriesValue';
  order: SortOrder;
  seriesKey: string;
};

export type DataTableChartSpec = {
  title: string;
  dimensions: Array<DataTableChartDimension>;
  measure: DataTableChartMeasure;
  render: DataTableChartRender;
};

export type DataTableChartSummary = {
  chartId: string;
  tableId: string;
  position: number;
  origin: DataTableChartOrigin;
  chartSpec: DataTableChartSpec;
  filterSpec?: DataTableChartFilterSpec;
  pendingChartId?: string;
};

export type DataTableChartTreemapRender = {
  type: 'treemap';
};

export enum DataTableChartValueKind {
  LABEL = 'LABEL',
  COUNT = 'COUNT',
  DECIMAL = 'DECIMAL',
  PERCENTAGE = 'PERCENTAGE',
  YEAR = 'YEAR',
}

export type DataTableChartWarning = {
  code: DataTableChartWarningCode;
  columnId: string;
};

export enum DataTableChartWarningCode {
  COLUMN_DELETED = 'COLUMN_DELETED',
  COLUMN_TYPE_CHANGED = 'COLUMN_TYPE_CHANGED',
}

export type DataTableColumnReview = {
  columnId: string;
  status: CellReviewStatus;
};

export enum DataTableExportFormat {
  CSV = 'CSV',
  XLSX = 'XLSX',
}

export type DataTableFilter =
  | ({
      type: 'string';
    } & StringColumnFilter)
  | ({
      type: 'integer';
    } & IntegerColumnFilter)
  | ({
      type: 'decimal';
    } & DecimalColumnFilter)
  | ({
      type: 'stringEnum';
    } & StringEnumColumnFilter)
  | ({
      type: 'patent';
    } & PatentColumnFilter);

export type DataTableImportColumnMapping = {
  sourceIndex: number;
  displayName: string;
  columnType: ColumnType;
};

export type DataTableImportColumnPreview = {
  sourceIndex: number;
  header: string;
  sampleValues: Array<string>;
  suggestedType?: ColumnType;
};

export type DataTableImportFileRange = {
  temporaryFileId: string;
  range?: string;
  headerRow?: number;
  skipRows?: Array<number>;
  skipColumns?: Array<string>;
};

export type DataTableImportPreviewRequest = {
  /**
   * @deprecated
   */
  temporaryFileIds?: Array<string>;
  /**
   * @deprecated
   */
  temporaryFileId?: string;
  resourceId: string;
  resourceType: ResourceType;
  ranges?: Array<DataTableImportFileRange>;
};

export type DataTableImportPreviewResponse = {
  totalRowCount: number;
  columns: Array<DataTableImportColumnPreview>;
  ignoredHeaders: Array<string>;
};

export type DataTableInfo = {
  tableId: string;
  name: string;
  isDeleted: boolean;
};

export enum DataTableLockOwner {
  IN_REVIEW = 'IN_REVIEW',
}

export enum DataTableOwner {
  USER = 'USER',
  CHAT = 'CHAT',
  NOVELTY_ANALYSIS = 'NOVELTY_ANALYSIS',
  SIGMA_SEARCH = 'SIGMA_SEARCH',
}

export enum DataTablePatentDataField {
  ASSIGNEE = 'assignee',
  LEGAL_STATUS = 'legalStatus',
  FILING_YEAR = 'filingYear',
  PRIORITY_YEAR = 'priorityYear',
  PUBLICATION_YEAR = 'publicationYear',
  CPC_SUBCLASS = 'cpcSubclass',
  CPC_GROUP = 'cpcGroup',
}

export type DataTablePatentFieldValue = {
  value: string;
  patentCount: number;
};

export type DataTableRow = {
  rowId: string;
  cells: Array<DataTableCell>;
  isPending?: boolean;
};

export type DataTableRowImportMapping = {
  sourceIndex: number;
  columnId: string;
};

export type DataTableRowUserContext = {
  type: 'dataTableRow';
  rowIds: Array<string>;
};

export type DataTableSchemaColumn = {
  columnId: string;
  displayName: string;
  returnedByDefault: boolean;
  columnType: ColumnType;
  source: ColumnSource;
  isPending?: boolean;
};

export type DataTableSchemaUpdate = {
  columns: Array<DataTableSchemaColumn>;
};

export type DataTableSort = {
  columnId: string;
  order: SortOrder;
};

export type DataTableSummary = {
  id: string;
  name: string;
  rowCount: number;
  columnCount: number;
  owner: DataTableOwner;
};

export type DateFieldAggregate = {
  definition: CustomFieldDefinition;
  /**
   * The type the field belongs to. RESOURCE_FOLDER fields count each project under the value of the folder it is filed in.
   */
  resourceType: ResourceType;
  /**
   * Projects counted: those of `resourceType`, or every project for a RESOURCE_FOLDER field.
   */
  population: number;
  /**
   * How many of `population` have a value.
   */
  filled: number;
  type: 'date';
  months: Array<ProjectAnalyticsMonthCount>;
};

export type DateFieldFilter = {
  type: 'date';
  from?: string;
  to?: string;
};

export type DateFieldType = {
  type: 'date';
};

export type DateFieldValue = {
  type: 'date';
  value?: string;
};

export type DateFormField = {
  type: 'date';
  key: string;
  label: string;
  description?: string;
  placeholder?: string;
  required: boolean;
  requiredWhen?: FormCondition;
  visibleWhen?: FormCondition;
  prefill?: AiPrefill;
};

export type DateValue = {
  type: 'date';
  value: string;
};

export type DecimalCellValue = {
  type: 'decimal';
  value?: string;
};

export type DecimalColumnFilter = {
  type: 'decimal';
  columnId: string;
  operator: NumericalFilterOperator;
  value?: string;
};

export type DecimalColumnType = {
  type: 'decimal';
  unit?: string;
};

export type DeclinedPatentSuggestion = {
  patentExtractionItemId: string;
  status: 'DECLINED';
};

export type DeleteCompoundsRequest = {
  compoundIds: Array<string>;
};

export type DeleteObjectionStatusRequest = {
  objectionIds: Array<string>;
};

export type DeleteProjectsRequest = {
  projects: Array<ProjectRef>;
};

export type DeleteSequencesRequest = {
  sequenceIds: Array<string>;
};

export type DetectDataTableImportTablesRequest = {
  temporaryFileId: string;
  resourceId: string;
  resourceType: ResourceType;
};

export type DetectDataTableImportTablesResponse = {
  tables: Array<DetectedDataTableImportTable>;
};

export type DetectedDataTableImportTable = {
  range: string;
  headerRow: number;
  skipRows: Array<number>;
  skipColumns: Array<string>;
  suggestedName?: string;
  headers: Array<string>;
  rowCount: number;
};

export type DeveloperPromptFile = {
  kind: PromptOverrideKind;
  path: string;
  content: string;
  overridable: boolean;
};

export type DeveloperPromptFilesResponse = {
  promptFiles: Array<DeveloperPromptFile>;
};

export type DeveloperPromptOverride = {
  kind: PromptOverrideKind;
  path: string;
  content: string;
  createdBy: string;
  updatedAt: Instant;
};

export type DeveloperPromptOverridesResponse = {
  overrides: Array<DeveloperPromptOverride>;
};

export type DiscriminatedChartValue =
  | ({
      type: 'string';
    } & StringChartValue)
  | ({
      type: 'int';
    } & IntChartValue)
  | ({
      type: 'float';
    } & FloatChartValue);

export enum DisplayColour {
  RED = 'RED',
  AMBER = 'AMBER',
  GREEN = 'GREEN',
  BLUE = 'BLUE',
  BLUE_STRONG = 'BLUE_STRONG',
  BLUE_SOFT = 'BLUE_SOFT',
  GREY = 'GREY',
}

export type Document = {
  id: string;
  created: string;
  sections: Array<DocumentSection>;
  name: string;
  isMigrated: boolean;
  content?: string;
};

export type DocumentComment = {
  id: number;
  author: string;
  createdDate?: string;
  text: string;
  resolved: boolean;
  replies?: Array<DocumentComment>;
};

export type DocumentContentOverride = {
  storedDocumentId: string;
  content: string;
  comments?: Array<DocumentComment>;
};

export enum DocumentCreationEventStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export type DocumentCreationRequired = {
  type: 'documentCreationRequired';
  documentCreationEventId: string;
  documentType: OfficeActionDocumentType;
  status: DocumentCreationEventStatus;
};

export enum DocumentCreationReviewAction {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
}

export type DocumentCreationReviewPayload = {
  type: 'documentCreation';
  name: string;
  content: string;
  templateId?: string;
};

export type DocumentCreationReviewResult = {
  type: 'documentCreation';
};

export type DocumentEdit = {
  info: EditableDocumentInfo;
  editType: EditType;
  text: string;
  type: 'document';
};

export type DocumentEditFields = {
  info: EditableDocumentInfo;
  editType: EditType;
  text: string;
};

export type DocumentEditLocation = {
  type: 'document';
  documentId: string;
  documentName: string;
  editType: EditType;
};

export type DocumentSection = {
  id: string;
  position: number;
  sectionRef: string;
  heading?: string;
  content?: string;
  required: boolean;
};

export type DocumentSelectionUserContext = {
  type: 'document';
  documentId: string;
  highlightedContent?: string;
};

export type DocxRef = {
  updatedAt: string;
  presignedUrl: PresignedUrl;
};

export type DocxUploadUrl = {
  key: string;
  uploadUrl: PresignedUrl;
};

export type DossierExternalSourceAuthConfig = {
  type: 'dossier';
};

export type DossierExternalSourceInfo = {
  type: 'dossier';
  patentOfficeCode: PatentOfficeCode;
};

export type DossierSearch = {
  type: 'dossierSearch';
  dossier: DossierSource;
  applicationReference: string;
  recommendedDocumentIds: Array<string>;
};

export enum DossierSource {
  EPO = 'EPO',
  USPTO = 'USPTO',
}

export type DraftContentOverridable = {
  contentOverride?: string;
};

export type DraftFromBlank = {
  type: 'blank';
};

export type DraftFromTemplate = {
  type: 'template';
};

export type DraftFromUpload = {
  type: 'upload';
  fileName: string;
  content: string;
};

export enum DraftMode {
  MECHANICAL_PATENT = 'MECHANICAL_PATENT',
  CHEMICAL_PATENT = 'CHEMICAL_PATENT',
  PATENT = 'PATENT',
  DISCLOSURE = 'DISCLOSURE',
  OFFICE_ACTION_RESPONSE_LETTER = 'OFFICE_ACTION_RESPONSE_LETTER',
  OFFICE_ACTION_CLIENT_RESPONSE_LETTER = 'OFFICE_ACTION_CLIENT_RESPONSE_LETTER',
  OFFICE_ACTION_STRATEGY_DOCUMENT = 'OFFICE_ACTION_STRATEGY_DOCUMENT',
  OFFICE_ACTION_FOREIGN_ATTORNEY_INSTRUCTIONS = 'OFFICE_ACTION_FOREIGN_ATTORNEY_INSTRUCTIONS',
  OFFICE_ACTION_CLAIM_DOCUMENT = 'OFFICE_ACTION_CLAIM_DOCUMENT',
  OFFICE_ACTION_DESCRIPTION_DOCUMENT = 'OFFICE_ACTION_DESCRIPTION_DOCUMENT',
}

export type DraftingComposePromptPreviewRequest = {
  workflow: 'drafting';
  draftingMode: DraftMode;
  jurisdiction: PatentDraftJurisdiction;
  language: PatentDraftLanguage;
  overrides: Array<PromptOverride>;
};

export type DrawioFigureMetadata = {
  type: 'drawio';
  xml: string;
};

export type DrawioReferenceSignPlacement = {
  referenceSignId: string;
  label: string;
  left: number;
  top: number;
  width: number;
  height: number;
  tipX: number;
  tipY: number;
  curvature: number;
  arrowHead: ReferenceSignArrowHead;
};

export type DrawioReferenceSignPlacements = {
  type: 'drawio';
  placements: Array<DrawioReferenceSignPlacement>;
};

export type EditLocation =
  | ({
      type: 'document';
    } & DocumentEditLocation)
  | ({
      type: 'tag';
    } & TagEditLocation)
  | ({
      type: 'tag_range';
    } & TagRangeEditLocation);

export type EditReferenceSignRequest = {
  referenceSignId: string;
  label: string;
  value: string;
};

export enum EditType {
  UPDATE = 'UPDATE',
  INSERT = 'INSERT',
  DELETE = 'DELETE',
}

export type EditableDocument =
  | ({
      type: 'document';
    } & DocumentEdit)
  | ({
      type: 'tag';
    } & TagEdit)
  | ({
      type: 'tag_range';
    } & TagRangeEdit);

export type EditableDocumentInfo = {
  documentId: string;
  documentName: string;
};

export type EffectiveAccessRequest = {
  userIds: Array<string>;
};

export type EffectiveAccessResponse = {
  access: Array<UserAccess>;
};

export type EndpointPrompt = {
  type: 'endpoint';
  promptId: string;
};

export type EndpointWithLinkedResourcesPrompt = {
  type: 'endpointWithLinkedResources';
  promptId: string;
  linkedResourceType: LinkedResourceType;
  linkedResourceIds: Array<string>;
};

export type EqFormCondition = {
  op: 'eq';
  key: string;
  value: FormConditionValue;
};

export type Error = {
  type: 'error';
  code: string;
  details?: string;
};

export type ExportCompoundsRequest = {
  compoundIds: Array<string>;
  type: ChemicalExportType;
};

export type ExportCompoundsResponse = {
  result: {
    [key: string]: unknown;
  };
};

export type ExportDocxContentItem = {
  type: 'content';
  fileIndex: number;
  fileName: string;
};

export type ExportDraftResponse = {
  fileUrl: PresignedUrl;
};

export type ExportExternalSourceItemResult =
  | ({
      status: 'exported';
    } & ExternalSourceItemExportSuccess)
  | ({
      status: 'failed';
    } & ExternalSourceItemExportFailure);

export type ExportExternalSourceItemsMultipartRequest = {
  export: ExportExternalSourceItemsRequest;
  files?: Array<unknown>;
};

export type ExportExternalSourceItemsRequest = {
  sourceId: string;
  destinationId: string;
  overwrite?: boolean;
  items: Array<ExportItem>;
};

export type ExportExternalSourceItemsResponse = {
  results: Array<ExportExternalSourceItemResult>;
};

/**
 * @deprecated
 */
export type ExportFigureToVisioRequest = {
  figureId?: string;
  currentTempFileId?: string;
  annotationState: {
    [key: string]: unknown;
  };
};

export type ExportFigureToVisioRequestV2 = {
  figureId?: string;
  currentTempFileId?: string;
  metadata: FigureMetadata;
};

export type ExportFigureToVisioResponse = {
  visioFileUrl: PresignedUrl;
};

export type ExportFormResponse = {
  caseReference: string;
  caseStatus: string;
  files: Array<FormExportFileResult>;
};

export type ExportItem = ExportDocxContentItem;

export enum ExportUserSource {
  PROJECT_OWNER = 'PROJECT_OWNER',
}

export type ExternalConnection = {
  id: string;
  sourceId: string;
  containerId: string;
  displayName: string;
  displayPath?: string;
  writable: boolean;
};

export type ExternalConnectionSpec =
  | ({
      type: 'container';
    } & ContainerConnectionSpec)
  | ({
      type: 'patentOffice';
    } & PatentOfficeConnectionSpec);

export type ExternalFileReviewPayload = {
  type: 'externalFile';
  folderId?: string;
  patentDraftFileType?: PatentDraftFileType;
  files: Array<ExternalSourceFileSpec>;
};

export type ExternalFileReviewResult = {
  type: 'externalFile';
  importResults: Array<ImportExternalSourceFileResult>;
};

export type ExternalFileSuggestion = {
  type: 'externalFileSuggestion';
  suggestion: ChatSuggestion;
};

export enum ExternalFileSuggestionCardStatus {
  OK = 'OK',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  NO_CONNECTIONS = 'NO_CONNECTIONS',
}

export type ExternalSource = {
  id: string;
  disabled: boolean;
  authConfig: ExternalSourceAuthConfig;
  sourceInfo?: ExternalSourceInfo;
};

export enum ExternalSourceAccessLevel {
  READ = 'READ',
  READ_WRITE = 'READ_WRITE',
}

export type ExternalSourceAuthConfig =
  | ({
      type: 'sharepoint';
    } & SharepointExternalSourceAuthConfig)
  | ({
      type: 'dossier';
    } & DossierExternalSourceAuthConfig)
  | ({
      type: 'anaqua';
    } & AnaquaExternalSourceAuthConfig);

export enum ExternalSourceAuthStatus {
  CONNECTED = 'CONNECTED',
  NEEDS_SIGN_IN = 'NEEDS_SIGN_IN',
  NOT_REQUIRED = 'NOT_REQUIRED',
}

export type ExternalSourceConfig =
  | ({
      type: 'sharepoint';
    } & SharepointExternalSourceConfig)
  | ({
      type: 'anaqua';
    } & AnaquaExternalSourceConfig);

export type ExternalSourceContainerItem = {
  type: 'container';
  id: string;
  name: string;
  childCount?: number;
  writable: boolean;
};

export type ExternalSourceCredentials = ApiKeyExternalSourceCredentials;

export type ExternalSourceDetails = {
  source: ExternalSource;
  config: ExternalSourceConfig;
};

export enum ExternalSourceFileImportErrorCode {
  TOO_LARGE = 'TOO_LARGE',
  UNSUPPORTED_TYPE = 'UNSUPPORTED_TYPE',
  NOT_FOUND = 'NOT_FOUND',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  INVALID_FILE = 'INVALID_FILE',
  UNKNOWN = 'UNKNOWN',
}

export type ExternalSourceFileImportFailure = {
  status: 'failed';
  fileId: string;
  errorCode: ExternalSourceFileImportErrorCode;
};

export type ExternalSourceFileImportSuccess = {
  status: 'imported';
  fileId: string;
  importedFileId: string;
};

export type ExternalSourceFileItem = {
  type: 'file';
  id: string;
  name: string;
  size: number;
  mimeType: string;
  modifiedAt: Instant;
};

export type ExternalSourceFileSpec = {
  sourceId: string;
  fileId: string;
};

export type ExternalSourceInfo = DossierExternalSourceInfo;

export type ExternalSourceItem =
  | ({
      type: 'file';
    } & ExternalSourceFileItem)
  | ({
      type: 'container';
    } & ExternalSourceContainerItem);

export enum ExternalSourceItemExportErrorCode {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  TOO_LARGE = 'TOO_LARGE',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  INVALID_NAME = 'INVALID_NAME',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN',
}

export type ExternalSourceItemExportFailure = {
  status: 'failed';
  item: ExportItem;
  errorCode: ExternalSourceItemExportErrorCode;
};

export type ExternalSourceItemExportSuccess = {
  status: 'exported';
  item: ExportItem;
  exportedFile: ExternalSourceFileItem;
};

export enum ExternalSourceItemType {
  CONTAINER = 'CONTAINER',
  FILE = 'FILE',
}

export type ExternalSourceSearchResult = {
  item: ExternalSourceItem;
  parentId?: string;
  displayPath?: string;
};

export type ExternalSourceStatus = {
  source: ExternalSource;
  status: ExternalSourceAuthStatus;
};

export enum ExternalSourceType {
  SHAREPOINT = 'SHAREPOINT',
}

export type ExtractCompoundsFromDocxResponse = {
  compounds: Array<ExtractedCompound>;
};

export type ExtractPatentFromFileRequest = {
  fileIds: Array<string>;
};

export type ExtractPatentFromFileResponse = {
  succeeded: Array<PatentInfo>;
  failed: Array<string>;
};

export type ExtractSpreadsheetResponse = {
  descriptions: Array<SheetDescription>;
  sheets: {
    [key: string]: unknown;
  };
};

export type ExtractTabularSequenceDataRequest = {
  hasHeader: boolean;
  molTypeSelector: MolTypeSelector;
  organismSelector?: OrganismSelector;
  orientationSelector: OrientationSelector;
  sequenceColumnIndex: number;
  nameColumnIndex?: number;
  seqNoIdColumnIndex?: number;
  analysisOptions?: Array<SequenceAnalysisOption>;
  modifications?: Array<Modification>;
};

export type ExtractTabularSequenceDataResponse = {
  sequences: Array<ExtractedSequenceData>;
};

export type ExtractedCompound = {
  mol: string;
  description?: string;
  sourceCdxml?: string;
};

export type ExtractedPatent = {
  patent: PatentInfo;
  status: PatentExtractionStatus;
  patentExtractionItemId?: string;
};

export type ExtractedPatentSuggestion =
  | ({
      status: 'ADDED';
    } & AddedPatentSuggestion)
  | ({
      status: 'DECLINED';
    } & DeclinedPatentSuggestion);

export type ExtractedPatentSuggestionFields = {
  patentExtractionItemId: string;
};

export type ExtractedPatentSuggestionRequest = {
  extractedPatents: Array<ExtractedPatentSuggestion>;
};

export type ExtractedSequenceData = {
  seqNoId: number;
  name: string;
  molType?: MolType;
  organism?: string;
  sequence: string;
  annotatedSequence?: string;
  sequenceLength: number;
  featureTable: Array<SequenceFeature>;
};

export type FailedCompoundInfo = {
  id: string;
  reason: string;
};

export type FailedFigureUpload = {
  fileName: string;
  errorMessage: string;
};

export type FailedFormExportFile = {
  type: 'failed';
  fileId: string;
  message?: string;
};

export type FamilyMember = {
  countryCode: string;
  publicationNumber: string;
};

export type FeatureFlagOrgOverride = {
  info: BaseOrganization;
  value: boolean;
};

export type FeatureFlagUserOverride = {
  info: BaseUser;
  value: boolean;
};

export type FeatureOverlapInfo = {
  featureId: string;
  featureText: string;
  noveltyScore: NoveltyScore;
  reasoning: string;
};

export type FeatureOverlapSummary = {
  featureIndex: number;
  noveltyScore: NoveltyScore;
};

export type FieldSearchCondition = {
  type: 'field';
  fields: Array<SigmaSearchQueryField>;
  value: string;
  cnTranslation?: string;
  cnMistranslation?: string;
};

export enum FigureDiagramAction {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export enum FigureDiagramReviewAction {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
}

export enum FigureDiagramStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export type FigureDiagramSuggestion = {
  figureDiagramEventId: string;
  figureType?: FigureFileType;
  action: FigureDiagramAction;
  suggestedPrompt: string;
  figureId?: string;
  status: FigureDiagramStatus;
};

export type FigureDiagramSuggestionCreateDetails = {
  action: 'CREATE';
};

export type FigureDiagramSuggestionDetails =
  | ({
      action: 'CREATE';
    } & FigureDiagramSuggestionCreateDetails)
  | ({
      action: 'EDIT';
    } & FigureDiagramSuggestionEditDetails);

export type FigureDiagramSuggestionEditDetails = {
  action: 'EDIT';
  figureId: string;
};

export type FigureDiagramSuggestionEvent = {
  type: 'figureDiagramSuggestion';
  figureDiagramEventId: string;
  figureType?: FigureFileType;
  suggestedPrompt: string;
  status: FigureDiagramStatus;
  details: FigureDiagramSuggestionDetails;
};

export type FigureFileCandidate = {
  fileId: string;
  fileName: string;
  fileStatus: FileStatus;
};

export type FigureFileCandidatesResponse = {
  candidates: Array<FigureFileCandidate>;
};

export enum FigureFileType {
  IMAGE = 'IMAGE',
  DIAGRAM = 'DIAGRAM',
}

export type FigureMetadata =
  | ({
      type: 'markerJs';
    } & MarkerJsFigureMetadata)
  | ({
      type: 'drawio';
    } & DrawioFigureMetadata);

export type FigureResponse = {
  id: string;
  type: FigureType;
  latestFileName: string;
  latestFileId: string;
  baseFileId?: string;
  /**
   * @deprecated
   */
  editMetadata?: {
    [key: string]: unknown;
  };
  createdAt: Instant;
  updatedAt?: Instant;
  sortOrder?: number;
  imageStyle?: ImageStyle;
  metadata?: FigureMetadata;
};

export enum FigureType {
  IMAGE = 'IMAGE',
  DIAGRAM = 'DIAGRAM',
}

export type FileCellInfo = {
  fileId: string;
  fileName?: string;
};

export type FileCellValue = {
  type: 'file';
  value?: FileCellInfo;
  isUnresolved?: boolean;
};

export type FileCitation = Omit<CitationV2, 'type'> & {
  type: 'file';
} & {
  type: 'file';
  boundingBox: Array<BoundingBox>;
};

export type FileColumnType = {
  type: 'file';
};

export type FileContentUploadRequest = {
  file: unknown;
};

export type FileFigureInfo = {
  fileFigureId: string;
  presignedUrl: PresignedUrl;
};

export type FileHighlight = PriorArtFileHighlight;

export enum FileHighlightType {
  PRIOR_ART = 'PRIOR_ART',
}

export type FileHighlightsResponse = {
  highlights: Array<FileHighlight>;
};

export type FileIdsResponse = {
  fileIds: Array<string>;
};

export type FileInfo = {
  fileId: string;
  fileName: string;
  fileType: FileType;
  isArchived: boolean;
  fileUrl?: string;
  presignedUrl?: PresignedUrl;
  status: FileStatus;
  fileSummary?: string;
};

export enum FileRendition {
  ORIGINAL = 'ORIGINAL',
  PROCESSED = 'PROCESSED',
}

export enum FileStatus {
  AWAITING_UPLOAD = 'AWAITING_UPLOAD',
  UPLOADED = 'UPLOADED',
  QUEUED = 'QUEUED',
  PROCESSING = 'PROCESSING',
  DONE = 'DONE',
  ERROR = 'ERROR',
}

export enum FileType {
  PDF = 'PDF',
  DOCX = 'DOCX',
  PPTX = 'PPTX',
  IMAGE = 'IMAGE',
  STEP = 'STEP',
}

export type FileUploadRequest = {
  fileName: string;
  file: unknown;
};

export type FilesFormField = {
  type: 'files';
  key: string;
  label: string;
  description?: string;
  placeholder?: string;
  required: boolean;
  requiredWhen?: FormCondition;
  visibleWhen?: FormCondition;
  prefill?: AiPrefill;
};

export type FilesValue = {
  type: 'files';
  fileIds: Array<string>;
};

export type FloatChartValue = {
  type: 'float';
  value: number;
};

export type FolderCompoundItem = {
  type: 'compound';
  compound: CompoundInfo;
};

export type FolderFileItem = {
  type: 'file';
  file: FileInfo;
};

export type FolderItem =
  | ({
      type: 'file';
    } & FolderFileItem)
  | ({
      type: 'compound';
    } & FolderCompoundItem)
  | ({
      type: 'sequence';
    } & FolderSequenceItem);

export type FolderItemRef = {
  itemType: FolderItemType;
  itemId: string;
};

export enum FolderItemType {
  FILE = 'FILE',
  COMPOUND = 'COMPOUND',
  SEQUENCE = 'SEQUENCE',
}

/**
 * The drawer a section is shown in.
 */
export enum FolderKind {
  FILE = 'FILE',
  COMPOUND = 'COMPOUND',
  SEQUENCE = 'SEQUENCE',
}

export type FolderSequenceItem = {
  type: 'sequence';
  sequence: SequenceInfo;
};

export type Form = {
  id: string;
  name: string;
  templateId: string;
  updatedAt: Instant;
};

export type FormAnswer =
  | ({
      type: 'text';
    } & TextValue)
  | ({
      type: 'date';
    } & DateValue)
  | ({
      type: 'integer';
    } & IntegerValue)
  | ({
      type: 'boolean';
    } & BooleanValue)
  | ({
      type: 'options';
    } & OptionsValue)
  | ({
      type: 'users';
    } & UsersValue)
  | ({
      type: 'files';
    } & FilesValue);

export type FormAnswerEntry = {
  key: string;
  value: FormAnswer;
};

export type FormCondition =
  | ({
      op: 'eq';
    } & EqFormCondition)
  | ({
      op: 'in';
    } & InFormCondition);

export type FormConditionValue =
  | ({
      type: 'text';
    } & TextValue)
  | ({
      type: 'integer';
    } & IntegerValue)
  | ({
      type: 'boolean';
    } & BooleanValue)
  | ({
      type: 'options';
    } & OptionsValue);

export type FormContent = {
  form: Form;
  definition: FormDefinition;
  answers: Array<FormAnswerEntry>;
};

export type FormDefinition = {
  sourceId?: string;
  pages: Array<FormPage>;
  export: FormExport;
};

export type FormExport = {
  values: Array<FormExportValue>;
  submittedStatus?: string;
};

export type FormExportFileResult =
  | ({
      type: 'uploaded';
    } & UploadedFormExportFile)
  | ({
      type: 'failed';
    } & FailedFormExportFile);

export type FormExportValue =
  | ({
      type: 'answer';
    } & AnswerExportValue)
  | ({
      type: 'combined_answer';
    } & CombinedAnswerExportValue)
  | ({
      type: 'constant';
    } & ConstantExportValue)
  | ({
      type: 'user_mapping';
    } & UserMappingExportValue);

export type FormField =
  | ({
      type: 'text';
    } & TextFormField)
  | ({
      type: 'date';
    } & DateFormField)
  | ({
      type: 'integer';
    } & IntegerFormField)
  | ({
      type: 'boolean';
    } & BooleanFormField)
  | ({
      type: 'options';
    } & OptionsFormField)
  | ({
      type: 'users';
    } & UsersFormField)
  | ({
      type: 'files';
    } & FilesFormField);

export type FormFieldBlockStart = {
  type: 'formField';
  formId: string;
  fieldKey: string;
};

export type FormFieldCommon = {
  key: string;
  label: string;
  description?: string;
  placeholder?: string;
  required: boolean;
  requiredWhen?: FormCondition;
  visibleWhen?: FormCondition;
  prefill?: AiPrefill;
};

export type FormFieldValueEvent = {
  type: 'formFieldValue';
  value: FormAnswer;
};

export type FormOption = {
  id: string;
  label: string;
  visibleWhen?: FormCondition;
};

export type FormPage = {
  key: string;
  title: string;
  visibleWhen?: FormCondition;
  sections: Array<FormSection>;
};

export type FormSection = {
  title?: string;
  fields: Array<FormField>;
};

export type FormTemplateContent = {
  type: 'form';
  definition: FormDefinition;
  isArchived: boolean;
};

export type FormUserContext = {
  type: 'form';
  formId: string;
  fieldKeys?: Array<string>;
};

export type FormUserOption = {
  id: string;
  name: string;
  visibleWhen?: FormCondition;
};

export type GeneralAssistant = {
  id: string;
  name: string;
  description?: string;
  language?: Language;
  createdAt: Instant;
};

export type GeneralAssistantDraftSource =
  | ({
      type: 'template';
    } & DraftFromTemplate)
  | ({
      type: 'upload';
    } & DraftFromUpload)
  | ({
      type: 'blank';
    } & DraftFromBlank);

export type GeneralAssistantInfo = {
  id: string;
  name: string;
  createdAt: Instant;
  createdBy: BasicUserInfo;
};

export type GenerateDiagramFromFigureRequest = {
  contentOverride?: string;
  userPrompt: string;
  existingState?: string;
  promptOverrides?: Array<PromptOverride>;
};

export type GenerateDiagramFromFileRequest = {
  userPrompt: string;
  referenceImage: unknown;
  existingState?: string;
  contentOverride?: string;
};

export type GenerateDiagramFromFileV2Request = {
  userPrompt: string;
  referenceImage: unknown;
  existingMetadata?: FigureMetadata;
  contentOverride?: string;
};

export type GenerateDiagramV2Request = {
  contentOverride?: string;
  userPrompt: string;
  existingMetadata?: FigureMetadata;
  promptOverrides?: Array<PromptOverride>;
};

export type GenerateFigureDiagramResponse = {
  markerState: {
    [key: string]: unknown;
  };
};

export type GenerateFigureDiagramUnifiedResponse = {
  metadata: FigureMetadata;
};

export type GenerateFigureImageFromFileRequest = {
  prompt: string;
  referenceImage: unknown;
  imageStyle?: ImageStyle;
  contentOverride?: string;
};

export type GenerateFigureImageResponse = {
  tempFileId: string;
};

export type GenerateImageFromFigureRequest = {
  contentOverride?: string;
  prompt: string;
  figureId: string;
  additionalImageTempFileIds?: Array<string>;
  imageStyle?: ImageStyle;
  promptOverrides?: Array<PromptOverride>;
};

export type GenerateImageFromTempFileRequest = {
  contentOverride?: string;
  prompt: string;
  tempFileId: string;
  additionalImageTempFileIds?: Array<string>;
  imageStyle?: ImageStyle;
  promptOverrides?: Array<PromptOverride>;
};

export type GenerateImageFromTextRequest = {
  prompt: string;
  imageStyle?: ImageStyle;
  promptOverrides?: Array<PromptOverride>;
};

export type GenerateKnowledgeDescriptionRequest = {
  name: string;
  content?: string;
  referenceFileIds?: Array<string>;
  resourceType?: ResourceType;
  resourceId?: string;
};

export type GenerateKnowledgeDescriptionResponse = {
  description: string;
};

export type GenerateReferenceSignsFromImageRequest = {
  imageFile: unknown;
  'figure-id'?: string;
  contentOverride?: string;
};

export type GenerateSigmaSearchQueryRequest = {
  title: string;
  context: string;
};

export type GenerateSigmaSearchQueryResponse = {
  query: SigmaSearchCondition;
};

export type GeneratedReferenceSign = {
  label: string;
  value: string;
  figureIds: Array<string>;
};

export type GeneratedReferenceSignsResponse = {
  generatedReferenceSigns: Array<GeneratedReferenceSign>;
};

export type GetAllPatentDraftsResponse = {
  total: number;
  patentDrafts: Array<PatentDraftInfo>;
};

export type GetChatMessageResponse = {
  total: number;
  chatMessages: Array<ChatMessageInfo>;
};

export type GetCompoundsResponse = {
  compounds: Array<CompoundInfo>;
};

export type GetDataTablePatentFieldValuesResponse = {
  values: Array<DataTablePatentFieldValue>;
};

export type GetDataTableResponse = {
  table: DataTable;
};

export type GetDataTableRowsByIdResponse = {
  rows: Array<DataTableRow>;
};

export type GetDataTableRowsByIdsRequest = {
  rowIds: Array<string>;
  columnIds?: Array<string>;
};

export type GetDataTableRowsRequest = {
  pageNumber?: number;
  pageSize?: number;
  filters?: Array<DataTableFilter>;
  sort?: DataTableSort;
  search?: string;
};

export type GetDataTableRowsResponse = {
  rows: Array<DataTableRow>;
  totalRowCount: number;
  filteredRowCount?: number;
};

export type GetFeatureFlagAdminResponse = {
  featureFlags: Array<AdminFeatureFlag>;
};

export type GetFeatureFlagOverridesResponse = {
  orgOverrides: Array<FeatureFlagOrgOverride>;
  userOverrides: Array<FeatureFlagUserOverride>;
};

export type GetFeatureFlagResponse = {
  featureFlags: {
    [key: string]: unknown;
  };
};

export type GetFormResponse = {
  content: FormContent;
};

export type GetNoveltyAnalysesResponse = {
  analyses: Array<NoveltyAnalysisInfo>;
};

export type GetNoveltyAnalysisResultOverlapResponse = {
  patentDetails: NoveltyAnalysisOverlapPatentDetails;
  features: Array<FeatureOverlapInfo>;
};

export type GetNoveltyAnalysisResultOverlapStatusResponse = {
  status: NoveltyAnalysisStatus;
};

export type GetNoveltyAnalysisResultsResponse = {
  analysisId: string;
  results: Array<NoveltyAnalysisPatentResult>;
  totalResultCount: number;
};

export type GetNoveltyAnalysisStatusResponse = {
  status: NoveltyAnalysisStatus;
  totalFilteredResultCount: number;
  finishedOverlapCount: number;
};

export type GetObjectionStatusResponse = {
  objectionStatus: OfficeActionObjectionStatus;
  lastAnalysedAt?: string;
};

export type GetOfficeActionObjectionResponse = {
  objectionInfo: OfficeActionObjectionInfo;
  snippet: string;
  summary?: string;
  examinerReasoning: Array<OfficeActionCitedContent>;
  files: Array<OfficeActionFileInfo>;
};

export type GetPatentDraftFilesResponse = {
  files: Array<PatentDraftFileInfo>;
};

export type GetSigmaSearchQueryResponse = {
  query?: SigmaSearchCondition;
};

export type GetSigmaSearchResponse = {
  search: SigmaSearchDetail;
};

export type GetSigmaSearchStatusResponse = {
  state: SigmaSearchState;
  processedCount: number;
  targetCount: number;
  totalHits?: number;
};

export type GetTemplateResponse = {
  template: TemplateInfo;
};

export type GetTemporaryFileResponse = {
  presignedUrl: PresignedUrl;
};

export type GlossaryRelatedTerm = {
  term: string;
  location: GlossaryTermLocation;
};

export type GlossaryRelatedTermsResponse = {
  relatedTerms: Array<GlossaryRelatedTerm>;
};

export type GlossarySearchRequest = {
  documentId: string;
  searchTerm: string;
  contentOverride?: string;
};

export type GlossaryTermDefinitionsResponse = {
  definitions: Array<GlossaryTermLocation>;
  effects: Array<GlossaryTermLocation>;
};

export type GlossaryTermLocation = {
  quote: string;
  tagId: string;
};

export type HighlightedSection = {
  sectionRef: string;
  content: string;
};

export type HubEntry =
  | ({
      type: 'folder';
    } & HubFolderEntry)
  | ({
      type: 'resource';
    } & HubResourceEntry);

export type HubFolderEntry = {
  type: 'folder';
  folderId: string;
  folderType: ResourceFolderType;
  resourceType?: ResourceType;
  name: string;
  accessType: AccessType;
  creatorId: string;
  sharedWithOrg: boolean;
  sharedWithUserCount: number;
  itemCount: number;
  createdByUser: ProjectUserInfo;
  lastUsedAt: Instant;
  createdAt: Instant;
  customFields: Array<ProjectCustomField>;
};

export type HubResourceEntry = {
  type: 'resource';
  resourceType: ResourceType;
  resourceId: string;
  folderId?: string;
  name: string;
  status?: ProjectStatus;
  draftingMode?: DraftMode;
  createdByUser: ProjectUserInfo;
  accessType: AccessType;
  sharedByMe: boolean;
  createdAt: Instant;
  lastUsedAt: Instant;
  review?: ProjectReview;
  customFields: Array<ProjectCustomField>;
};

export enum ImageStyle {
  GENERIC_IMAGE = 'GENERIC_IMAGE',
  PATENT_DRAWING = 'PATENT_DRAWING',
}

export type ImportByApplicationRef = {
  patentOfficeCode: PatentOfficeCode;
  documentIds: Array<string>;
  resourceType: ResourceType;
  resourceId: string;
  folderId?: string;
  type: 'applicationRef';
  applicationRef: string;
};

export type ImportByPublicationNumber = {
  patentOfficeCode: PatentOfficeCode;
  documentIds: Array<string>;
  resourceType: ResourceType;
  resourceId: string;
  folderId?: string;
  type: 'publicationNumber';
  publicationNumber: string;
};

export type ImportDataTableRequest = {
  /**
   * @deprecated
   */
  temporaryFileIds?: Array<string>;
  /**
   * @deprecated
   */
  temporaryFileId?: string;
  name: string;
  resourceId: string;
  resourceType: ResourceType;
  columns: Array<DataTableImportColumnMapping>;
  ranges?: Array<DataTableImportFileRange>;
};

export type ImportExternalSourceFileResult =
  | ({
      status: 'imported';
    } & ExternalSourceFileImportSuccess)
  | ({
      status: 'failed';
    } & ExternalSourceFileImportFailure);

export type ImportExternalSourceFilesRequest = {
  folderId?: string;
  patentDraftFileType?: PatentDraftFileType;
  files: Array<ExternalSourceFileSpec>;
};

export type ImportExternalSourceFilesResponse = {
  results: Array<ImportExternalSourceFileResult>;
};

export type ImportPatentOfficeFileFields = {
  patentOfficeCode: PatentOfficeCode;
  documentIds: Array<string>;
  resourceType: ResourceType;
  resourceId: string;
  folderId?: string;
};

export type ImportPatentOfficeFileRequest =
  | ({
      type: 'applicationRef';
    } & ImportByApplicationRef)
  | ({
      type: 'publicationNumber';
    } & ImportByPublicationNumber);

export type ImportPatentOfficeFileResponse = {
  successIds: Array<string>;
  failedIds: Array<string>;
};

export type ImportReferenceSignsFromDocumentRequest = {
  file: unknown;
};

export type InFormCondition = {
  op: 'in';
  key: string;
  values: Array<FormConditionValue>;
};

export type IntChartValue = {
  type: 'int';
  value: number;
};

export type IntegerCellValue = {
  type: 'integer';
  value?: number;
};

export type IntegerColumnFilter = {
  type: 'integer';
  columnId: string;
  operator: NumericalFilterOperator;
  value?: number;
};

export type IntegerColumnType = {
  type: 'integer';
  unit?: string;
};

export type IntegerFormField = {
  type: 'integer';
  key: string;
  label: string;
  description?: string;
  placeholder?: string;
  required: boolean;
  requiredWhen?: FormCondition;
  visibleWhen?: FormCondition;
  prefill?: AiPrefill;
  min?: number;
  max?: number;
};

export type IntegerSetting = Omit<AdminSetting, 'type'> & {
  type: 'integer';
} & {
  type: 'integer';
  default: number;
  orgOverride?: number;
  userOverrides?: {
    [key: string]: unknown;
  };
};

export type IntegerSettingUpdate = Omit<AdminSettingUpdate, 'type'> & {
  type: 'integer';
} & {
  type: 'integer';
  orgOverride?: number;
  userOverrides?: {
    [key: string]: unknown;
  };
};

export type IntegerValue = {
  type: 'integer';
  value: number;
};

export type InventionAssistant = {
  id: string;
  name: string;
  folderId?: string;
  language?: Language;
  createdAt: Instant;
  review?: ProjectReview;
  customFields: Array<ProjectCustomField>;
};

export type ItemFolderInfo = {
  folderId: string;
  name: string;
  index: number;
  kind: FolderKind;
  items: Array<FolderItem>;
};

export type ItemFolderMetadata = {
  folderId: string;
  name: string;
  index: number;
  kind: FolderKind;
};

export type ItemFoldersResponse = {
  folders: Array<ItemFolderInfo>;
};

export enum Jurisdiction {
  EPO = 'EPO',
  USPTO = 'USPTO',
  KIPO = 'KIPO',
  CNIPA = 'CNIPA',
  HIPO = 'HIPO',
  JPO = 'JPO',
  FR = 'FR',
  DE = 'DE',
}

export type KnowledgeDetail = {
  id: string;
  name: string;
  sharedWithOrg: boolean;
  accessType: AccessType;
  description: string;
  resourceType: ResourceType;
  source: KnowledgeSource;
  sharedWithUsers: boolean;
  forceActive: boolean;
  content?: string;
  referenceFiles: Array<ReferenceFile>;
  creatorId: string;
  updatedAt: Instant;
};

export type KnowledgeEventCreate = {
  id: string;
  status: KnowledgeEventStatus;
  proposedContent: string;
  type: 'CREATE';
  name: string;
  description: string;
};

export type KnowledgeEventDetail =
  | ({
      type: 'CREATE';
    } & KnowledgeEventCreate)
  | ({
      type: 'EDIT';
    } & KnowledgeEventEdit);

export type KnowledgeEventEdit = {
  id: string;
  status: KnowledgeEventStatus;
  proposedContent: string;
  type: 'EDIT';
  knowledgeId: string;
  name: string;
  description: string;
  currentContent?: string;
};

export type KnowledgeEventFields = {
  id: string;
  status: KnowledgeEventStatus;
  proposedContent: string;
};

export enum KnowledgeEventStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export enum KnowledgeEventType {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export type KnowledgeFolderInfo = {
  folderId: string;
  folderType: ResourceFolderType;
  resourceType?: ResourceType;
  name: string;
  accessType: AccessType;
  creatorId: string;
  sharedWithOrg: boolean;
  sharedWithUserCount: number;
  itemCount: number;
  knowledge: Array<KnowledgeListItem>;
};

export type KnowledgeFoldersResponse = {
  folders: Array<KnowledgeFolderInfo>;
  unfiled: Array<KnowledgeListItem>;
};

export type KnowledgeInfo = {
  knowledgeId: string;
  name: string;
  isDeleted: boolean;
};

export type KnowledgeListItem = {
  id: string;
  name: string;
  sharedWithOrg: boolean;
  accessType: AccessType;
  resourceType: ResourceType;
  active: boolean;
  autoLoad: boolean;
  forceActiveForUser: boolean;
  sharedWithUsers: boolean;
  referenceFileIds: Array<string>;
  isCreator: boolean;
  createdBy: BaseUser;
  linkedTemplateCount: number;
  linkedDocumentCount: number;
  createdAt: Instant;
};

export enum KnowledgeReviewAction {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
}

export type KnowledgeShareConflicts = {
  peopleWithoutAccessCount: number;
};

export enum KnowledgeSource {
  USER = 'USER',
  GENERATED = 'GENERATED',
}

export type KnowledgeSuggestion = {
  knowledgeEventId: string;
  knowledgeId?: string;
  name: string;
  description: string;
  status: KnowledgeEventStatus;
  type: KnowledgeEventType;
};

export type KnowledgeSuggestionEvent = {
  type: 'knowledgeSuggestion';
  knowledgeEventId: string;
  name: string;
  description: string;
  status: KnowledgeEventStatus;
  eventType: KnowledgeEventType;
};

export enum Language {
  ENGLISH = 'ENGLISH',
  FRENCH = 'FRENCH',
  GERMAN = 'GERMAN',
  BULGARIAN = 'BULGARIAN',
  ITALIAN = 'ITALIAN',
  SPANISH = 'SPANISH',
  DUTCH = 'DUTCH',
  PORTUGUESE = 'PORTUGUESE',
  CHINESE = 'CHINESE',
  JAPANESE = 'JAPANESE',
  KOREAN = 'KOREAN',
  HUNGARIAN = 'HUNGARIAN',
}

export type LinkedResourceMessageInfo = {
  type: LinkedResourceType;
  id: string;
  title: string;
  fromInactiveObjectionRun: boolean;
};

export type LinkedResourcePrompt = {
  type: 'linkedResource';
  linkedResourceType: LinkedResourceType;
  linkedResourceId: string;
  userMessage: string;
};

export enum LinkedResourceType {
  OFFICE_ACTION_SUGGESTION = 'OFFICE_ACTION_SUGGESTION',
  OFFICE_ACTION_OBJECTION = 'OFFICE_ACTION_OBJECTION',
  OFFICE_ACTION_OBJECTION_FEATURE = 'OFFICE_ACTION_OBJECTION_FEATURE',
  LITIGATION_SEARCH_RESULT = 'LITIGATION_SEARCH_RESULT',
  LITIGATION_FEATURE_OVERLAP = 'LITIGATION_FEATURE_OVERLAP',
  NOVELTY_ANALYSIS_RESULT = 'NOVELTY_ANALYSIS_RESULT',
}

export type ListAdminCustomFieldsResponse = {
  fields: Array<AdminCustomField>;
};

export type ListCustomFieldsResponse = {
  fields: Array<CustomFieldDefinition>;
};

export type ListDataTableChartsResponse = {
  tableId: string;
  charts: Array<DataTableChartSummary>;
};

export type ListDataTablesResponse = {
  tables: Array<DataTableSummary>;
};

export type ListExternalConnectionsResponse = {
  connections: Array<ExternalConnection>;
};

export type ListExternalSourceConfigsResponse = {
  sources: Array<ExternalSourceDetails>;
};

export type ListExternalSourceItemsResponse = {
  items: Array<ExternalSourceItem>;
  nextPageToken?: string;
};

export type ListExternalSourcesResponse = {
  sources: Array<ExternalSourceStatus>;
};

export type ListFormsResponse = {
  forms: Array<Form>;
};

export type ListGeneralAssistantsResponse = {
  total: number;
  generalAssistants: Array<GeneralAssistantInfo>;
};

export type ListInventionAssistantsResponse = {
  total: number;
  inventionAssistants: Array<InventionAssistant>;
};

export type ListKnowledgeResponse = {
  total: number;
  knowledge: Array<KnowledgeListItem>;
};

export type ListPatentFamilyMembersRequest = {
  patentOfficeCode: PatentOfficeCode;
  reference: string;
};

export type ListPatentFamilyMembersResponse = {
  members: Array<PatentFamilyMember>;
};

export type ListProjectsResponse = {
  total: number;
  /**
   * @deprecated
   */
  projects: Array<ProjectListItem>;
  entries: Array<HubEntry>;
};

export type ListSequencesResponse = {
  sequences: Array<SequenceInfo>;
};

export type ListSigmaSearchesResponse = {
  searches: Array<SigmaSearchSummary>;
};

export type ListTemplatesResponse = {
  templates: Array<TemplateInfo>;
};

export type LookupUsersRequest = {
  userIds: Array<string>;
};

export type LookupUsersResponse = {
  users: Array<ProjectUserInfo>;
};

export type ManualColumnSource = {
  type: 'manual';
};

export type MarkerJsFigureMetadata = {
  type: 'markerJs';
  state: {
    [key: string]: unknown;
  };
};

export type MarkerJsReferenceSignPlacements = {
  type: 'markerJs';
  markers: Array<{
    [key: string]: unknown;
  }>;
};

export type MessagesStored = {
  type: 'messagesStored';
  userMessageId: string;
  assistantMessageId: string;
};

export enum ModelProvider {
  OPENAI = 'OPENAI',
  OPENAI_FALLBACK = 'OPENAI_FALLBACK',
  OPENAI_5_5 = 'OPENAI_5_5',
  OPENAI_TEST = 'OPENAI_TEST',
  OPENAI_EU = 'OPENAI_EU',
  OPENAI_EU_FALLBACK = 'OPENAI_EU_FALLBACK',
  OPENAI_US = 'OPENAI_US',
  OPENAI_US_FALLBACK = 'OPENAI_US_FALLBACK',
  BEDROCK = 'BEDROCK',
  BEDROCK_TEST = 'BEDROCK_TEST',
  BEDROCK_4_5 = 'BEDROCK_4_5',
  BEDROCK_4_6 = 'BEDROCK_4_6',
  BEDROCK_4_7 = 'BEDROCK_4_7',
  BEDROCK_4_8 = 'BEDROCK_4_8',
  BEDROCK_5 = 'BEDROCK_5',
  BEDROCK_5_5 = 'BEDROCK_5_5',
}

export type Modification = {
  notation: string;
  position?: ModificationPosition;
  key?: ModificationKey;
  modification: string;
  residue?: string;
};

export enum ModificationKey {
  MISC_DIFFERENCE = 'Misc Difference',
  MISC_FEATURE = 'Misc Feature',
  MODIFIED_BASE = 'Modified Base',
  UNSURE = 'Unsure',
  VARIATION = 'Variation',
  MOD_RES = 'Mod Res',
  REGION = 'Region',
  SITE = 'Site',
  VARIANT = 'Variant',
  VAR_SEQ = 'Var Seq',
}

export enum ModificationPosition {
  PREFIX = 'prefix',
  SUFFIX = 'suffix',
  LINKAGE = 'linkage',
  RESIDUE = 'residue',
  TERMINAL = 'terminal',
}

export type ModifyResourceAccess = {
  type: 'modify';
  accessType: AccessType;
};

export enum MolType {
  GENOMIC_DNA = 'GENOMIC_DNA',
  OTHER_DNA = 'OTHER_DNA',
  UNASSIGNED_DNA = 'UNASSIGNED_DNA',
  GENOMIC_RNA = 'GENOMIC_RNA',
  MRNA = 'MRNA',
  TRNA = 'TRNA',
  RRNA = 'RRNA',
  OTHER_RNA = 'OTHER_RNA',
  TRANSCRIBED_RNA = 'TRANSCRIBED_RNA',
  VIRAL_CRNA = 'VIRAL_CRNA',
  UNASSIGNED_RNA = 'UNASSIGNED_RNA',
  PROTEIN = 'PROTEIN',
  DNA = 'DNA',
  RNA = 'RNA',
  AA = 'AA',
}

export type MolTypeCategory = {
  category: SequenceMolTypeCategory;
  options: Array<MolTypeOption>;
};

export type MolTypeOption = {
  value: string;
  label: string;
};

export type MolTypeOptionsResponse = {
  categories: Array<MolTypeCategory>;
};

export type MolTypeSelector =
  | ({
      type: 'static';
    } & StaticMolTypeSelector)
  | ({
      type: 'column';
    } & ColumnMolTypeSelector);

export type MultiLinkedResourcePrompt = {
  type: 'multiLinkedResource';
  linkedResourceType: LinkedResourceType;
  linkedResourceIds: Array<string>;
  userMessage: string;
};

export type NewDataTableRow = {
  afterRowId?: string;
  cells: Array<DataTableCell>;
};

export type NewReferenceSignDetails = {
  label: string;
  value: string;
  figureIds: Array<string>;
};

export type NotSearchCondition = {
  type: 'not';
  condition: SigmaSearchCondition;
};

export type NoveltyAnalysisInfo = {
  id: string;
  name: string;
  status: NoveltyAnalysisStatus;
  createdAt: string;
};

export type NoveltyAnalysisOverlapPatentDetails = {
  patentId: string;
  title?: string;
  publicationDate?: string;
  priorityDate?: string;
  countryCode: string;
  patentAbstract?: string;
  patentDescription?: string;
  familyMembers: Array<FamilyMember>;
  applicants: Array<string>;
  assignees: Array<string>;
};

export type NoveltyAnalysisPatentDetails = {
  title?: string;
  publicationDate?: string;
  priorityDate?: string;
  countryCode: string;
  familyMembers: Array<FamilyMember>;
  applicants: Array<string>;
  assignees: Array<string>;
};

export type NoveltyAnalysisPatentResult = {
  resultId: string;
  patentId: string;
  patentDetails: NoveltyAnalysisPatentDetails;
  riskLevel?: NoveltyRiskLevel;
  features: Array<FeatureOverlapSummary>;
};

export enum NoveltyAnalysisStatus {
  QUEUED = 'QUEUED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  CANCELLED = 'CANCELLED',
  ERROR = 'ERROR',
}

export type NoveltyFeaturesBody = {
  features: {
    [key: string]: unknown;
  };
};

export enum NoveltyRiskLevel {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}

export enum NoveltyScore {
  NOVEL = 'NOVEL',
  UNKNOWN = 'UNKNOWN',
  NOT_NOVEL = 'NOT_NOVEL',
}

export type NumberFieldAggregate = {
  definition: CustomFieldDefinition;
  /**
   * The type the field belongs to. RESOURCE_FOLDER fields count each project under the value of the folder it is filed in.
   */
  resourceType: ResourceType;
  /**
   * Projects counted: those of `resourceType`, or every project for a RESOURCE_FOLDER field.
   */
  population: number;
  /**
   * How many of `population` have a value.
   */
  filled: number;
  type: 'number';
  min?: number;
  max?: number;
  mean?: number;
};

export type NumberFieldFilter = {
  type: 'number';
  min?: number;
  max?: number;
};

export type NumberFieldType = {
  type: 'number';
};

export type NumberFieldValue = {
  type: 'number';
  value?: number;
};

export enum NumericalFilterOperator {
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN_OR_EQUALS = 'GREATER_THAN_OR_EQUALS',
  LESS_THAN_OR_EQUALS = 'LESS_THAN_OR_EQUALS',
  IS_EMPTY = 'IS_EMPTY',
  IS_NOT_EMPTY = 'IS_NOT_EMPTY',
}

export type OAuth2AuthorizationCodeAuthRequest = {
  method: 'oauth2';
  sourceId: string;
  authCode: string;
  redirectUri: string;
};

export type ObjectionSuggestion = {
  suggestionId: string;
  suggestionType: ObjectionSuggestionType;
  suggestionTitle: string;
  status?: ObjectionSuggestionStatus;
  response?: string;
};

export type ObjectionSuggestionResponse = {
  suggestions: Array<ObjectionSuggestion>;
  suggestionsV2: Array<ObjectionSuggestionV2>;
};

export enum ObjectionSuggestionScore {
  STRONG = 'STRONG',
  NORMAL = 'NORMAL',
  WEAK = 'WEAK',
}

export enum ObjectionSuggestionStatus {
  RUN = 'RUN',
  DECLINED = 'DECLINED',
}

export enum ObjectionSuggestionType {
  REBUT = 'REBUT',
  AMEND = 'AMEND',
}

export type ObjectionSuggestionV2 = {
  suggestionId: string;
  suggestionTitle: string;
  suggestionType: ObjectionSuggestionType;
  description: Array<OfficeActionCitedContent>;
  suggestionScore?: ObjectionSuggestionScore;
  sourceFeatureIds: Array<string>;
};

export type OfficeActionCitedContent = {
  text: string;
  highlights: Array<OfficeActionsCitedContentHighlight>;
};

export enum OfficeActionDocumentType {
  RESPONSE_LETTER = 'RESPONSE_LETTER',
  CLIENT_RESPONSE_LETTER = 'CLIENT_RESPONSE_LETTER',
  STRATEGY_DOCUMENT = 'STRATEGY_DOCUMENT',
  FOREIGN_ATTORNEY_INSTRUCTIONS = 'FOREIGN_ATTORNEY_INSTRUCTIONS',
  CLAIMS = 'CLAIMS',
  DESCRIPTION = 'DESCRIPTION',
}

export enum OfficeActionFileFrontendStatus {
  UPLOADED = 'UPLOADED',
  MISSING = 'MISSING',
  READY = 'READY',
  QUEUED = 'QUEUED',
  PROCESSING = 'PROCESSING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}

export type OfficeActionFileInfo = {
  fileId: string;
  fileType: OfficeActionFileType;
  title: string;
  fileStatus: OfficeActionFileFrontendStatus;
  isIgnored: boolean;
  isPostAnalysis: boolean;
  patentOfficeFileInfo?: PatentOfficeFileInfo;
};

export enum OfficeActionFileType {
  OFFICE_ACTION = 'OFFICE_ACTION',
  PRIOR_OFFICE_ACTION = 'PRIOR_OFFICE_ACTION',
  PRIOR_RESPONSE = 'PRIOR_RESPONSE',
  CLAIMS = 'CLAIMS',
  DESCRIPTION = 'DESCRIPTION',
  DRAWINGS = 'DRAWINGS',
  STRATEGY = 'STRATEGY',
  PRIOR_ART = 'PRIOR_ART',
  COMBINED_APPLICATION = 'COMBINED_APPLICATION',
}

export enum OfficeActionJurisdictionCode {
  EPO = 'EPO',
  USPTO = 'USPTO',
  FR = 'FR',
  GB = 'GB',
  DE = 'DE',
  CNIPA = 'CNIPA',
  CIPO = 'CIPO',
  AU = 'AU',
  JPO = 'JPO',
  KIPO = 'KIPO',
  OTHER = 'OTHER',
  SG = 'SG',
}

export enum OfficeActionLanguage {
  ENGLISH = 'ENGLISH',
  FRENCH = 'FRENCH',
  GERMAN = 'GERMAN',
  CHINESE = 'CHINESE',
  KOREAN = 'KOREAN',
  ITALIAN = 'ITALIAN',
  SPANISH = 'SPANISH',
  DUTCH = 'DUTCH',
  JAPANESE = 'JAPANESE',
  PORTUGUESE = 'PORTUGUESE',
}

export type OfficeActionObjectionClaim = {
  officeActionClaimId: string;
  claimRef: string;
  claimIndex?: number;
  claimFeatures: Array<OfficeActionObjectionClaimFeature>;
};

export type OfficeActionObjectionClaimFeature = {
  featureId: string;
  featureRef: string;
};

export type OfficeActionObjectionClaimFile = {
  claimFileId: string;
  claims: Array<OfficeActionObjectionClaim>;
};

export type OfficeActionObjectionInfo = {
  id: string;
  title: string;
  objectionType: OfficeActionObjectionType;
  claims: OfficeActionObjectionClaimFile;
  priorArt: Array<OfficeActionObjectionPriorArt>;
  objectionStatus: OfficeActionObjectionStatus;
  lastAnalysedAt?: string;
  state: OfficeActionObjectionState;
  numStrongRebutSuggestions: number;
};

export type OfficeActionObjectionPriorArt = {
  priorArtFileId: string;
  priorArtRef: string;
  highlights: Array<BoundingBox>;
};

export enum OfficeActionObjectionState {
  OPEN = 'OPEN',
  COMPLETE = 'COMPLETE',
  INCOMPLETE = 'INCOMPLETE',
}

export enum OfficeActionObjectionStatus {
  PROCESSING = 'PROCESSING',
  PROCESSING_SUGGESTIONS = 'PROCESSING_SUGGESTIONS',
  FEATURE_ANALYSIS = 'FEATURE_ANALYSIS',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}

export enum OfficeActionObjectionType {
  CLARITY = 'CLARITY',
  NOVELTY = 'NOVELTY',
  INVENTIVITY = 'INVENTIVITY',
  GENERAL = 'GENERAL',
  USC101 = 'USC101',
  IMPERMISSIBLE_AMENDMENT = 'IMPERMISSIBLE_AMENDMENT',
  PRACTICAL_APPLICABILITY = 'PRACTICAL_APPLICABILITY',
  SUFFICIENCY_OF_DISCLOSURE = 'SUFFICIENCY_OF_DISCLOSURE',
}

/**
 * Office actions. No settings of their own yet.
 */
export type OfficeActionSettings = {
  [key: string]: unknown;
};

export type OfficeActionSetupRegister = {
  patentOfficeCode: PatentOfficeCode;
  applicationRef: string;
};

export type OfficeActionSetupSpec = {
  name: string;
  jurisdiction: Jurisdiction;
  language?: Language;
  register?: OfficeActionSetupRegister;
  folderId?: string;
  folders: Array<SetupFolderSpec>;
};

export type OfficeActionsCitationFileInfo = {
  alias?: string;
  name?: string;
};

export type OfficeActionsCitedContentHighlight = {
  fileId: string;
  fileInfo: OfficeActionsCitationFileInfo;
  type: string;
  boundingBoxes: Array<BoundingBox>;
};

export type OfficeActionsComposePromptPreviewRequest = {
  workflow: 'office_actions';
  jurisdiction: OfficeActionJurisdictionCode;
  language: OfficeActionLanguage;
  overrides: Array<PromptOverride>;
};

export type OptionsFormField = {
  type: 'options';
  key: string;
  label: string;
  description?: string;
  placeholder?: string;
  required: boolean;
  requiredWhen?: FormCondition;
  visibleWhen?: FormCondition;
  prefill?: AiPrefill;
  multiple: boolean;
  options: Array<FormOption>;
  display: OptionsFormFieldDisplay;
};

export enum OptionsFormFieldDisplay {
  TILES = 'TILES',
  DROPDOWN = 'DROPDOWN',
}

export type OptionsValue = {
  type: 'options';
  optionIds: Array<string>;
};

export type OrSearchCondition = {
  type: 'or';
  conditions: Array<SigmaSearchCondition>;
};

export type OrganismSelector =
  | ({
      type: 'static';
    } & StaticOrganismSelector)
  | ({
      type: 'column';
    } & ColumnOrganismSelector);

/**
 * The 5'->3' authoring direction of an annotated sequence.
 */
export enum Orientation {
  FIVE_TO_THREE = 'five_to_three',
  THREE_TO_FIVE = 'three_to_five',
}

export type OrientationSelector =
  | ({
      type: 'static';
    } & StaticOrientationSelector)
  | ({
      type: 'column';
    } & ColumnOrientationSelector);

export type ParseCdxCmlResponse = {
  extractedCompounds: Array<ParsedCompound>;
  compounds: Array<string>;
};

export type ParseModificationsResponse = {
  modifications: Array<Modification>;
};

export type ParsedCompound = {
  name?: string;
  mol: string;
  properties: {
    [key: string]: unknown;
  };
  description?: string;
  sourceCdxml?: string;
};

export type PatentAssigneeFieldFilter = {
  field: 'assignee';
  operator: StringEnumFilterOperator;
  values?: Array<string>;
};

export type PatentCellValue = {
  type: 'patent';
  value?: PatentInfo;
  isUnresolved?: boolean;
};

export type PatentColumnFilter = {
  type: 'patent';
  columnId: string;
  filter: PatentFieldFilter;
};

export type PatentColumnType = {
  type: 'patent';
};

export type PatentCpcGroupFieldFilter = {
  field: 'cpcGroup';
  operator: StringEnumFilterOperator;
  values?: Array<string>;
};

export type PatentCpcSubclassFieldFilter = {
  field: 'cpcSubclass';
  operator: StringEnumFilterOperator;
  values?: Array<string>;
};

export enum PatentDraftContentType {
  HTML = 'HTML',
  MD = 'MD',
}

export type PatentDraftDetails = {
  patentDraftId: string;
  name?: string;
  inventionDescription?: string;
  content?: string;
  initialContent?: string;
  contentType: PatentDraftContentType;
  referencePatents: Array<ReferencePatentEntry>;
  createdByUserId: string;
  createdAt: string;
  antecedenceCheckExecuted: boolean;
  dependenceCheckExecuted: boolean;
  referenceSignsCheckExecuted: boolean;
  jurisdiction?: PatentDraftJurisdiction;
  draftingMode: DraftMode;
  language: PatentDraftLanguage;
  hasComments: boolean;
  document?: Document;
  trackedChangesBase?: Document;
  contentGenerated: boolean;
  templateId?: string;
  customInstructionId?: string;
  sectionless: boolean;
};

export type PatentDraftFileInfo = FileInfo & {
  patentDraftFileType: PatentDraftFileType;
  patentDraftFileStatus: PatentDraftFileStatus;
};

export enum PatentDraftFileStatus {
  UPLOADED = 'UPLOADED',
  QUEUED = 'QUEUED',
  PROCESSING = 'PROCESSING',
  DONE = 'DONE',
  ERROR = 'ERROR',
}

export enum PatentDraftFileType {
  PRIOR_ART = 'PRIOR_ART',
  STYLE_REFERENCE = 'STYLE_REFERENCE',
  FIGURE = 'FIGURE',
  FIGURE_BASE = 'FIGURE_BASE',
  INVENTION_DESCRIPTION = 'INVENTION_DESCRIPTION',
  MARKUSH_IMAGE = 'MARKUSH_IMAGE',
  TABLE_IMAGE = 'TABLE_IMAGE',
  COMPOUND_IMAGE = 'COMPOUND_IMAGE',
}

export type PatentDraftInfo = {
  patentDraftId: string;
  name?: string;
  createdByUser: BasicUserInfo;
  createdAt: string;
  userPermissions: Array<UserPermission>;
  jurisdiction?: PatentDraftJurisdiction;
  language: PatentDraftLanguage;
  draftingMode?: DraftMode;
};

export enum PatentDraftJurisdiction {
  EPO = 'EPO',
  PCT = 'PCT',
  USPTO = 'USPTO',
  KIPO = 'KIPO',
  CNIPA = 'CNIPA',
  HIPO = 'HIPO',
  CIPO = 'CIPO',
  AU = 'AU',
  JPO = 'JPO',
  FR = 'FR',
}

export enum PatentDraftLanguage {
  ENGLISH = 'ENGLISH',
  FRENCH = 'FRENCH',
  GERMAN = 'GERMAN',
  CHINESE = 'CHINESE',
  KOREAN = 'KOREAN',
  ITALIAN = 'ITALIAN',
  SPANISH = 'SPANISH',
  DUTCH = 'DUTCH',
  HUNGARIAN = 'HUNGARIAN',
  PORTUGUESE = 'PORTUGUESE',
  JAPANESE = 'JAPANESE',
}

/**
 * Patent drafting. No settings of its own yet.
 */
export type PatentDraftSettings = {
  [key: string]: unknown;
};

export type PatentExtractionEvent = {
  type: 'patentExtraction';
  patents: Array<ExtractedPatent>;
};

export enum PatentExtractionStatus {
  PENDING = 'PENDING',
  ADDED = 'ADDED',
  DECLINED = 'DECLINED',
}

export type PatentFamilyMember = {
  patentOfficeCode: PatentOfficeCode;
  applicationRef: string;
  publicationNumber: string;
  kindCode: string;
};

export type PatentFieldFilter =
  | ({
      field: 'number';
    } & PatentNumberFieldFilter)
  | ({
      field: 'jurisdiction';
    } & PatentJurisdictionFieldFilter)
  | ({
      field: 'assignee';
    } & PatentAssigneeFieldFilter)
  | ({
      field: 'legalStatus';
    } & PatentLegalStatusFieldFilter)
  | ({
      field: 'filingYear';
    } & PatentFilingYearFieldFilter)
  | ({
      field: 'priorityYear';
    } & PatentPriorityYearFieldFilter)
  | ({
      field: 'publicationYear';
    } & PatentPublicationYearFieldFilter)
  | ({
      field: 'cpcSubclass';
    } & PatentCpcSubclassFieldFilter)
  | ({
      field: 'cpcGroup';
    } & PatentCpcGroupFieldFilter);

export type PatentFilingYearFieldFilter = {
  field: 'filingYear';
  operator: StringEnumFilterOperator;
  values?: Array<string>;
};

export type PatentInfo = {
  patentId: string;
  title?: string;
  countryCode: string;
  publicationDate?: string;
  priorityDate?: string;
  familyMembers: Array<FamilyMember>;
  applicants: Array<string>;
  assignees: Array<string>;
};

export type PatentIntelligenceContext = {
  productLines: Array<string>;
  businessLines: Array<string>;
  countryCodes: Array<string>;
  assignees: Array<string>;
  dateFrom?: string;
  dateTo?: string;
};

export type PatentJurisdictionFieldFilter = {
  field: 'jurisdiction';
  operator: StringEnumFilterOperator;
  values?: Array<string>;
};

export type PatentLegalStatusFieldFilter = {
  field: 'legalStatus';
  operator: StringEnumFilterOperator;
  values?: Array<string>;
};

export type PatentNumberFieldFilter = {
  field: 'number';
  operator: StringFilterOperator;
  value?: string;
};

export type PatentNumberUploadFailure = {
  patentNumber: string;
};

export type PatentNumberUploadRequest = {
  patentNumbers: Array<string>;
  folderId?: string;
};

export type PatentNumberUploadResult = {
  succeeded: Array<PatentNumberUploadSuccess>;
  failed: Array<PatentNumberUploadFailure>;
};

export type PatentNumberUploadSuccess = {
  patentNumber: string;
  fileId: string;
};

export enum PatentOfficeCode {
  EPO = 'EPO',
  USPTO = 'USPTO',
  KR = 'KR',
  JP = 'JP',
  CN = 'CN',
  DE = 'DE',
}

export type PatentOfficeConnectionByApplicationRef = {
  type: 'applicationRef';
  applicationRef: string;
};

export type PatentOfficeConnectionByPublicationNumber = {
  type: 'publicationNumber';
  publicationNumber: string;
};

export type PatentOfficeConnectionIdentifier =
  | ({
      type: 'applicationRef';
    } & PatentOfficeConnectionByApplicationRef)
  | ({
      type: 'publicationNumber';
    } & PatentOfficeConnectionByPublicationNumber);

export type PatentOfficeConnectionSpec = {
  type: 'patentOffice';
  patentOfficeCode: PatentOfficeCode;
  identifier: PatentOfficeConnectionIdentifier;
};

export type PatentOfficeFileInfo = {
  documentId: string;
  date: string;
};

export type PatentPriorityYearFieldFilter = {
  field: 'priorityYear';
  operator: StringEnumFilterOperator;
  values?: Array<string>;
};

export type PatentPublicationYearFieldFilter = {
  field: 'publicationYear';
  operator: StringEnumFilterOperator;
  values?: Array<string>;
};

export type PlaceReferenceSignItem = {
  referenceSignId: string;
  label: string;
  value: string;
};

export type PlaceReferenceSignsRequest = {
  imageFile: unknown;
  referenceSignItems: Array<PlaceReferenceSignItem>;
  contentOverride?: string;
};

export type PlaceReferenceSignsResponse = {
  markers: Array<{
    [key: string]: unknown;
  }>;
};

export type PlaceReferenceSignsV2Request = {
  imageFile: unknown;
  referenceSignItems: Array<PlaceReferenceSignItem>;
  format: ReferenceSignPlacementFormat;
  contentOverride?: string;
  promptOverrides?: Array<PromptOverride>;
};

export type PlaceReferenceSignsV2Response = {
  result: ReferenceSignPlacements;
};

export type PresignedUrl = {
  url: string;
  expiryTimestamp: string;
};

export type PreviewExternalSourceFileResponse = {
  fileId: string;
  name: string;
  mimeType: string;
  presignedUrl: PresignedUrl;
};

export type PriorArtExtractionProjectTask = Omit<ProjectTask, 'type'> & {
  type: 'priorArtExtraction';
} & {
  type: 'priorArtExtraction';
  priorArtFolderId?: string;
};

export type PriorArtFileHighlight = {
  type: 'priorArt';
  extractedPriorArtId: string;
  rawRef: string;
  priorArtFileId: string;
  boundingBoxes: Array<BoundingBox>;
};

export type ProjectAnalyticsBucket = {
  /**
   * The stored identity being counted: a resource type, an option key, a user id, a review status code or a text value.
   */
  key: string;
  count: number;
};

export type ProjectAnalyticsMonthCount = {
  /**
   * `YYYY-MM`.
   */
  month: string;
  count: number;
};

export type ProjectAnalyticsResponse = {
  projectsByType: Array<ProjectAnalyticsBucket>;
  /**
   * Months in UTC.
   */
  createdByMonth: Array<ProjectAnalyticsMonthCount>;
  createdBy: Array<ProjectAnalyticsBucket>;
  createdByOtherCount: number;
  /**
   * Left out when review status is not available to the caller.
   */
  reviewStatus?: ProjectAnalyticsReviewStatusCounts;
  customFields: Array<CustomFieldAggregate>;
  users: Array<ProjectUserInfo>;
};

export type ProjectAnalyticsReviewStatusCounts = {
  /**
   * Research projects counted.
   */
  population: number;
  /**
   * Keyed by review status code.
   */
  buckets: Array<ProjectAnalyticsBucket>;
};

export type ProjectComposePromptPreviewRequest = {
  workflow: 'project';
  projectType: ResourceType;
  overrides: Array<PromptOverride>;
};

export type ProjectCustomField = {
  fieldId: string;
  value: CustomFieldValue;
};

export type ProjectDocumentCreationRequired = {
  type: 'projectDocumentCreationRequired';
  suggestion: ChatSuggestion;
};

export type ProjectFacetsResponse = {
  facets: Array<ProjectTypeFacet>;
};

/**
 * Filters on different fields must all match. A folder matches on its own creator, creation date and custom fields.
 */
export type ProjectFilters = {
  /**
   * Lists folders, with the projects inside them left to the folder; otherwise every project is listed flat.
   */
  includeFolders: boolean;
  lastUsedAfter?: Instant;
  types: Array<ResourceType>;
  draftingModes: Array<DraftMode>;
  reviewStatuses: Array<string>;
  assigneeUserIds: Array<string>;
  unassigned: boolean;
  createdByUserIds: Array<string>;
  /**
   * Inclusive; leave one out to leave that side open.
   */
  createdFrom?: string;
  createdTo?: string;
  customFields: Array<CustomFieldFilterEntry>;
};

export type ProjectFolderDetail = {
  folderId: string;
  folderType: ResourceFolderType;
  resourceType?: ResourceType;
  name: string;
  accessType: AccessType;
  creatorId: string;
  sharedWithOrg: boolean;
  sharedWithUserCount: number;
  itemCount: number;
  total: number;
  projects: Array<ProjectListItem>;
  customFields: Array<ProjectCustomField>;
};

export type ProjectFolderInfo = {
  folderId: string;
  folderType: ResourceFolderType;
  resourceType?: ResourceType;
  name: string;
  accessType: AccessType;
  creatorId: string;
  sharedWithOrg: boolean;
  sharedWithUserCount: number;
  itemCount: number;
};

export type ProjectFoldersResponse = {
  folders: Array<ProjectFolderInfo>;
};

export type ProjectListItem = {
  resourceType: ResourceType;
  resourceId: string;
  folderId?: string;
  name: string;
  status?: ProjectStatus;
  draftingMode?: DraftMode;
  createdByUser: ProjectUserInfo;
  accessType: AccessType;
  sharedByMe: boolean;
  createdAt: Instant;
  lastUsedAt: Instant;
  review?: ProjectReview;
  customFields: Array<ProjectCustomField>;
};

export type ProjectPageOptions = {
  number: number;
  size: number;
};

export type ProjectRef = {
  resourceType: ResourceType;
  resourceId: string;
};

export type ProjectReview = {
  reviewStatus: string;
  assignees: Array<ProjectUserInfo>;
};

/**
 * Projects. No settings of their own yet.
 */
export type ProjectSettings = {
  [key: string]: unknown;
};

export enum ProjectSort {
  CREATED_AT = 'CREATED_AT',
  LAST_USED_AT = 'LAST_USED_AT',
  NAME = 'NAME',
  TYPE = 'TYPE',
}

export type ProjectSortOptions = {
  by: ProjectSort;
  order: SortOrder;
};

export enum ProjectStatus {
  DRAFT = 'DRAFT',
  DISCOVERING_FILES = 'DISCOVERING_FILES',
  AWAITING_ANALYSIS = 'AWAITING_ANALYSIS',
  QUEUED = 'QUEUED',
  PROCESSING_FILES = 'PROCESSING_FILES',
  SUMMARISE = 'SUMMARISE',
  PROCESSING_OBJECTION = 'PROCESSING_OBJECTION',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}

export type ProjectTask = {
  id: string;
  status: ProjectTaskStatus;
  createdAt: Instant;
  /**
   * Discriminator property for ProjectTask.
   */
  type: string;
};

export enum ProjectTaskStatus {
  QUEUED = 'QUEUED',
  PROCESSING = 'PROCESSING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}

export type ProjectTypeFacet = {
  resourceType: ResourceType;
  draftingModes?: Array<DraftMode>;
  count: number;
};

export type ProjectUserInfo = {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
};

export type PromptOverride = {
  kind: PromptOverrideKind;
  path: string;
  content: string;
};

export enum PromptOverrideKind {
  PROMPT = 'PROMPT',
  SKILL = 'SKILL',
}

export type PublicationHighlight = {
  type: 'publicationHighlight';
  resultId: string;
};

export type PublicationTrackerContext = {
  reportId?: string;
  dataTableId?: string;
  isReviewed?: boolean;
  isRelevant?: boolean;
  stars: Array<number>;
  tagFilters: Array<TagFilter>;
};

export type PutContentRequest = {
  content: string;
};

export type PutContentResponse = {
  content: string;
};

export type PutPatentDraftCustomInstructionsIdRequest = {
  customInstructionsId?: string;
};

export type PutPatentDraftDraftingModeRequest = {
  patentDraftId: string;
  draftingMode: DraftMode;
};

export type PutPatentDraftInventionDescriptionRequest = {
  patentDraftId: string;
  inventionDescription: string;
};

export type PutPatentDraftJurisdictionRequest = {
  patentDraftId: string;
  jurisdiction: PatentDraftJurisdiction;
};

export type PutPatentDraftLanguageRequest = {
  patentDraftId: string;
  language: PatentDraftLanguage;
};

export type PutPatentDraftNameRequest = {
  patentDraftId: string;
  name: string;
};

export type PutPatentDraftReferencePatentIdsRequest = {
  patentDraftId: string;
  referencePatentIds: Array<string>;
};

export type PutReferenceSignValueRequest = {
  referenceSignId: string;
  value: string;
};

export type PutSigmaSearchQueryRequest = {
  query: SigmaSearchCondition;
};

export type PutTemplateRequest = {
  templateId?: string;
};

export type QueryProjectAnalyticsRequest = {
  filters: ProjectFilters;
};

export type QueryProjectFacetsRequest = {
  search?: string;
  filters: ProjectFilters;
  folderId?: string;
};

export type QueryProjectsRequest = {
  search?: string;
  filters: ProjectFilters;
  sort: ProjectSortOptions;
  page: ProjectPageOptions;
};

export type ReferenceFile = {
  fileId: string;
  fileName: string;
};

export type ReferencePatentEntry =
  | ({
      type: 'PATENT_ID';
    } & ReferencePatentIdEntry)
  | ({
      type: 'FILE';
    } & ReferencePatentFileEntry);

export type ReferencePatentFileEntry = {
  type: 'FILE';
  fileId: string;
};

export type ReferencePatentIdEntry = {
  type: 'PATENT_ID';
  patentId: string;
};

export enum ReferenceSignArrowHead {
  NONE = 'none',
  END = 'end',
}

export type ReferenceSignDeleteSuggestion = {
  type: 'referenceSignDeleteSuggestion';
  deletes: Array<ResolvedDelete>;
};

export type ReferenceSignDetails = {
  referenceSignId: string;
  label: string;
  value: string;
  figureIds: Array<string>;
};

export type ReferenceSignFigureLinkRequest = {
  referenceSignId: string;
  figureId: string;
};

export enum ReferenceSignPlacementFormat {
  MARKER_JS = 'MARKER_JS',
  DRAWIO = 'DRAWIO',
}

export type ReferenceSignPlacements =
  | ({
      type: 'markerJs';
    } & MarkerJsReferenceSignPlacements)
  | ({
      type: 'drawio';
    } & DrawioReferenceSignPlacements);

export type ReferenceSignSuggestion = {
  type: 'referenceSignSuggestion';
  signs: Array<GeneratedReferenceSign>;
};

export type ReferenceSignUpdateSuggestion = {
  type: 'referenceSignUpdateSuggestion';
  updates: Array<ResolvedUpdate>;
};

export type ReferenceSignsResponse = {
  referenceSigns: Array<ReferenceSignDetails>;
};

export type RegisterSetupFile = {
  type: 'register';
  documentId: string;
};

export enum ReleaseTrack {
  INTERNAL = 'INTERNAL',
  CANARY = 'CANARY',
  STABLE = 'STABLE',
}

export type RemoveResourceAccess = {
  type: 'remove';
};

export type RenderCompoundCdxmlInput = {
  type: 'cdxml';
  value: string;
};

export type RenderCompoundInput =
  | ({
      type: 'smiles';
    } & RenderCompoundSmilesInput)
  | ({
      type: 'mol';
    } & RenderCompoundMolInput)
  | ({
      type: 'cdxml';
    } & RenderCompoundCdxmlInput);

export type RenderCompoundMolInput = {
  type: 'mol';
  value: string;
};

export type RenderCompoundRequest = {
  compound: RenderCompoundInput;
};

export type RenderCompoundResponse = {
  svg: string;
};

export type RenderCompoundSmilesInput = {
  type: 'smiles';
  value: string;
};

export type ReorderFiguresRequest = {
  orderedFigureIds: Array<string>;
};

export type ResolveIdentifiersRequest = {
  identifierType: ChemistryIdentifierType;
  identifiers: Array<string>;
};

export type ResolveIdentifiersResponse = {
  resolved: {
    [key: string]: unknown;
  };
  failed: {
    [key: string]: unknown;
  };
};

export type ResolvedDelete = {
  referenceSignId: string;
  label: string;
  value: string;
  figureIds: Array<string>;
};

export type ResolvedUpdate = {
  referenceSignId: string;
  currentLabel: string;
  currentValue: string;
  currentFigureIds: Array<string>;
  newLabel: string;
  newValue: string;
  newFigureIds: Array<string>;
  addFigureIds: Array<string>;
  removeFigureIds: Array<string>;
};

export type ResourceAccessUpdate = {
  resourceType: ResourceType;
  resourceId: string;
  user_id: string;
  update: ResourceAccessUpdateDetails;
};

export type ResourceAccessUpdateDetails =
  | ({
      type: 'modify';
    } & ModifyResourceAccess)
  | ({
      type: 'remove';
    } & RemoveResourceAccess);

export type ResourceFolderMetadata = {
  folderId: string;
  folderType: ResourceFolderType;
  resourceType?: ResourceType;
  name: string;
  accessType: AccessType;
  creatorId: string;
  sharedWithOrg: boolean;
  sharedWithUserCount: number;
  itemCount: number;
};

export enum ResourceFolderType {
  KNOWLEDGE_FOLDER = 'KNOWLEDGE_FOLDER',
  PROJECT_FOLDER = 'PROJECT_FOLDER',
}

export type ResourceKnowledgeItem = {
  id: string;
  name: string;
  sharedWithOrg: boolean;
  accessType: AccessType;
  description: string;
  isCreator: boolean;
};

export type ResourceKnowledgeLink = {
  id: string;
};

export enum ResourceType {
  FTO = 'FTO',
  INFRINGEMENT_DETECTION = 'INFRINGEMENT_DETECTION',
  INVENTION_DISCLOSURE = 'INVENTION_DISCLOSURE',
  INVENTION_DISCLOSURE_ANALYSIS_RUN = 'INVENTION_DISCLOSURE_ANALYSIS_RUN',
  AI_SEARCH = 'AI_SEARCH',
  AI_SEARCH_QUERY = 'AI_SEARCH_QUERY',
  PROJECT = 'PROJECT',
  PATENT_DRAFT = 'PATENT_DRAFT',
  FTO_CHEMICAL = 'FTO_CHEMICAL',
  PUBLICATION_TRACKER_TOPIC = 'PUBLICATION_TRACKER_TOPIC',
  PUBLICATION_TRACKER_REPORT_V2 = 'PUBLICATION_TRACKER_REPORT_V2',
  OFFICE_ACTION = 'OFFICE_ACTION',
  OFFICE_ACTION_2 = 'OFFICE_ACTION_2',
  TEMPLATE = 'TEMPLATE',
  LITIGATION_ASSISTANT = 'LITIGATION_ASSISTANT',
  LITIGATION_SEARCH = 'LITIGATION_SEARCH',
  PATENT_INTELLIGENCE = 'PATENT_INTELLIGENCE',
  NOVELTY_ANALYSIS = 'NOVELTY_ANALYSIS',
  KNOWLEDGE = 'KNOWLEDGE',
  RESOURCE_FOLDER = 'RESOURCE_FOLDER',
  GENERAL_ASSISTANT = 'GENERAL_ASSISTANT',
  INVENTION_ASSISTANT = 'INVENTION_ASSISTANT',
  SIGMA_SEARCH = 'SIGMA_SEARCH',
  DOCUMENT = 'DOCUMENT',
  FORM = 'FORM',
}

export type Resuming = {
  type: 'resuming';
};

export type ReviewAssigneeUpdate = {
  userIds: Array<string>;
};

export type ReviewChatSuggestionRequest = {
  decision: ChatSuggestionDecision;
  payload?: ChatSuggestionReviewPayload;
};

export type ReviewChatSuggestionResponse = {
  suggestion: ChatSuggestion;
  result: ChatSuggestionReviewResult;
};

export type ReviewDataTableCellsRequest = {
  reviews: Array<DataTableCellReview>;
  columnReviews?: Array<DataTableColumnReview>;
};

export type ReviewExtractedPatentFailure = {
  patentExtractionItemId: string;
};

export type ReviewExtractedPatentResult = {
  succeeded: Array<ReviewExtractedPatentSuccess>;
  failed: Array<ReviewExtractedPatentFailure>;
};

export type ReviewExtractedPatentSuccess = {
  patentExtractionItemId: string;
  fileId: string;
};

export type ReviewKnowledgeEventResponse = {
  knowledgeId?: string;
};

export type RichTextCellValue = {
  type: 'richText';
  value?: string;
};

export type RoleOverviewEntry = {
  role: UserRole;
  availableProviders: Array<ModelProvider>;
  activeProvider: ModelProvider;
  isOverride: boolean;
};

export type SaveFigureRequest = {
  file: unknown;
  fileName: string;
  newAnnotationState?: {
    [key: string]: unknown;
  };
  existingFigureId?: string;
  newBaseTempFileId?: string;
  imageStyle?: ImageStyle;
  metadata?: FigureMetadata;
  /**
   * The latestFileId the editor loaded. Only valid with existingFigureId.
   */
  expectedLatestFileId?: string;
};

export type SaveFormAnswersRequest = {
  answers: Array<FormAnswerEntry>;
};

export type SaveFormTemplateRequest = {
  title: string;
  description?: string;
  resourceType: ResourceType;
  definition: FormDefinition;
};

export type SaveFromChatDataTableRequest = {
  name?: string;
  tableId: string;
  /**
   * @deprecated
   */
  owner?: DataTableOwner;
};

export type SaveFromChatDataTableResponse = {
  tableId: string;
};

export type SaveTableTemplateRequest = {
  sourceTableId: string;
  title: string;
  description?: string;
  sharedWithOrg?: boolean;
};

export type SearchExternalSourceItemsResponse = {
  results: Array<ExternalSourceSearchResult>;
  nextPageToken?: string;
};

export type SearchFeatureColumnSource = {
  type: 'searchFeature';
};

export type SearchSuggestionDetail = {
  searchSuggestionId: string;
  features: Array<string>;
  status: SearchSuggestionStatus;
};

export type SearchSuggestionEvent = {
  type: 'searchSuggestion';
  searchSuggestionId: string;
  features: Array<string>;
  status: SearchSuggestionStatus;
};

export enum SearchSuggestionReviewAction {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
}

export enum SearchSuggestionStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

/**
 * A project with several options selected counts once for each.
 */
export type SelectFieldAggregate = {
  definition: CustomFieldDefinition;
  /**
   * The type the field belongs to. RESOURCE_FOLDER fields count each project under the value of the folder it is filed in.
   */
  resourceType: ResourceType;
  /**
   * Projects counted: those of `resourceType`, or every project for a RESOURCE_FOLDER field.
   */
  population: number;
  /**
   * How many of `population` have a value.
   */
  filled: number;
  type: 'select';
  buckets: Array<ProjectAnalyticsBucket>;
};

export type SelectFieldFilter = {
  type: 'select';
  optionKeys: Array<string>;
};

export type SelectFieldType = {
  type: 'select';
  options: Array<CustomFieldOption>;
  allowMultiple: boolean;
};

export type SelectFieldValue = {
  type: 'select';
  values: Array<string>;
};

export type Sequence = {
  type: 'sequence';
  sequence: AssistantChatMessageSequence;
};

export type SequenceAlignment = {
  type: 'alignment';
  alignment: ChatAlignment;
};

export enum SequenceAnalysisOption {
  ANTIBODY_KABAT = 'ANTIBODY_KABAT',
  ANTIBODY_IMGT = 'ANTIBODY_IMGT',
  ANTIBODY_CHOTHIA = 'ANTIBODY_CHOTHIA',
  ANTIBODY_MARTIN = 'ANTIBODY_MARTIN',
}

export type SequenceCitation = Omit<CitationV2, 'type'> & {
  type: 'sequence';
} & {
  type: 'sequence';
  region?: string;
};

export type SequenceFeature = {
  key: string;
  location: string;
  qualifiers: Array<SequenceFeatureQualifier>;
};

export type SequenceFeatureQualifier = {
  name: string;
  value: string;
};

export type SequenceInfo = {
  id: string;
  seqNoId: number;
  name: string;
  molType: MolType;
  sequence: string;
  annotatedSequence?: string;
  sequenceLength: number;
  featureTable: Array<SequenceFeature>;
};

export enum SequenceMolTypeCategory {
  DNA = 'DNA',
  RNA = 'RNA',
  AA = 'AA',
}

export type SetExternalSourceCredentialsRequest = {
  organizationId: string;
  credentials: ExternalSourceCredentials;
  expiresInDays?: number;
};

export type SetModelProviderOverrideRequest = {
  orgRole: UserRole;
  modelProvider: ModelProvider;
};

export type Settings = {
  /**
   * Research Projects
   *
   * Portfolio workspace for managing research projects end to end.
   */
  researchProjects?: ProjectSettings;
  /**
   * IP Projects
   *
   * Portfolio workspace for managing patent projects end to end.
   */
  ipProjects?: ProjectSettings;
  /**
   * Office Actions
   *
   * Respond to office actions.
   */
  officeActions?: OfficeActionSettings;
  /**
   * [Deprecated] Patent Drafting (Default)
   *
   * Draft patent applications.
   */
  patentDraft?: PatentDraftSettings;
  /**
   * [Deprecated] Patent Drafting (Life Sciences)
   *
   * Draft chemical and life science patent applications.
   */
  chemicalDraft?: ChemicalPatentDraftSettings;
};

export type SetupFile =
  | ({
      type: 'register';
    } & RegisterSetupFile)
  | ({
      type: 'upload';
    } & UploadSetupFile);

export type SetupFolderSpec = {
  name: string;
  extractPriorArt: boolean;
  files: Array<SetupFile>;
};

export type SetupOfficeActionRequest = {
  setup: OfficeActionSetupSpec;
  files?: Array<unknown>;
};

export type SetupOfficeActionResponse = {
  id: string;
  failedDocumentIds: Array<string>;
};

export type SharepointExternalSourceAuthConfig = {
  type: 'sharepoint';
  clientId: string;
  scopes: string;
  entraTenantId: string;
};

export type SharepointExternalSourceConfig = {
  type: 'sharepoint';
  entraTenantId: string;
  sharepointHost: string;
  sites: Array<SharepointExternalSourceSite>;
};

export type SharepointExternalSourceSite = {
  id: string;
  access: ExternalSourceAccessLevel;
};

export type SheetDescription = {
  name: string;
  hidden: boolean;
  columns: Array<string>;
  hasHeader: boolean;
};

export type SigmaSearchCondition =
  | ({
      type: 'and';
    } & AndSearchCondition)
  | ({
      type: 'or';
    } & OrSearchCondition)
  | ({
      type: 'not';
    } & NotSearchCondition)
  | ({
      type: 'field';
    } & FieldSearchCondition);

export type SigmaSearchDetail = {
  id: string;
  title: string;
  state: SigmaSearchState;
  createdAt: Instant;
  context: string;
  query?: SigmaSearchCondition;
};

export enum SigmaSearchQueryField {
  TITLE = 'TITLE',
  ABSTRACT = 'ABSTRACT',
  DESCRIPTION = 'DESCRIPTION',
  CLAIMS = 'CLAIMS',
}

export enum SigmaSearchState {
  DRAFT = 'DRAFT',
  VALIDATING = 'VALIDATING',
  CALIBRATED = 'CALIBRATED',
  RUNNING = 'RUNNING',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
}

export type SigmaSearchSummary = {
  id: string;
  title: string;
  state: SigmaSearchState;
  createdAt: Instant;
};

export type SingleSuggestionReviewedEvent = Omit<SuggestionReviewedEvent, 'type'> & {
  type: 'single';
} & {
  type: 'single';
};

export type SnippetContext = {
  text: string;
  documentId: string;
  sectionRef?: string;
};

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SourceRange = {
  type: 'sourceRange';
  documentId: string;
  startTagId: string;
  endTagId: string;
  kind: SourceRangeKind;
};

export enum SourceRangeKind {
  CLAIMS = 'CLAIMS',
}

export type StaticFile = {
  id: string;
  title: string;
  type: StaticFileType;
};

export type StaticFileCitation = Omit<CitationV2, 'type'> & {
  type: 'staticFile';
} & {
  type: 'staticFile';
  staticFileType: StaticFileType;
  boundingBox: Array<BoundingBox>;
};

export enum StaticFileType {
  EPO_GUIDELINES = 'EPO_GUIDELINES',
  CASE_LAW = 'CASE_LAW',
  MPEP_GUIDELINES = 'MPEP_GUIDELINES',
  MPEP_SUPPLEMENTS = 'MPEP_SUPPLEMENTS',
}

export type StaticMolTypeSelector = {
  type: 'static';
  molType: MolType;
};

export type StaticOrganismSelector = {
  type: 'static';
  organism: string;
};

export type StaticOrientationSelector = {
  type: 'static';
  orientation: Orientation;
};

export type StringChartValue = {
  type: 'string';
  value: string;
};

export type StringColumnFilter = {
  type: 'string';
  columnId: string;
  operator: StringFilterOperator;
  value?: string;
};

export type StringColumnType = {
  type: 'string';
};

export type StringEnumCellValue = {
  type: 'stringEnum';
  values?: Array<string>;
  /**
   * @deprecated
   */
  value?: string;
};

export type StringEnumColumnFilter = {
  type: 'stringEnum';
  columnId: string;
  operator: StringEnumFilterOperator;
  values?: Array<string>;
};

export type StringEnumColumnType = {
  type: 'stringEnum';
  options: Array<StringEnumOption>;
  allowMultiple?: boolean;
};

export enum StringEnumFilterOperator {
  ANY_OF = 'ANY_OF',
  NONE_OF = 'NONE_OF',
  IS_EMPTY = 'IS_EMPTY',
  IS_NOT_EMPTY = 'IS_NOT_EMPTY',
}

export type StringEnumOption = {
  value: string;
  displayValue?: string;
  displayColour: DisplayColour;
};

export enum StringFilterOperator {
  CONTAINS = 'CONTAINS',
  NOT_CONTAINS = 'NOT_CONTAINS',
  STARTS_WITH = 'STARTS_WITH',
  ENDS_WITH = 'ENDS_WITH',
  IS_EMPTY = 'IS_EMPTY',
  IS_NOT_EMPTY = 'IS_NOT_EMPTY',
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
}

export type StructField = {
  key: string;
  columnType: ColumnType;
  instructions?: string;
};

export type StructListCellValue = {
  type: 'structList';
  rows?: Array<{
    [key: string]: unknown;
  }>;
};

export type StructListColumnType = {
  type: 'structList';
  fields: Array<StructField>;
};

export type SuggestedExternalFile = {
  fileId: string;
  name: string;
  linkedFolderId?: string;
  modifiedAt?: Instant;
  size?: number;
  mimeType?: string;
};

export type SuggestedPrompts = {
  type: 'suggestedPrompts';
  prompts: Array<string>;
};

export enum SuggestionReviewAction {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export type SuggestionReviewedEvent = {
  suggestionType: AiSuggestionType;
  action: SuggestionReviewAction;
  /**
   * Discriminator property for SuggestionReviewedEvent.
   */
  type: string;
};

export enum TableBlockType {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
}

export type TableColumnAddedEvent = {
  type: 'tableColumnAdded';
  column: DataTableSchemaColumn;
};

export type TableRowsAddedEvent = {
  type: 'tableRowsAdded';
  rows: Array<DataTableRow>;
};

export type TableRowsEvent = {
  type: 'tableRows';
  rows: Array<TableRowsEventRow>;
};

export type TableRowsEventRow = {
  cells: Array<DataTableCell>;
};

export type TableRowsReplacedEvent = {
  type: 'tableRowsUpdated';
  rows: Array<DataTableRow>;
};

export type TableSchema = {
  tableId: string;
  name: string;
  columns: Array<DataTableSchemaColumn>;
};

export type TableUpdateStart = {
  tableId: string;
  name: string;
  columnIds: Array<string>;
  rowIds: Array<string>;
  replaceExisting: boolean;
};

export type TagEdit = {
  info: EditableDocumentInfo;
  editType: EditType;
  text: string;
  type: 'tag';
  tagId: string;
};

export type TagEditLocation = {
  type: 'tag';
  tagId: string;
  documentId: string;
  documentName: string;
  editType: EditType;
};

export type TagFilter = {
  tagId: string;
  values: Array<string>;
};

export type TagRangeEdit = {
  info: EditableDocumentInfo;
  editType: EditType;
  text: string;
  type: 'tag_range';
  startTagId: string;
  endTagId: string;
};

export type TagRangeEditLocation = {
  type: 'tag_range';
  startTagId: string;
  endTagId: string;
  documentId: string;
  documentName: string;
  editType: EditType;
};

export type TemplateContent = FormTemplateContent;

export type TemplateInfo = {
  id: string;
  title: string;
  description?: string;
  documentId?: string;
  templateType: TemplateType;
  jurisdiction?: Jurisdiction;
  language?: Language;
  userId?: string;
  sharedWithOrg: boolean;
  sharedWithUsers: boolean;
  isMigrated: boolean;
  owner: TemplateOwner;
  accessType: AccessType;
  isCreator: boolean;
  createdBy?: BaseUser;
  tableColumns?: Array<DataTableSchemaColumn>;
  content?: TemplateContent;
};

export enum TemplateOwner {
  PLATFORM = 'PLATFORM',
  USER = 'USER',
}

export enum TemplateType {
  RESPONSE_LETTER = 'RESPONSE_LETTER',
  CLIENT_RESPONSE_LETTER = 'CLIENT_RESPONSE_LETTER',
  STRATEGY_DOCUMENT = 'STRATEGY_DOCUMENT',
  FOREIGN_ATTORNEY_INSTRUCTIONS = 'FOREIGN_ATTORNEY_INSTRUCTIONS',
  CLAIMS = 'CLAIMS',
  DESCRIPTION = 'DESCRIPTION',
  DISCLOSURE = 'DISCLOSURE',
  PROJECT = 'PROJECT',
  MECHANICAL_DRAFT = 'MECHANICAL_DRAFT',
  CHEMICAL_DRAFT = 'CHEMICAL_DRAFT',
  TABLE = 'TABLE',
  FORM = 'FORM',
}

export type TextContent = {
  type: 'textContent';
  location: TextEventLocation;
  content: string;
  tagId?: string;
  editType?: EditType;
};

export enum TextEventLocation {
  CHAT = 'CHAT',
  DOCUMENT = 'DOCUMENT',
}

export type TextFieldAggregate = {
  definition: CustomFieldDefinition;
  /**
   * The type the field belongs to. RESOURCE_FOLDER fields count each project under the value of the folder it is filed in.
   */
  resourceType: ResourceType;
  /**
   * Projects counted: those of `resourceType`, or every project for a RESOURCE_FOLDER field.
   */
  population: number;
  /**
   * How many of `population` have a value.
   */
  filled: number;
  type: 'text';
  buckets: Array<ProjectAnalyticsBucket>;
  otherCount: number;
};

export type TextFieldFilter = {
  type: 'text';
  contains: string;
};

export type TextFieldType = {
  type: 'text';
  /**
   * Rejects a value already used by another resource in the organisation, ignoring case and surrounding whitespace.
   */
  unique: boolean;
};

export type TextFieldValue = {
  type: 'text';
  value?: string;
};

export type TextFormField = {
  type: 'text';
  key: string;
  label: string;
  description?: string;
  placeholder?: string;
  required: boolean;
  requiredWhen?: FormCondition;
  visibleWhen?: FormCondition;
  prefill?: AiPrefill;
  multiline: boolean;
  maxLength?: number;
  pattern?: string;
};

export type TextMessageBlock = {
  type: 'textV2';
  text: string;
  citations: Array<CitationDetails>;
};

export type TextValue = {
  type: 'text';
  value: string;
};

export type ThinkingStatus = {
  type: 'thinkingStatus';
  content: string;
};

export type UpdateCompoundRequest = {
  smiles: string;
  molStructure: string;
  compoundName?: string;
  compoundAlias?: string;
  description?: string;
  status?: CompoundStatus;
  sourceCdxml?: string;
};

export type UpdateCompoundRequestV2 = {
  compoundName?: string;
  compoundAlias?: string;
  description?: string;
  status?: CompoundStatus;
  sourceCdxml?: string;
};

export type UpdateCustomFieldValuesRequest = {
  fields: Array<ProjectCustomField>;
};

export type UpdateDataTableChartRequest = {
  chartSpec: DataTableChartSpec;
  filterSpec?: DataTableChartFilterSpec;
  position: number;
};

export type UpdateDataTableChartViewRequest = {
  chartOrder: Array<string>;
};

export type UpdateDataTableRequest = {
  name?: string;
  schema?: DataTableSchemaUpdate;
  newRows?: Array<NewDataTableRow>;
  updateRows?: Array<UpdateDataTableRow>;
  deleteRowIds?: Array<string>;
};

export type UpdateDataTableRow = {
  rowId: string;
  cells: Array<DataTableCell>;
};

export type UpdateDocumentMetadataRequest = {
  name: string;
};

export type UpdateDocumentMetadataResponse = {
  documentId: string;
};

export type UpdateExternalSourceRequest = {
  organizationId: string;
  config: ExternalSourceConfig;
};

export type UpdateExternalSourceResponse = {
  source: ExternalSourceDetails;
};

export type UpdateFigureInfoRequest = {
  name: string;
};

export type UpdateFileInfoRequest = {
  name?: string;
  summary?: string;
};

export type UpdateFolderItemsRequest = {
  items: Array<FolderItemRef>;
};

export type UpdateGeneralAssistantRequest = {
  name: string;
  description?: string;
  language?: Language;
};

export type UpdateInventionAssistantRequest = {
  name: string;
  language?: Language;
};

export type UpdateItemFolderRequest = {
  name: string;
  index: number;
};

export type UpdateKnowledgeActiveRequest = {
  resourceType: ResourceType;
  resourceId: string;
  value: boolean;
};

export type UpdateKnowledgeAutoLoadRequest = {
  shouldAutoLoad: boolean;
  resourceType?: ResourceType;
  resourceId?: string;
};

export type UpdateKnowledgeFolderItemsRequest = {
  knowledgeIds: Array<string>;
};

export type UpdateKnowledgeFolderRequest = {
  name?: string;
  sharedWithOrg?: boolean;
};

export type UpdateKnowledgeRequest = {
  name?: string;
  description?: string;
  content?: string;
  referenceFileIds?: Array<string>;
  shareWithOrg?: boolean;
  forceActive?: boolean;
  folderId?: string;
};

export type UpdateNoveltyAnalysisRequest = {
  name?: string;
};

export type UpdateObjectionStatusRequest = {
  status: OfficeActionObjectionState;
  objectionIds: Array<string>;
};

export type UpdateOrgFeatureFlagOverrideRequest = {
  overrides: {
    [key: string]: unknown;
  };
};

export type UpdatePatentDraftFileInfoRequest = {
  name: string;
};

export type UpdateProjectFolderItemsRequest = {
  projects: Array<ProjectRef>;
};

export type UpdateProjectFolderRequest = {
  name?: string;
  sharedWithOrg?: boolean;
};

export type UpdateProjectReviewRequest = {
  reviewStatus?: string;
  assignees?: ReviewAssigneeUpdate;
};

export type UpdateResourceAccessRequest = {
  updates: Array<ResourceAccessUpdate>;
};

export type UpdateSequenceRequest = {
  seqNoId?: number;
  name?: string;
  molType?: MolType;
  sequence?: string;
  featureTable?: Array<SequenceFeature>;
};

export type UpdateSettingsRequest = {
  changes: Array<AdminSettingUpdate>;
};

export type UpdateSigmaSearchRequest = {
  title?: string;
  context?: string;
};

export type UpdateTemplateRequest = {
  title?: string;
  description?: string;
  sharedWithOrg?: boolean;
};

export type UpdateUserFeatureFlagOverrideRequest = {
  overrides: {
    [key: string]: unknown;
  };
};

export type UploadSetupFile = {
  type: 'upload';
  uploadIndex: number;
};

export type UploadTemporaryFileRequest = {
  file: unknown;
};

export type UploadTemporaryFileResponse = {
  temporaryFileId: string;
  temporaryFileUrl: PresignedUrl;
};

export type UploadedFormExportFile = {
  type: 'uploaded';
  fileId: string;
  name: string;
};

export type UpsertKnowledgeRequest = {
  name: string;
  description: string;
  content: string;
  resourceType: ResourceType;
  shareWithOrg: boolean;
  forceActive?: boolean;
  referenceFileIds?: Array<string>;
  folderId?: string;
};

export type UserAccess = {
  userId: string;
  accessType?: AccessType;
};

export type UserChatMessageInfo = {
  type: 'user';
  chatId: string;
  timestamp: string;
  content: string;
  selectionContext?: string;
  promptId?: string;
  linkedResourceInfos: Array<LinkedResourceMessageInfo>;
  userContext?: Array<UserContext>;
};

export type UserConfirmationRequired = {
  type: 'userConfirmationRequired';
  confirmationType: UserConfirmationType;
};

export enum UserConfirmationType {
  PLAN_CREATION = 'PLAN_CREATION',
}

export type UserContext =
  | ({
      type: 'document';
    } & DocumentSelectionUserContext)
  | ({
      type: 'dataTable';
    } & WriteDataTableUserContext)
  | ({
      type: 'dataTableRow';
    } & DataTableRowUserContext)
  | ({
      type: 'form';
    } & FormUserContext);

/**
 * A project with several users counts once for each.
 */
export type UserFieldAggregate = {
  definition: CustomFieldDefinition;
  /**
   * The type the field belongs to. RESOURCE_FOLDER fields count each project under the value of the folder it is filed in.
   */
  resourceType: ResourceType;
  /**
   * Projects counted: those of `resourceType`, or every project for a RESOURCE_FOLDER field.
   */
  population: number;
  /**
   * How many of `population` have a value.
   */
  filled: number;
  type: 'user';
  buckets: Array<ProjectAnalyticsBucket>;
  otherCount: number;
};

export type UserFieldFilter = {
  type: 'user';
  userIds: Array<string>;
};

export type UserFieldType = {
  type: 'user';
  allowMultiple: boolean;
};

export type UserFieldValue = {
  type: 'user';
  userIds: Array<string>;
  users: Array<ProjectUserInfo>;
};

export type UserMappingExportValue = {
  type: 'user_mapping';
  fieldId: string;
  source: ExportUserSource;
  userIdMap: {
    [key: string]: unknown;
  };
  fallbackUserId: string;
};

export type UserPermission = {
  userId: string;
  username: string;
  firstName?: string;
  lastName?: string;
  userEmail: string;
  accessType: AccessType;
};

export type UserPrompt = {
  type: 'userPrompt';
  prompt: string;
  promptId?: string;
};

export enum UserRole {
  AI_SEARCH = 'AI_SEARCH',
  ORG_ADMIN = 'ORG_ADMIN',
  DEVELOPER_ADMIN = 'DEVELOPER_ADMIN',
  INFRINGEMENT_DETECTION = 'INFRINGEMENT_DETECTION',
  INVENTION_DISCLOSURE = 'INVENTION_DISCLOSURE',
  FTO = 'FTO',
  CHEMISTRY = 'CHEMISTRY',
  FTO_CHEMICAL = 'FTO_CHEMICAL',
  DEVELOPER = 'DEVELOPER',
  PATENT_DRAFT = 'PATENT_DRAFT',
  PATENT_DRAFT_WORD_IMPORT = 'PATENT_DRAFT_WORD_IMPORT',
  IMAGE_GENERATION = 'IMAGE_GENERATION',
  IMAGE_GENERATION_V2 = 'IMAGE_GENERATION_V2',
  AI_SEARCH_QUERY = 'AI_SEARCH_QUERY',
  PUBLICATION_TRACKER = 'PUBLICATION_TRACKER',
  CHEMICAL_DRAFT = 'CHEMICAL_DRAFT',
  DISCLOSURE_DRAFT = 'DISCLOSURE_DRAFT',
  OFFICE_ACTION = 'OFFICE_ACTION',
  MILETUS = 'MILETUS',
  ORG_CUSTOM_INSTRUCTION = 'ORG_CUSTOM_INSTRUCTION',
  LITIGATION_ASSISTANT = 'LITIGATION_ASSISTANT',
  DICTATION = 'DICTATION',
  GENERAL_ASSISTANT = 'GENERAL_ASSISTANT',
  INVENTION_ASSISTANT = 'INVENTION_ASSISTANT',
  KNOWLEDGE_ADMIN = 'KNOWLEDGE_ADMIN',
}

export type UsersFormField = {
  type: 'users';
  key: string;
  label: string;
  description?: string;
  placeholder?: string;
  required: boolean;
  requiredWhen?: FormCondition;
  visibleWhen?: FormCondition;
  prefill?: AiPrefill;
  multiple: boolean;
  options: Array<FormUserOption>;
};

export type UsersValue = {
  type: 'users';
  userIds: Array<string>;
};

export type Uspto101File = {
  id: string;
  title: string;
  type: Uspto101FileType;
};

export type Uspto101FileCitation = Omit<CitationV2, 'type'> & {
  type: 'uspto101File';
} & {
  type: 'uspto101File';
  uspto101FileType: Uspto101FileType;
  boundingBox: Array<BoundingBox>;
};

export enum Uspto101FileType {
  EXAMPLE = 'EXAMPLE',
  RULES = 'RULES',
}

export type ViewDataTableChartsRequest = {
  chartIds?: Array<string>;
};

export type ViewDataTableChartsResponse = {
  tableId: string;
  charts: Array<DataTableChartDetail>;
};

export type WorkflowFilesResponse = {
  files: Array<FileInfo>;
};

export type WriteDataTableUserContext = {
  type: 'dataTable';
  dataTableId: string;
  columnIds: Array<string>;
  rowIds?: Array<string>;
  regenerate?: boolean;
};

export type WriteDocumentRequest = {
  content: string;
};

export type Instant = string;

export type ChatServiceCommonPathParamsResourceId = string;

export type ChatServiceCommonPathParamsResourceType = ResourceType;

export type DocumentServiceCommonPathParams = ResourceType;

export type DocumentServiceCommonPathParamsWithDocumentIdResourceType = ResourceType;

export type DocumentServiceCommonPathParamsWithDocumentIdStoredDocumentId = string;

export type FigureGenerationServiceCommonPathParamsResourceId = string;

export type FigureGenerationServiceCommonPathParamsResourceType = ResourceType;

export type FigureServiceCommonPathParamsResourceId = string;

export type FigureServiceCommonPathParamsResourceType = ResourceType;

export type GlossaryServiceGlossaryPathParamsResourceId = string;

export type GlossaryServiceGlossaryPathParamsResourceType = ResourceType;

export type ItemFolderServiceCommonPathParamsResourceId = string;

export type ItemFolderServiceCommonPathParamsResourceType = ResourceType;

export type KnowledgeServiceResourceKnowledgePathParamsResourceId = string;

export type KnowledgeServiceResourceKnowledgePathParamsResourceType = ResourceType;

export type ReferenceSignServiceCommonPathParamsResourceId = string;

export type ReferenceSignServiceCommonPathParamsResourceType = ResourceType;

export type ResourcePathParamsResourceId = string;

export type ResourcePathParamsResourceType = ResourceType;

export type SequenceServiceCommonPathParamsResourceId = string;

export type SequenceServiceCommonPathParamsResourceType = ResourceType;

export type ResourceAccessUpdateResourceAccessData = {
  body: UpdateResourceAccessRequest;
  path?: never;
  query?: never;
  url: '/access';
};

export type ResourceAccessUpdateResourceAccessResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type ResourceAccessUpdateResourceAccessResponse =
  ResourceAccessUpdateResourceAccessResponses[keyof ResourceAccessUpdateResourceAccessResponses];

export type ResourceAccessEffectiveAccessData = {
  body: EffectiveAccessRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/access/{resourceType}/{resourceId}/effective';
};

export type ResourceAccessEffectiveAccessResponses = {
  /**
   * The request has succeeded.
   */
  200: EffectiveAccessResponse;
};

export type ResourceAccessEffectiveAccessResponse =
  ResourceAccessEffectiveAccessResponses[keyof ResourceAccessEffectiveAccessResponses];

export type GetAdminFeatureFlagsData = {
  body?: never;
  path?: never;
  query?: {
    'flag-key'?: Array<string>;
    'organization-id'?: string;
    'user-id'?: string;
  };
  url: '/admin/feature-flag';
};

export type GetAdminFeatureFlagsResponses = {
  /**
   * The request has succeeded.
   */
  200: GetFeatureFlagAdminResponse;
};

export type GetAdminFeatureFlagsResponse = GetAdminFeatureFlagsResponses[keyof GetAdminFeatureFlagsResponses];

export type UpdateUserFeatureFlagOverrideData = {
  body: UpdateUserFeatureFlagOverrideRequest;
  path: {
    userId: string;
  };
  query?: never;
  url: '/admin/feature-flag/user/{userId}';
};

export type UpdateUserFeatureFlagOverrideResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type GetFeatureFlagOverridesData = {
  body?: never;
  path: {
    flagKey: string;
  };
  query?: never;
  url: '/admin/feature-flag/{flagKey}/overrides';
};

export type GetFeatureFlagOverridesResponses = {
  /**
   * The request has succeeded.
   */
  200: GetFeatureFlagOverridesResponse;
};

export type GetFeatureFlagOverridesResponse2 = GetFeatureFlagOverridesResponses[keyof GetFeatureFlagOverridesResponses];

export type UpdateOrgFeatureFlagOverrideData = {
  body: UpdateOrgFeatureFlagOverrideRequest;
  path: {
    organizationId: string;
  };
  query?: never;
  url: '/admin/feature-flag/{organizationId}';
};

export type UpdateOrgFeatureFlagOverrideResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ChartsUpdateImageData = {
  body: FileUploadRequest;
  path: {
    chartId: string;
  };
  query?: never;
  url: '/chart/{chartId}/image';
};

export type ChartsUpdateImageResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type ChartsUpdateImageResponse = ChartsUpdateImageResponses[keyof ChartsUpdateImageResponses];

export type ChartsGetImageUrlData = {
  body?: never;
  path: {
    chartId: string;
  };
  query?: never;
  url: '/chart/{chartId}/image-url';
};

export type ChartsGetImageUrlResponses = {
  /**
   * The request has succeeded.
   */
  200: PresignedUrl;
};

export type ChartsGetImageUrlResponse = ChartsGetImageUrlResponses[keyof ChartsGetImageUrlResponses];

export type ChatAckData = {
  body?: never;
  path: {
    messageId: string;
  };
  query?: never;
  url: '/chat/{messageId}/ack';
};

export type ChatAckResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type ChatAckResponse = ChatAckResponses[keyof ChatAckResponses];

export type ChatCancelActiveData = {
  body?: never;
  path: {
    messageId: string;
  };
  query?: never;
  url: '/chat/{messageId}/active';
};

export type ChatCancelActiveResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type ChatCancelActiveResponse = ChatCancelActiveResponses[keyof ChatCancelActiveResponses];

export type ReviewSuggestionData = {
  body: ReviewChatSuggestionRequest;
  path: {
    resourceType: ResourceType;
    suggestionId: string;
  };
  query?: never;
  url: '/chat/{resourceType}/suggestions/{suggestionId}/review';
};

export type ReviewSuggestionResponses = {
  /**
   * The request has succeeded.
   */
  200: ReviewChatSuggestionResponse;
};

export type ReviewSuggestionResponse = ReviewSuggestionResponses[keyof ReviewSuggestionResponses];

export type ChatClearData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/chat/{resourceType}/{resourceId}';
};

export type ChatClearResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ChatListData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: {
    'page-num'?: number;
    'page-size'?: number;
  };
  url: '/chat/{resourceType}/{resourceId}';
};

export type ChatListResponses = {
  /**
   * The request has succeeded.
   */
  200: GetChatMessageResponse;
};

export type ChatListResponse = ChatListResponses[keyof ChatListResponses];

export type ChatCreateData = {
  body: ChatRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: {
    'user-selected-files'?: Array<string>;
    'chat-mode'?: Array<ChatMode>;
  };
  url: '/chat/{resourceType}/{resourceId}';
};

export type ChatCreateResponses = {
  /**
   * The request has succeeded.
   */
  200: ChatEvent;
};

export type ChatCreateResponse = ChatCreateResponses[keyof ChatCreateResponses];

export type ChatCheckActiveData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/chat/{resourceType}/{resourceId}/active';
};

export type ChatCheckActiveResponses = {
  /**
   * The request has succeeded.
   */
  200: CheckActiveMessageResponse;
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type ChatCheckActiveResponse = ChatCheckActiveResponses[keyof ChatCheckActiveResponses];

export type ChatExportData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/chat/{resourceType}/{resourceId}/export';
};

export type ChatExportResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type CompoundsAlignRotationData = {
  body: AlignCompoundsRotationRequest;
  path?: never;
  query?: never;
  url: '/compound/align-compounds-rotation';
};

export type CompoundsAlignRotationResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type CompoundsDeleteBatchData = {
  body: DeleteCompoundsRequest;
  path?: never;
  query?: never;
  url: '/compound/batch';
};

export type CompoundsDeleteBatchResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type CompoundsDeleteBatchResponse = CompoundsDeleteBatchResponses[keyof CompoundsDeleteBatchResponses];

export type CompoundsAcceptSuggestionsData = {
  body: Array<CompoundImportInfo>;
  path?: never;
  query?: {
    folderId?: string;
  };
  url: '/compound/batch-accept-suggestions';
};

export type CompoundsAcceptSuggestionsResponses = {
  /**
   * The request has succeeded.
   */
  200: BatchAddCompoundsResponse;
};

export type CompoundsAcceptSuggestionsResponse =
  CompoundsAcceptSuggestionsResponses[keyof CompoundsAcceptSuggestionsResponses];

export type CompoundsExportChemistryData = {
  body: ExportCompoundsRequest;
  path?: never;
  query?: never;
  url: '/compound/export-chemistry';
};

export type CompoundsExportChemistryResponses = {
  /**
   * The request has succeeded.
   */
  200: ExportCompoundsResponse;
};

export type CompoundsExportChemistryResponse =
  CompoundsExportChemistryResponses[keyof CompoundsExportChemistryResponses];

export type CompoundsRenderData = {
  body: RenderCompoundRequest;
  path?: never;
  query?: never;
  url: '/compound/render';
};

export type CompoundsRenderResponses = {
  /**
   * The request has succeeded.
   */
  200: RenderCompoundResponse;
};

export type CompoundsRenderResponse = CompoundsRenderResponses[keyof CompoundsRenderResponses];

export type CompoundsResolveIdentifiersData = {
  body: ResolveIdentifiersRequest;
  path?: never;
  query?: never;
  url: '/compound/resolve-identifiers';
};

export type CompoundsResolveIdentifiersResponses = {
  /**
   * The request has succeeded.
   */
  200: ResolveIdentifiersResponse;
};

export type CompoundsResolveIdentifiersResponse =
  CompoundsResolveIdentifiersResponses[keyof CompoundsResolveIdentifiersResponses];

export type CompoundsUpdateV2Data = {
  body: UpdateCompoundRequestV2;
  path: {
    compoundId: string;
  };
  query?: never;
  url: '/compound/v2/{compoundId}';
};

export type CompoundsUpdateV2Responses = {
  /**
   * The request has succeeded.
   */
  200: CompoundInfo;
};

export type CompoundsUpdateV2Response = CompoundsUpdateV2Responses[keyof CompoundsUpdateV2Responses];

export type CompoundsAddV2Data = {
  body: AddCompoundRequestV2;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/compound/v2/{resourceType}/{resourceId}';
};

export type CompoundsAddV2Responses = {
  /**
   * The request has succeeded.
   */
  200: CompoundInfo;
};

export type CompoundsAddV2Response = CompoundsAddV2Responses[keyof CompoundsAddV2Responses];

export type CompoundsGetData = {
  body?: never;
  path: {
    compoundId: string;
  };
  query?: never;
  url: '/compound/{compoundId}';
};

export type CompoundsGetResponses = {
  /**
   * The request has succeeded.
   */
  200: CompoundInfo;
};

export type CompoundsGetResponse = CompoundsGetResponses[keyof CompoundsGetResponses];

export type CompoundsUpdateData = {
  body: UpdateCompoundRequest;
  path: {
    compoundId: string;
  };
  query?: never;
  url: '/compound/{compoundId}';
};

export type CompoundsUpdateResponses = {
  /**
   * The request has succeeded.
   */
  200: CompoundInfo;
};

export type CompoundsUpdateResponse = CompoundsUpdateResponses[keyof CompoundsUpdateResponses];

export type CompoundsUpdateImageData = {
  body: FileUploadRequest;
  path: {
    compoundId: string;
  };
  query?: never;
  url: '/compound/{compoundId}/image';
};

export type CompoundsUpdateImageResponses = {
  /**
   * The request has succeeded.
   */
  200: string;
};

export type CompoundsUpdateImageResponse = CompoundsUpdateImageResponses[keyof CompoundsUpdateImageResponses];

export type CompoundsListData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/compound/{resourceType}/{resourceId}';
};

export type CompoundsListResponses = {
  /**
   * The request has succeeded.
   */
  200: GetCompoundsResponse;
};

export type CompoundsListResponse = CompoundsListResponses[keyof CompoundsListResponses];

export type CompoundsAddData = {
  body: AddCompoundRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/compound/{resourceType}/{resourceId}';
};

export type CompoundsAddResponses = {
  /**
   * The request has succeeded.
   */
  200: CompoundInfo;
};

export type CompoundsAddResponse = CompoundsAddResponses[keyof CompoundsAddResponses];

export type CompoundsDeleteAllData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/compound/{resourceType}/{resourceId}/all';
};

export type CompoundsDeleteAllResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type CompoundsDeleteAllResponse = CompoundsDeleteAllResponses[keyof CompoundsDeleteAllResponses];

export type CompoundsAddBatchData = {
  body: Array<CompoundImportInfo>;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: {
    folderId?: string;
  };
  url: '/compound/{resourceType}/{resourceId}/batch';
};

export type CompoundsAddBatchResponses = {
  /**
   * The request has succeeded.
   */
  200: BatchAddCompoundsResponse;
};

export type CompoundsAddBatchResponse = CompoundsAddBatchResponses[keyof CompoundsAddBatchResponses];

export type CompoundsConvertChemdrawData = {
  body: ConvertChemdrawUploadRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/compound/{resourceType}/{resourceId}/convert-chemdraw';
};

export type CompoundsConvertChemdrawResponses = {
  /**
   * The request has succeeded.
   */
  200: ParseCdxCmlResponse;
};

export type CompoundsConvertChemdrawResponse =
  CompoundsConvertChemdrawResponses[keyof CompoundsConvertChemdrawResponses];

export type CompoundsExtractFromDocxData = {
  body: FileUploadRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/compound/{resourceType}/{resourceId}/extract-docx';
};

export type CompoundsExtractFromDocxResponses = {
  /**
   * The request has succeeded.
   */
  200: ExtractCompoundsFromDocxResponse;
};

export type CompoundsExtractFromDocxResponse =
  CompoundsExtractFromDocxResponses[keyof CompoundsExtractFromDocxResponses];

export type CompoundsExtractSpreadsheetData = {
  body: FileUploadRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/compound/{resourceType}/{resourceId}/extract-spreadsheet';
};

export type CompoundsExtractSpreadsheetResponses = {
  /**
   * The request has succeeded.
   */
  200: ExtractSpreadsheetResponse;
};

export type CompoundsExtractSpreadsheetResponse =
  CompoundsExtractSpreadsheetResponses[keyof CompoundsExtractSpreadsheetResponses];

export type CustomFieldListData = {
  body?: never;
  path?: never;
  query: {
    type: ResourceType;
  };
  url: '/custom-fields';
};

export type CustomFieldListResponses = {
  /**
   * The request has succeeded.
   */
  200: ListCustomFieldsResponse;
};

export type CustomFieldListResponse = CustomFieldListResponses[keyof CustomFieldListResponses];

export type CustomFieldUpdateData = {
  body: UpdateCustomFieldValuesRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/custom-fields/{resourceType}/{resourceId}';
};

export type CustomFieldUpdateResponses = {
  /**
   * The request has succeeded.
   */
  200: CustomFieldValues;
};

export type CustomFieldUpdateResponse = CustomFieldUpdateResponses[keyof CustomFieldUpdateResponses];

export type CreateDataTableData = {
  body: CreateDataTableRequest;
  path?: never;
  query?: never;
  url: '/data-tables';
};

export type CreateDataTableResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: CreateDataTableResponse;
};

export type CreateDataTableResponse2 = CreateDataTableResponses[keyof CreateDataTableResponses];

export type ImportDataTableData = {
  body: ImportDataTableRequest;
  path?: never;
  query?: never;
  url: '/data-tables/import';
};

export type ImportDataTableResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: CreateDataTableResponse;
};

export type ImportDataTableResponse = ImportDataTableResponses[keyof ImportDataTableResponses];

export type DetectDataTableImportTablesData = {
  body: DetectDataTableImportTablesRequest;
  path?: never;
  query?: never;
  url: '/data-tables/import/detect';
};

export type DetectDataTableImportTablesResponses = {
  /**
   * The request has succeeded.
   */
  200: DetectDataTableImportTablesResponse;
};

export type DetectDataTableImportTablesResponse2 =
  DetectDataTableImportTablesResponses[keyof DetectDataTableImportTablesResponses];

export type ImportDataTablePreviewData = {
  body: DataTableImportPreviewRequest;
  path?: never;
  query?: never;
  url: '/data-tables/import/preview';
};

export type ImportDataTablePreviewResponses = {
  /**
   * The request has succeeded.
   */
  200: DataTableImportPreviewResponse;
};

export type ImportDataTablePreviewResponse = ImportDataTablePreviewResponses[keyof ImportDataTablePreviewResponses];

export type SaveFromChatDataTableData = {
  body: SaveFromChatDataTableRequest;
  path?: never;
  query?: never;
  url: '/data-tables/save-from-chat';
};

export type SaveFromChatDataTableResponses = {
  /**
   * The request has succeeded.
   */
  200: SaveFromChatDataTableResponse;
};

export type SaveFromChatDataTableResponse2 = SaveFromChatDataTableResponses[keyof SaveFromChatDataTableResponses];

export type ListDataTablesData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/data-tables/{resourceType}/{resourceId}';
};

export type ListDataTablesResponses = {
  /**
   * The request has succeeded.
   */
  200: ListDataTablesResponse;
};

export type ListDataTablesResponse2 = ListDataTablesResponses[keyof ListDataTablesResponses];

export type DeleteDataTableData = {
  body?: never;
  path: {
    tableId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}';
};

export type DeleteDataTableResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type DeleteDataTableResponse = DeleteDataTableResponses[keyof DeleteDataTableResponses];

export type GetDataTableData = {
  body?: never;
  path: {
    tableId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}';
};

export type GetDataTableResponses = {
  /**
   * The request has succeeded.
   */
  200: GetDataTableResponse;
};

export type GetDataTableResponse2 = GetDataTableResponses[keyof GetDataTableResponses];

export type UpdateDataTableData = {
  body: UpdateDataTableRequest;
  path: {
    tableId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}';
};

export type UpdateDataTableResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ListDataTableChartsData = {
  body?: never;
  path: {
    tableId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}/charts';
};

export type ListDataTableChartsResponses = {
  /**
   * The request has succeeded.
   */
  200: ListDataTableChartsResponse;
};

export type ListDataTableChartsResponse2 = ListDataTableChartsResponses[keyof ListDataTableChartsResponses];

export type CreateDataTableChartData = {
  body: CreateDataTableChartRequest;
  path: {
    tableId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}/charts';
};

export type CreateDataTableChartResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: DataTableChartDetail;
};

export type CreateDataTableChartResponse = CreateDataTableChartResponses[keyof CreateDataTableChartResponses];

export type UpdateDataTableChartViewData = {
  body: UpdateDataTableChartViewRequest;
  path: {
    tableId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}/charts';
};

export type UpdateDataTableChartViewResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ViewDataTableChartsData = {
  body: ViewDataTableChartsRequest;
  path: {
    tableId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}/charts/view';
};

export type ViewDataTableChartsResponses = {
  /**
   * The request has succeeded.
   */
  200: ViewDataTableChartsResponse;
};

export type ViewDataTableChartsResponse2 = ViewDataTableChartsResponses[keyof ViewDataTableChartsResponses];

export type DeleteDataTableChartData = {
  body?: never;
  path: {
    tableId: string;
    chartId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}/charts/{chartId}';
};

export type DeleteDataTableChartResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type DeleteDataTableChartResponse = DeleteDataTableChartResponses[keyof DeleteDataTableChartResponses];

export type UpdateDataTableChartData = {
  body: UpdateDataTableChartRequest;
  path: {
    tableId: string;
    chartId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}/charts/{chartId}';
};

export type UpdateDataTableChartResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type AddDataTableChartToViewData = {
  body?: never;
  path: {
    tableId: string;
    chartId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}/charts/{chartId}/add';
};

export type AddDataTableChartToViewResponses = {
  /**
   * The request has succeeded.
   */
  200: DataTableChartDetail;
};

export type AddDataTableChartToViewResponse = AddDataTableChartToViewResponses[keyof AddDataTableChartToViewResponses];

export type ReviewDataTableChartData = {
  body?: never;
  path: {
    tableId: string;
    chartId: string;
  };
  query: {
    action: DataTableChartReviewAction;
  };
  url: '/data-tables/{tableId}/charts/{chartId}/review';
};

export type ReviewDataTableChartResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type GetDataTablePatentFieldValuesData = {
  body?: never;
  path: {
    tableId: string;
    columnId: string;
  };
  query: {
    field: DataTablePatentDataField;
  };
  url: '/data-tables/{tableId}/columns/{columnId}/patent-values';
};

export type GetDataTablePatentFieldValuesResponses = {
  /**
   * The request has succeeded.
   */
  200: GetDataTablePatentFieldValuesResponse;
};

export type GetDataTablePatentFieldValuesResponse2 =
  GetDataTablePatentFieldValuesResponses[keyof GetDataTablePatentFieldValuesResponses];

export type ExportDataTableData = {
  body?: never;
  path: {
    tableId: string;
  };
  query?: {
    format?: DataTableExportFormat;
  };
  url: '/data-tables/{tableId}/export';
};

export type ExportDataTableResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ReviewDataTableCellsData = {
  body: ReviewDataTableCellsRequest;
  path: {
    tableId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}/review';
};

export type ReviewDataTableCellsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type GetDataTableRowsData = {
  body: GetDataTableRowsRequest;
  path: {
    tableId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}/rows';
};

export type GetDataTableRowsResponses = {
  /**
   * The request has succeeded.
   */
  200: GetDataTableRowsResponse;
};

export type GetDataTableRowsResponse2 = GetDataTableRowsResponses[keyof GetDataTableRowsResponses];

export type GetDataTableRowsByIdsData = {
  body: GetDataTableRowsByIdsRequest;
  path: {
    tableId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}/rows/by-ids';
};

export type GetDataTableRowsByIdsResponses = {
  /**
   * The request has succeeded.
   */
  200: GetDataTableRowsByIdResponse;
};

export type GetDataTableRowsByIdsResponse = GetDataTableRowsByIdsResponses[keyof GetDataTableRowsByIdsResponses];

export type AppendDataTableRowsData = {
  body: AppendDataTableRowsRequest;
  path: {
    tableId: string;
  };
  query?: never;
  url: '/data-tables/{tableId}/rows/import';
};

export type AppendDataTableRowsResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: AppendDataTableRowsResponse;
};

export type AppendDataTableRowsResponse2 = AppendDataTableRowsResponses[keyof AppendDataTableRowsResponses];

export type ComposePromptPreviewData = {
  body: ComposePromptPreviewRequest;
  path?: never;
  query?: never;
  url: '/developer/compose-prompt-preview';
};

export type ComposePromptPreviewResponses = {
  /**
   * The request has succeeded.
   */
  200: ComposePromptPreviewResponse;
};

export type ComposePromptPreviewResponse2 = ComposePromptPreviewResponses[keyof ComposePromptPreviewResponses];

export type DeleteModelProviderOverrideData = {
  body?: never;
  path?: never;
  query: {
    role: UserRole;
  };
  url: '/developer/model-provider-override';
};

export type DeleteModelProviderOverrideResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type DeleteModelProviderOverrideResponse =
  DeleteModelProviderOverrideResponses[keyof DeleteModelProviderOverrideResponses];

export type SetModelProviderOverrideData = {
  body: SetModelProviderOverrideRequest;
  path?: never;
  query?: never;
  url: '/developer/model-provider-override';
};

export type SetModelProviderOverrideResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type GetDeveloperPromptFilesData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/developer/prompt-files';
};

export type GetDeveloperPromptFilesResponses = {
  /**
   * The request has succeeded.
   */
  200: DeveloperPromptFilesResponse;
};

export type GetDeveloperPromptFilesResponse = GetDeveloperPromptFilesResponses[keyof GetDeveloperPromptFilesResponses];

export type DeleteDeveloperPromptOverridesData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: {
    path?: string;
  };
  url: '/developer/prompt-overrides/{resourceType}/{resourceId}';
};

export type DeleteDeveloperPromptOverridesResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type DeleteDeveloperPromptOverridesResponse =
  DeleteDeveloperPromptOverridesResponses[keyof DeleteDeveloperPromptOverridesResponses];

export type GetDeveloperPromptOverridesData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/developer/prompt-overrides/{resourceType}/{resourceId}';
};

export type GetDeveloperPromptOverridesResponses = {
  /**
   * The request has succeeded.
   */
  200: DeveloperPromptOverridesResponse;
};

export type GetDeveloperPromptOverridesResponse =
  GetDeveloperPromptOverridesResponses[keyof GetDeveloperPromptOverridesResponses];

export type PutDeveloperPromptOverrideData = {
  body: Array<PromptOverride>;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/developer/prompt-overrides/{resourceType}/{resourceId}';
};

export type PutDeveloperPromptOverrideResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type GetDeveloperRolesOverviewData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/developer/roles-overview';
};

export type GetDeveloperRolesOverviewResponses = {
  /**
   * The request has succeeded.
   */
  200: Array<RoleOverviewEntry>;
};

export type GetDeveloperRolesOverviewResponse =
  GetDeveloperRolesOverviewResponses[keyof GetDeveloperRolesOverviewResponses];

export type DocumentCreationReviewEventData = {
  body?: never;
  path: {
    eventId: string;
  };
  query: {
    action: DocumentCreationReviewAction;
  };
  url: '/document-creation/event/{eventId}';
};

export type DocumentCreationReviewEventResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type DocumentsGetByResourceIdData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/document/{resourceType}/resource/{resourceId}';
};

export type DocumentsGetByResourceIdResponses = {
  /**
   * The request has succeeded.
   */
  200: Array<Document>;
};

export type DocumentsGetByResourceIdResponse =
  DocumentsGetByResourceIdResponses[keyof DocumentsGetByResourceIdResponses];

export type DocumentsCreateData = {
  body: CreateDocumentRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/document/{resourceType}/resource/{resourceId}';
};

export type DocumentsCreateResponses = {
  /**
   * The request has succeeded.
   */
  200: Document;
};

export type DocumentsCreateResponse = DocumentsCreateResponses[keyof DocumentsCreateResponses];

export type DocumentsDeleteData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    storedDocumentId: string;
  };
  query?: never;
  url: '/document/{resourceType}/{storedDocumentId}';
};

export type DocumentsDeleteResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type DocumentsDeleteResponse = DocumentsDeleteResponses[keyof DocumentsDeleteResponses];

export type DocumentsGetData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    storedDocumentId: string;
  };
  query?: never;
  url: '/document/{resourceType}/{storedDocumentId}';
};

export type DocumentsGetResponses = {
  /**
   * The request has succeeded.
   */
  200: Document;
};

export type DocumentsGetResponse = DocumentsGetResponses[keyof DocumentsGetResponses];

export type DocumentsPutContentData = {
  body: WriteDocumentRequest;
  path: {
    resourceType: ResourceType;
    storedDocumentId: string;
  };
  query?: never;
  url: '/document/{resourceType}/{storedDocumentId}/content';
};

export type DocumentsPutContentResponses = {
  /**
   * The request has succeeded.
   */
  200: Document;
};

export type DocumentsPutContentResponse = DocumentsPutContentResponses[keyof DocumentsPutContentResponses];

export type DocumentsGetDocxData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    storedDocumentId: string;
  };
  query?: never;
  url: '/document/{resourceType}/{storedDocumentId}/docx';
};

export type DocumentsGetDocxResponses = {
  /**
   * The request has succeeded.
   */
  200: DocxRef;
};

export type DocumentsGetDocxResponse = DocumentsGetDocxResponses[keyof DocumentsGetDocxResponses];

export type DocumentsPutDocxData = {
  body: unknown;
  path: {
    resourceType: ResourceType;
    storedDocumentId: string;
  };
  query?: never;
  url: '/document/{resourceType}/{storedDocumentId}/docx';
};

export type DocumentsPutDocxResponses = {
  /**
   * The request has succeeded.
   */
  200: DocxRef;
};

export type DocumentsPutDocxResponse = DocumentsPutDocxResponses[keyof DocumentsPutDocxResponses];

export type DocumentsCompleteDocxUploadData = {
  body: CompleteDocxUploadRequest;
  path: {
    resourceType: ResourceType;
    storedDocumentId: string;
  };
  query?: never;
  url: '/document/{resourceType}/{storedDocumentId}/docx/complete';
};

export type DocumentsCompleteDocxUploadResponses = {
  /**
   * The request has succeeded.
   */
  200: DocxRef;
};

export type DocumentsCompleteDocxUploadResponse =
  DocumentsCompleteDocxUploadResponses[keyof DocumentsCompleteDocxUploadResponses];

export type DocumentsCreateDocxUploadUrlData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    storedDocumentId: string;
  };
  query?: never;
  url: '/document/{resourceType}/{storedDocumentId}/docx/upload-url';
};

export type DocumentsCreateDocxUploadUrlResponses = {
  /**
   * The request has succeeded.
   */
  200: DocxUploadUrl;
};

export type DocumentsCreateDocxUploadUrlResponse =
  DocumentsCreateDocxUploadUrlResponses[keyof DocumentsCreateDocxUploadUrlResponses];

export type DocumentsDuplicateData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    storedDocumentId: string;
  };
  query?: never;
  url: '/document/{resourceType}/{storedDocumentId}/duplicate';
};

export type DocumentsDuplicateResponses = {
  /**
   * The request has succeeded.
   */
  200: Document;
};

export type DocumentsDuplicateResponse = DocumentsDuplicateResponses[keyof DocumentsDuplicateResponses];

export type DocumentsUpdateMetadataData = {
  body: UpdateDocumentMetadataRequest;
  path: {
    resourceType: ResourceType;
    storedDocumentId: string;
  };
  query?: never;
  url: '/document/{resourceType}/{storedDocumentId}/metadata';
};

export type DocumentsUpdateMetadataResponses = {
  /**
   * The request has succeeded.
   */
  200: UpdateDocumentMetadataResponse;
};

export type DocumentsUpdateMetadataResponse = DocumentsUpdateMetadataResponses[keyof DocumentsUpdateMetadataResponses];

export type ListExternalSourcesData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/external-sources';
};

export type ListExternalSourcesResponses = {
  /**
   * The request has succeeded.
   */
  200: ListExternalSourcesResponse;
};

export type ListExternalSourcesResponse2 = ListExternalSourcesResponses[keyof ListExternalSourcesResponses];

export type CreateExternalSourceData = {
  body: CreateExternalSourceRequest;
  path?: never;
  query?: never;
  url: '/external-sources';
};

export type CreateExternalSourceResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: ExternalSource;
};

export type CreateExternalSourceResponse = CreateExternalSourceResponses[keyof CreateExternalSourceResponses];

export type CreateExternalSourceAuthData = {
  body: CreateExternalSourceAuthRequest;
  path?: never;
  query?: never;
  url: '/external-sources/auth';
};

export type CreateExternalSourceAuthResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type CreateExternalSourceAuthResponse =
  CreateExternalSourceAuthResponses[keyof CreateExternalSourceAuthResponses];

export type ListExternalSourceConfigsData = {
  body?: never;
  path?: never;
  query: {
    'organization-id': string;
  };
  url: '/external-sources/configs';
};

export type ListExternalSourceConfigsResponses = {
  /**
   * The request has succeeded.
   */
  200: ListExternalSourceConfigsResponse;
};

export type ListExternalSourceConfigsResponse2 =
  ListExternalSourceConfigsResponses[keyof ListExternalSourceConfigsResponses];

export type ListExternalConnectionsData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: {
    'source-id'?: string;
  };
  url: '/external-sources/connections/{resourceType}/{resourceId}';
};

export type ListExternalConnectionsResponses = {
  /**
   * The request has succeeded.
   */
  200: ListExternalConnectionsResponse;
};

export type ListExternalConnectionsResponse2 = ListExternalConnectionsResponses[keyof ListExternalConnectionsResponses];

export type CreateExternalConnectionsData = {
  body: CreateExternalConnectionsRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/external-sources/connections/{resourceType}/{resourceId}';
};

export type CreateExternalConnectionsResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: ListExternalConnectionsResponse;
};

export type CreateExternalConnectionsResponse =
  CreateExternalConnectionsResponses[keyof CreateExternalConnectionsResponses];

export type DeleteExternalConnectionData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
    connectionId: string;
  };
  query?: never;
  url: '/external-sources/connections/{resourceType}/{resourceId}/{connectionId}';
};

export type DeleteExternalConnectionResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type DeleteExternalConnectionResponse =
  DeleteExternalConnectionResponses[keyof DeleteExternalConnectionResponses];

export type ExportExternalSourceItemsData = {
  body: ExportExternalSourceItemsMultipartRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/external-sources/exports/{resourceType}/{resourceId}';
};

export type ExportExternalSourceItemsResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: ExportExternalSourceItemsResponse;
};

export type ExportExternalSourceItemsResponse2 =
  ExportExternalSourceItemsResponses[keyof ExportExternalSourceItemsResponses];

export type ImportExternalSourceFilesData = {
  body: ImportExternalSourceFilesRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/external-sources/imports/{resourceType}/{resourceId}';
};

export type ImportExternalSourceFilesResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: ImportExternalSourceFilesResponse;
};

export type ImportExternalSourceFilesResponse2 =
  ImportExternalSourceFilesResponses[keyof ImportExternalSourceFilesResponses];

export type SearchExternalSourceItemsData = {
  body?: never;
  path?: never;
  query: {
    'source-id': string;
    search: string;
    type?: Array<ExternalSourceItemType>;
    'parent-id'?: string;
    'page-token'?: string;
  };
  url: '/external-sources/items';
};

export type SearchExternalSourceItemsResponses = {
  /**
   * The request has succeeded.
   */
  200: SearchExternalSourceItemsResponse;
};

export type SearchExternalSourceItemsResponse2 =
  SearchExternalSourceItemsResponses[keyof SearchExternalSourceItemsResponses];

export type ListExternalSourceItemsData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query: {
    'source-id': string;
    'parent-id': string;
    'page-token'?: string;
  };
  url: '/external-sources/items/{resourceType}/{resourceId}';
};

export type ListExternalSourceItemsResponses = {
  /**
   * The request has succeeded.
   */
  200: ListExternalSourceItemsResponse;
};

export type ListExternalSourceItemsResponse2 = ListExternalSourceItemsResponses[keyof ListExternalSourceItemsResponses];

export type PreviewExternalSourceFileData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query: {
    'source-id': string;
    'file-id': string;
  };
  url: '/external-sources/items/{resourceType}/{resourceId}/preview';
};

export type PreviewExternalSourceFileResponses = {
  /**
   * The request has succeeded.
   */
  200: PreviewExternalSourceFileResponse;
};

export type PreviewExternalSourceFileResponse2 =
  PreviewExternalSourceFileResponses[keyof PreviewExternalSourceFileResponses];

export type UpdateExternalSourceData = {
  body: UpdateExternalSourceRequest;
  path: {
    sourceId: string;
  };
  query?: never;
  url: '/external-sources/{sourceId}';
};

export type UpdateExternalSourceResponses = {
  /**
   * The request has succeeded.
   */
  200: UpdateExternalSourceResponse;
};

export type UpdateExternalSourceResponse2 = UpdateExternalSourceResponses[keyof UpdateExternalSourceResponses];

export type SetExternalSourceCredentialsData = {
  body: SetExternalSourceCredentialsRequest;
  path: {
    sourceId: string;
  };
  query?: never;
  url: '/external-sources/{sourceId}/credentials';
};

export type SetExternalSourceCredentialsResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type SetExternalSourceCredentialsResponse =
  SetExternalSourceCredentialsResponses[keyof SetExternalSourceCredentialsResponses];

export type GetFeatureFlagsData = {
  body?: never;
  path?: never;
  query?: {
    'flag-key'?: Array<string>;
  };
  url: '/feature-flag';
};

export type GetFeatureFlagsResponses = {
  /**
   * The request has succeeded.
   */
  200: GetFeatureFlagResponse;
};

export type GetFeatureFlagsResponse = GetFeatureFlagsResponses[keyof GetFeatureFlagsResponses];

export type FigureDiagramsReviewFigureDiagramEventData = {
  body?: never;
  path: {
    eventId: string;
  };
  query: {
    action: FigureDiagramReviewAction;
    figureType?: FigureFileType;
  };
  url: '/figure-diagram/event/{eventId}';
};

export type FigureDiagramsReviewFigureDiagramEventResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type FigureGenerationGenerateDiagramData = {
  body: GenerateDiagramFromFigureRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/generation/{resourceType}/{resourceId}/diagram';
};

export type FigureGenerationGenerateDiagramResponses = {
  /**
   * The request has succeeded.
   */
  200: GenerateFigureDiagramResponse;
};

export type FigureGenerationGenerateDiagramResponse =
  FigureGenerationGenerateDiagramResponses[keyof FigureGenerationGenerateDiagramResponses];

export type FigureGenerationGenerateDiagramFromFileData = {
  body: GenerateDiagramFromFileRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/generation/{resourceType}/{resourceId}/diagram/from-file';
};

export type FigureGenerationGenerateDiagramFromFileResponses = {
  /**
   * The request has succeeded.
   */
  200: GenerateFigureDiagramResponse;
};

export type FigureGenerationGenerateDiagramFromFileResponse =
  FigureGenerationGenerateDiagramFromFileResponses[keyof FigureGenerationGenerateDiagramFromFileResponses];

export type FigureGenerationGenerateDiagramFromFileV2Data = {
  body: GenerateDiagramFromFileV2Request;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/generation/{resourceType}/{resourceId}/diagram/from-file/v2';
};

export type FigureGenerationGenerateDiagramFromFileV2Responses = {
  /**
   * The request has succeeded.
   */
  200: GenerateFigureDiagramUnifiedResponse;
};

export type FigureGenerationGenerateDiagramFromFileV2Response =
  FigureGenerationGenerateDiagramFromFileV2Responses[keyof FigureGenerationGenerateDiagramFromFileV2Responses];

export type FigureGenerationGenerateDiagramV2Data = {
  body: GenerateDiagramV2Request;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/generation/{resourceType}/{resourceId}/diagram/v2';
};

export type FigureGenerationGenerateDiagramV2Responses = {
  /**
   * The request has succeeded.
   */
  200: GenerateFigureDiagramUnifiedResponse;
};

export type FigureGenerationGenerateDiagramV2Response =
  FigureGenerationGenerateDiagramV2Responses[keyof FigureGenerationGenerateDiagramV2Responses];

export type FigureGenerationGenerateImageFromFigureData = {
  body: GenerateImageFromFigureRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/generation/{resourceType}/{resourceId}/image/from-figure';
};

export type FigureGenerationGenerateImageFromFigureResponses = {
  /**
   * The request has succeeded.
   */
  200: GenerateFigureImageResponse;
};

export type FigureGenerationGenerateImageFromFigureResponse =
  FigureGenerationGenerateImageFromFigureResponses[keyof FigureGenerationGenerateImageFromFigureResponses];

export type FigureGenerationGenerateImageFromFileData = {
  body: GenerateFigureImageFromFileRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/generation/{resourceType}/{resourceId}/image/from-file';
};

export type FigureGenerationGenerateImageFromFileResponses = {
  /**
   * The request has succeeded.
   */
  200: GenerateFigureImageResponse;
};

export type FigureGenerationGenerateImageFromFileResponse =
  FigureGenerationGenerateImageFromFileResponses[keyof FigureGenerationGenerateImageFromFileResponses];

export type FigureGenerationGenerateImageFromTempFileData = {
  body: GenerateImageFromTempFileRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/generation/{resourceType}/{resourceId}/image/from-temp-file';
};

export type FigureGenerationGenerateImageFromTempFileResponses = {
  /**
   * The request has succeeded.
   */
  200: GenerateFigureImageResponse;
};

export type FigureGenerationGenerateImageFromTempFileResponse =
  FigureGenerationGenerateImageFromTempFileResponses[keyof FigureGenerationGenerateImageFromTempFileResponses];

export type FigureGenerationGenerateImageFromTextV2Data = {
  body: GenerateImageFromTextRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/generation/{resourceType}/{resourceId}/image/from-text-v2';
};

export type FigureGenerationGenerateImageFromTextV2Responses = {
  /**
   * The request has succeeded.
   */
  200: GenerateFigureImageResponse;
};

export type FigureGenerationGenerateImageFromTextV2Response =
  FigureGenerationGenerateImageFromTextV2Responses[keyof FigureGenerationGenerateImageFromTextV2Responses];

export type FiguresGetFiguresData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/{resourceType}/{resourceId}';
};

export type FiguresGetFiguresResponses = {
  /**
   * The request has succeeded.
   */
  200: Array<FigureResponse>;
};

export type FiguresGetFiguresResponse = FiguresGetFiguresResponses[keyof FiguresGetFiguresResponses];

export type FiguresBatchDeleteFiguresData = {
  body: BatchDeleteFiguresRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/{resourceType}/{resourceId}/batch';
};

export type FiguresBatchDeleteFiguresResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type FiguresExportFigureToVisioData = {
  body: ExportFigureToVisioRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/{resourceType}/{resourceId}/export/visio';
};

export type FiguresExportFigureToVisioResponses = {
  /**
   * The request has succeeded.
   */
  200: ExportFigureToVisioResponse;
};

export type FiguresExportFigureToVisioResponse =
  FiguresExportFigureToVisioResponses[keyof FiguresExportFigureToVisioResponses];

export type FiguresBatchExportFiguresToVisioData = {
  body: BatchExportFiguresToVisioRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/{resourceType}/{resourceId}/export/visio/batch';
};

export type FiguresBatchExportFiguresToVisioResponses = {
  /**
   * The request has succeeded.
   */
  200: ExportFigureToVisioResponse;
};

export type FiguresBatchExportFiguresToVisioResponse =
  FiguresBatchExportFiguresToVisioResponses[keyof FiguresBatchExportFiguresToVisioResponses];

export type FiguresExportFigureToVisioV2Data = {
  body: ExportFigureToVisioRequestV2;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/{resourceType}/{resourceId}/export/visio/v2';
};

export type FiguresExportFigureToVisioV2Responses = {
  /**
   * The request has succeeded.
   */
  200: ExportFigureToVisioResponse;
};

export type FiguresExportFigureToVisioV2Response =
  FiguresExportFigureToVisioV2Responses[keyof FiguresExportFigureToVisioV2Responses];

export type FiguresBatchImportFromFileData = {
  body: BatchImportFromFileRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/{resourceType}/{resourceId}/import-from-file';
};

export type FiguresBatchImportFromFileResponses = {
  /**
   * The request has succeeded.
   */
  200: BatchUploadFiguresResponse;
};

export type FiguresBatchImportFromFileResponse =
  FiguresBatchImportFromFileResponses[keyof FiguresBatchImportFromFileResponses];

export type FiguresReorderFiguresData = {
  body: ReorderFiguresRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/{resourceType}/{resourceId}/order';
};

export type FiguresReorderFiguresResponses = {
  /**
   * The request has succeeded.
   */
  200: Array<FigureResponse>;
};

export type FiguresReorderFiguresResponse = FiguresReorderFiguresResponses[keyof FiguresReorderFiguresResponses];

export type FiguresSaveFigureData = {
  body: SaveFigureRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/{resourceType}/{resourceId}/save';
};

export type FiguresSaveFigureResponses = {
  /**
   * The request has succeeded.
   */
  200: FigureResponse;
};

export type FiguresSaveFigureResponse = FiguresSaveFigureResponses[keyof FiguresSaveFigureResponses];

export type FiguresUploadFigureData = {
  body: FileUploadRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: {
    shouldConvertToPdf?: boolean;
  };
  url: '/figure/{resourceType}/{resourceId}/upload';
};

export type FiguresUploadFigureResponses = {
  /**
   * The request has succeeded.
   */
  200: Array<FigureResponse>;
};

export type FiguresUploadFigureResponse = FiguresUploadFigureResponses[keyof FiguresUploadFigureResponses];

export type FiguresUploadFiguresBatchData = {
  body: BatchUploadFiguresRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/figure/{resourceType}/{resourceId}/upload/batch';
};

export type FiguresUploadFiguresBatchResponses = {
  /**
   * The request has succeeded.
   */
  200: BatchUploadFiguresResponse;
};

export type FiguresUploadFiguresBatchResponse =
  FiguresUploadFiguresBatchResponses[keyof FiguresUploadFiguresBatchResponses];

export type FiguresDeleteFigureData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
    figureId: string;
  };
  query?: never;
  url: '/figure/{resourceType}/{resourceId}/{figureId}';
};

export type FiguresDeleteFigureResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type FiguresGetFigureData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
    figureId: string;
  };
  query?: never;
  url: '/figure/{resourceType}/{resourceId}/{figureId}';
};

export type FiguresGetFigureResponses = {
  /**
   * The request has succeeded.
   */
  200: FigureResponse;
};

export type FiguresGetFigureResponse = FiguresGetFigureResponses[keyof FiguresGetFigureResponses];

export type FiguresUpdateFigureInfoData = {
  body: UpdateFigureInfoRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
    figureId: string;
  };
  query?: never;
  url: '/figure/{resourceType}/{resourceId}/{figureId}/info';
};

export type FiguresUpdateFigureInfoResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type FileFolderDeleteData = {
  body?: never;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/file-folders/{folderId}';
};

export type FileFolderDeleteResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type FileFolderUpdateData = {
  body: UpdateItemFolderRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/file-folders/{folderId}';
};

export type FileFolderUpdateResponses = {
  /**
   * The request has succeeded.
   */
  200: ItemFolderMetadata;
};

export type FileFolderUpdateResponse = FileFolderUpdateResponses[keyof FileFolderUpdateResponses];

export type FileFolderAddItemsData = {
  body: UpdateFolderItemsRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/file-folders/{folderId}/items';
};

export type FileFolderAddItemsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type FileFolderGetAllData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: {
    kind?: FolderKind;
  };
  url: '/file-folders/{resourceType}/{resourceId}';
};

export type FileFolderGetAllResponses = {
  /**
   * The request has succeeded.
   */
  200: ItemFoldersResponse;
};

export type FileFolderGetAllResponse = FileFolderGetAllResponses[keyof FileFolderGetAllResponses];

export type FileFolderCreateData = {
  body: CreateItemFolderRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/file-folders/{resourceType}/{resourceId}';
};

export type FileFolderCreateResponses = {
  /**
   * The request has succeeded.
   */
  200: ItemFolderMetadata;
};

export type FileFolderCreateResponse = FileFolderCreateResponses[keyof FileFolderCreateResponses];

export type FileUploadByPatentNumberV2Data = {
  body: PatentNumberUploadRequest;
  path: {
    resourceType: ResourceType;
    workflowId: string;
  };
  query?: never;
  url: '/file/upload-by-patent-number-v2/{resourceType}/{workflowId}';
};

export type FileUploadByPatentNumberV2Responses = {
  /**
   * The request has succeeded.
   */
  200: PatentNumberUploadResult;
};

export type FileUploadByPatentNumberV2Response =
  FileUploadByPatentNumberV2Responses[keyof FileUploadByPatentNumberV2Responses];

export type FileUploadData = {
  body: FileUploadRequest;
  path: {
    resourceType: ResourceType;
    workflowId: string;
  };
  query?: {
    convertToPdf?: boolean;
    shouldOCR?: boolean;
    folderId?: string;
  };
  url: '/file/upload/{resourceType}/{workflowId}';
};

export type FileUploadResponses = {
  /**
   * The request has succeeded.
   */
  200: string;
};

export type FileUploadResponse = FileUploadResponses[keyof FileUploadResponses];

export type FileDeleteData = {
  body?: never;
  path: {
    fileId: string;
  };
  query?: never;
  url: '/file/{fileId}';
};

export type FileDeleteResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type FileGetData = {
  body?: never;
  path: {
    fileId: string;
  };
  query?: {
    'generate-url'?: boolean;
  };
  url: '/file/{fileId}';
};

export type FileGetResponses = {
  /**
   * The request has succeeded.
   */
  200: FileInfo;
};

export type FileGetResponse = FileGetResponses[keyof FileGetResponses];

export type FileUpdateData = {
  body: UpdateFileInfoRequest;
  path: {
    fileId: string;
  };
  query?: never;
  url: '/file/{fileId}';
};

export type FileUpdateResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type FileUploadContentData = {
  body: FileContentUploadRequest;
  path: {
    fileId: string;
  };
  query?: never;
  url: '/file/{fileId}/content';
};

export type FileUploadContentResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type FileExtractPdfImagesData = {
  body?: never;
  path: {
    fileId: string;
  };
  query?: never;
  url: '/file/{fileId}/extract-pdf-images';
};

export type FileExtractPdfImagesResponses = {
  /**
   * The request has succeeded.
   */
  200: Array<string>;
};

export type FileExtractPdfImagesResponse = FileExtractPdfImagesResponses[keyof FileExtractPdfImagesResponses];

export type FileGetFiguresData = {
  body?: never;
  path: {
    fileId: string;
  };
  query?: never;
  url: '/file/{fileId}/figures';
};

export type FileGetFiguresResponses = {
  /**
   * The request has succeeded.
   */
  200: Array<FileFigureInfo>;
};

export type FileGetFiguresResponse = FileGetFiguresResponses[keyof FileGetFiguresResponses];

export type FileGetHighlightsData = {
  body?: never;
  path: {
    fileId: string;
  };
  query?: {
    type?: Array<FileHighlightType>;
  };
  url: '/file/{fileId}/highlights';
};

export type FileGetHighlightsResponses = {
  /**
   * The request has succeeded.
   */
  200: FileHighlightsResponse;
};

export type FileGetHighlightsResponse = FileGetHighlightsResponses[keyof FileGetHighlightsResponses];

export type FileGenerateSummaryData = {
  body?: never;
  path: {
    fileId: string;
  };
  query?: never;
  url: '/file/{fileId}/summary';
};

export type FileGenerateSummaryResponses = {
  /**
   * The request has succeeded.
   */
  200: FileInfo;
};

export type FileGenerateSummaryResponse = FileGenerateSummaryResponses[keyof FileGenerateSummaryResponses];

export type FileGetUrlData = {
  body?: never;
  path: {
    fileId: string;
  };
  query?: {
    /**
     * @deprecated
     */
    'use-searchable-pdf'?: boolean;
    rendition?: FileRendition;
  };
  url: '/file/{fileId}/url';
};

export type FileGetUrlResponses = {
  /**
   * The request has succeeded.
   */
  200: PresignedUrl;
};

export type FileGetUrlResponse = FileGetUrlResponses[keyof FileGetUrlResponses];

export type FileExtractPatentFromFileData = {
  body: ExtractPatentFromFileRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/file/{resourceType}/{resourceId}/extract-patent';
};

export type FileExtractPatentFromFileResponses = {
  /**
   * The request has succeeded.
   */
  200: ExtractPatentFromFileResponse;
};

export type FileExtractPatentFromFileResponse =
  FileExtractPatentFromFileResponses[keyof FileExtractPatentFromFileResponses];

export type FileReviewExtractedPatentFromFileData = {
  body: ExtractedPatentSuggestionRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/file/{resourceType}/{resourceId}/extract-patent-suggestion/review';
};

export type FileReviewExtractedPatentFromFileResponses = {
  /**
   * The request has succeeded.
   */
  200: ReviewExtractedPatentResult;
};

export type FileReviewExtractedPatentFromFileResponse =
  FileReviewExtractedPatentFromFileResponses[keyof FileReviewExtractedPatentFromFileResponses];

export type FileGetWorkflowFilesData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    workflowId: string;
  };
  query?: {
    'generate-urls'?: boolean;
  };
  url: '/file/{resourceType}/{workflowId}';
};

export type FileGetWorkflowFilesResponses = {
  /**
   * The request has succeeded.
   */
  200: WorkflowFilesResponse;
};

export type FileGetWorkflowFilesResponse = FileGetWorkflowFilesResponses[keyof FileGetWorkflowFilesResponses];

export type FileGetFigureFileCandidatesData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    workflowId: string;
  };
  query?: never;
  url: '/file/{resourceType}/{workflowId}/figure-candidates';
};

export type FileGetFigureFileCandidatesResponses = {
  /**
   * The request has succeeded.
   */
  200: FigureFileCandidatesResponse;
};

export type FileGetFigureFileCandidatesResponse =
  FileGetFigureFileCandidatesResponses[keyof FileGetFigureFileCandidatesResponses];

export type CreateFormData = {
  body: CreateFormRequest;
  path?: never;
  query?: never;
  url: '/forms';
};

export type CreateFormResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: Form;
};

export type CreateFormResponse = CreateFormResponses[keyof CreateFormResponses];

export type DeleteFormData = {
  body?: never;
  path: {
    formId: string;
  };
  query?: never;
  url: '/forms/{formId}';
};

export type DeleteFormResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type DeleteFormResponse = DeleteFormResponses[keyof DeleteFormResponses];

export type GetFormData = {
  body?: never;
  path: {
    formId: string;
  };
  query?: never;
  url: '/forms/{formId}';
};

export type GetFormResponses = {
  /**
   * The request has succeeded.
   */
  200: GetFormResponse;
};

export type GetFormResponse2 = GetFormResponses[keyof GetFormResponses];

export type SaveFormAnswersData = {
  body: SaveFormAnswersRequest;
  path: {
    formId: string;
  };
  query?: never;
  url: '/forms/{formId}/answers';
};

export type SaveFormAnswersResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ExportFormData = {
  body?: never;
  path: {
    formId: string;
  };
  query?: never;
  url: '/forms/{formId}/export';
};

export type ExportFormResponses = {
  /**
   * The request has succeeded.
   */
  200: ExportFormResponse;
};

export type ExportFormResponse2 = ExportFormResponses[keyof ExportFormResponses];

export type ListFormsData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/forms/{resourceType}/{resourceId}';
};

export type ListFormsResponses = {
  /**
   * The request has succeeded.
   */
  200: ListFormsResponse;
};

export type ListFormsResponse2 = ListFormsResponses[keyof ListFormsResponses];

export type GetGeneralAssistantsData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
    pageNumber?: number;
    pageSize?: number;
  };
  url: '/general-assistant';
};

export type GetGeneralAssistantsResponses = {
  /**
   * The request has succeeded.
   */
  200: ListGeneralAssistantsResponse;
};

export type GetGeneralAssistantsResponse = GetGeneralAssistantsResponses[keyof GetGeneralAssistantsResponses];

export type CreateGeneralAssistantData = {
  body: CreateGeneralAssistantRequest;
  path?: never;
  query?: never;
  url: '/general-assistant';
};

export type CreateGeneralAssistantResponses = {
  /**
   * The request has succeeded.
   */
  200: GeneralAssistant;
};

export type CreateGeneralAssistantResponse = CreateGeneralAssistantResponses[keyof CreateGeneralAssistantResponses];

export type SetupOfficeActionData = {
  body: SetupOfficeActionRequest;
  path?: never;
  query?: never;
  url: '/general-assistant/setup/office-action';
};

export type SetupOfficeActionResponses = {
  /**
   * The request has succeeded.
   */
  200: SetupOfficeActionResponse;
};

export type SetupOfficeActionResponse2 = SetupOfficeActionResponses[keyof SetupOfficeActionResponses];

export type CreateGeneralAssistantV2Data = {
  body: CreateGeneralAssistantV2Request;
  path?: never;
  query?: never;
  url: '/general-assistant/v2';
};

export type CreateGeneralAssistantV2Responses = {
  /**
   * The request has succeeded.
   */
  200: CreateGeneralAssistantV2Response;
};

export type CreateGeneralAssistantV2Response2 =
  CreateGeneralAssistantV2Responses[keyof CreateGeneralAssistantV2Responses];

export type DeleteGeneralAssistantData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/general-assistant/{id}';
};

export type DeleteGeneralAssistantResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type DeleteGeneralAssistantResponse = DeleteGeneralAssistantResponses[keyof DeleteGeneralAssistantResponses];

export type GetGeneralAssistantData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/general-assistant/{id}';
};

export type GetGeneralAssistantResponses = {
  /**
   * The request has succeeded.
   */
  200: GeneralAssistant;
};

export type GetGeneralAssistantResponse = GetGeneralAssistantResponses[keyof GetGeneralAssistantResponses];

export type UpdateGeneralAssistantData = {
  body: UpdateGeneralAssistantRequest;
  path: {
    id: string;
  };
  query?: never;
  url: '/general-assistant/{id}';
};

export type UpdateGeneralAssistantResponses = {
  /**
   * The request has succeeded.
   */
  200: GeneralAssistant;
};

export type UpdateGeneralAssistantResponse = UpdateGeneralAssistantResponses[keyof UpdateGeneralAssistantResponses];

export type GlossarySearchRelatedTermsData = {
  body: GlossarySearchRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/glossary/{resourceType}/{resourceId}/search-related-terms';
};

export type GlossarySearchRelatedTermsResponses = {
  /**
   * The request has succeeded.
   */
  200: GlossaryRelatedTermsResponse;
};

export type GlossarySearchRelatedTermsResponse =
  GlossarySearchRelatedTermsResponses[keyof GlossarySearchRelatedTermsResponses];

export type GlossarySearchTermDefinitionsData = {
  body: GlossarySearchRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/glossary/{resourceType}/{resourceId}/search-term-definitions';
};

export type GlossarySearchTermDefinitionsResponses = {
  /**
   * The request has succeeded.
   */
  200: GlossaryTermDefinitionsResponse;
};

export type GlossarySearchTermDefinitionsResponse =
  GlossarySearchTermDefinitionsResponses[keyof GlossarySearchTermDefinitionsResponses];

export type GetInventionAssistantsData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
    'page-num'?: number;
    'page-size'?: number;
  };
  url: '/invention-assistant';
};

export type GetInventionAssistantsResponses = {
  /**
   * The request has succeeded.
   */
  200: ListInventionAssistantsResponse;
};

export type GetInventionAssistantsResponse = GetInventionAssistantsResponses[keyof GetInventionAssistantsResponses];

export type CreateInventionAssistantData = {
  body: CreateInventionAssistantRequest;
  path?: never;
  query?: never;
  url: '/invention-assistant';
};

export type CreateInventionAssistantResponses = {
  /**
   * The request has succeeded.
   */
  200: InventionAssistant;
};

export type CreateInventionAssistantResponse =
  CreateInventionAssistantResponses[keyof CreateInventionAssistantResponses];

export type DeleteInventionAssistantData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/invention-assistant/{id}';
};

export type DeleteInventionAssistantResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type DeleteInventionAssistantResponse =
  DeleteInventionAssistantResponses[keyof DeleteInventionAssistantResponses];

export type GetInventionAssistantData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/invention-assistant/{id}';
};

export type GetInventionAssistantResponses = {
  /**
   * The request has succeeded.
   */
  200: InventionAssistant;
};

export type GetInventionAssistantResponse = GetInventionAssistantResponses[keyof GetInventionAssistantResponses];

export type UpdateInventionAssistantData = {
  body: UpdateInventionAssistantRequest;
  path: {
    id: string;
  };
  query?: never;
  url: '/invention-assistant/{id}';
};

export type UpdateInventionAssistantResponses = {
  /**
   * The request has succeeded.
   */
  200: InventionAssistant;
};

export type UpdateInventionAssistantResponse =
  UpdateInventionAssistantResponses[keyof UpdateInventionAssistantResponses];

export type ItemFolderDeleteData = {
  body?: never;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/item-folders/{folderId}';
};

export type ItemFolderDeleteResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ItemFolderUpdateData = {
  body: UpdateItemFolderRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/item-folders/{folderId}';
};

export type ItemFolderUpdateResponses = {
  /**
   * The request has succeeded.
   */
  200: ItemFolderMetadata;
};

export type ItemFolderUpdateResponse = ItemFolderUpdateResponses[keyof ItemFolderUpdateResponses];

export type ItemFolderAddItemsData = {
  body: UpdateFolderItemsRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/item-folders/{folderId}/items';
};

export type ItemFolderAddItemsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ItemFolderGetAllData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: {
    kind?: FolderKind;
  };
  url: '/item-folders/{resourceType}/{resourceId}';
};

export type ItemFolderGetAllResponses = {
  /**
   * The request has succeeded.
   */
  200: ItemFoldersResponse;
};

export type ItemFolderGetAllResponse = ItemFolderGetAllResponses[keyof ItemFolderGetAllResponses];

export type ItemFolderCreateData = {
  body: CreateItemFolderRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/item-folders/{resourceType}/{resourceId}';
};

export type ItemFolderCreateResponses = {
  /**
   * The request has succeeded.
   */
  200: ItemFolderMetadata;
};

export type ItemFolderCreateResponse = ItemFolderCreateResponses[keyof ItemFolderCreateResponses];

export type KnowledgeListData = {
  body?: never;
  path?: never;
  query?: {
    resource_type?: ResourceType;
    resource_id?: string;
    search?: string;
    page_number?: number;
    page_size?: number;
  };
  url: '/knowledge';
};

export type KnowledgeListResponses = {
  /**
   * The request has succeeded.
   */
  200: ListKnowledgeResponse;
};

export type KnowledgeListResponse = KnowledgeListResponses[keyof KnowledgeListResponses];

export type KnowledgeCreateData = {
  body: CreateKnowledgeRequest;
  path?: never;
  query?: never;
  url: '/knowledge';
};

export type KnowledgeCreateResponses = {
  /**
   * The request has succeeded.
   */
  200: KnowledgeDetail;
};

export type KnowledgeCreateResponse = KnowledgeCreateResponses[keyof KnowledgeCreateResponses];

export type KnowledgeFolderGetAllData = {
  body?: never;
  path?: never;
  query?: {
    resource_type?: ResourceType;
    resource_id?: string;
  };
  url: '/knowledge-folders';
};

export type KnowledgeFolderGetAllResponses = {
  /**
   * The request has succeeded.
   */
  200: KnowledgeFoldersResponse;
};

export type KnowledgeFolderGetAllResponse = KnowledgeFolderGetAllResponses[keyof KnowledgeFolderGetAllResponses];

export type KnowledgeFolderCreateData = {
  body: CreateKnowledgeFolderRequest;
  path?: never;
  query?: never;
  url: '/knowledge-folders';
};

export type KnowledgeFolderCreateResponses = {
  /**
   * The request has succeeded.
   */
  200: ResourceFolderMetadata;
};

export type KnowledgeFolderCreateResponse = KnowledgeFolderCreateResponses[keyof KnowledgeFolderCreateResponses];

export type KnowledgeFolderDeleteData = {
  body?: never;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/knowledge-folders/{folderId}';
};

export type KnowledgeFolderDeleteResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type KnowledgeFolderDeleteResponse = KnowledgeFolderDeleteResponses[keyof KnowledgeFolderDeleteResponses];

export type KnowledgeFolderUpdateData = {
  body: UpdateKnowledgeFolderRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/knowledge-folders/{folderId}';
};

export type KnowledgeFolderUpdateResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type KnowledgeFolderActivateData = {
  body: UpdateKnowledgeActiveRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/knowledge-folders/{folderId}/activate';
};

export type KnowledgeFolderActivateResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type KnowledgeFolderActivateResponse = KnowledgeFolderActivateResponses[keyof KnowledgeFolderActivateResponses];

export type KnowledgeFolderRemoveItemsData = {
  body: UpdateKnowledgeFolderItemsRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/knowledge-folders/{folderId}/items';
};

export type KnowledgeFolderRemoveItemsResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type KnowledgeFolderRemoveItemsResponse =
  KnowledgeFolderRemoveItemsResponses[keyof KnowledgeFolderRemoveItemsResponses];

export type KnowledgeFolderAddItemsData = {
  body: UpdateKnowledgeFolderItemsRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/knowledge-folders/{folderId}/items';
};

export type KnowledgeFolderAddItemsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type KnowledgeGetEventData = {
  body?: never;
  path: {
    eventId: string;
  };
  query?: never;
  url: '/knowledge/event/{eventId}';
};

export type KnowledgeGetEventResponses = {
  /**
   * The request has succeeded.
   */
  200: KnowledgeEventDetail;
};

export type KnowledgeGetEventResponse = KnowledgeGetEventResponses[keyof KnowledgeGetEventResponses];

export type KnowledgeReviewEventData = {
  body: UpsertKnowledgeRequest;
  path: {
    eventId: string;
  };
  query: {
    action: KnowledgeReviewAction;
  };
  url: '/knowledge/event/{eventId}';
};

export type KnowledgeReviewEventResponses = {
  /**
   * The request has succeeded.
   */
  200: ReviewKnowledgeEventResponse;
};

export type KnowledgeReviewEventResponse = KnowledgeReviewEventResponses[keyof KnowledgeReviewEventResponses];

export type KnowledgeGenerateDescriptionData = {
  body: GenerateKnowledgeDescriptionRequest;
  path?: never;
  query?: never;
  url: '/knowledge/generate-description';
};

export type KnowledgeGenerateDescriptionResponses = {
  /**
   * The request has succeeded.
   */
  200: GenerateKnowledgeDescriptionResponse;
};

export type KnowledgeGenerateDescriptionResponse =
  KnowledgeGenerateDescriptionResponses[keyof KnowledgeGenerateDescriptionResponses];

export type KnowledgeDeleteData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/knowledge/{id}';
};

export type KnowledgeDeleteResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type KnowledgeGetData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/knowledge/{id}';
};

export type KnowledgeGetResponses = {
  /**
   * The request has succeeded.
   */
  200: KnowledgeDetail;
};

export type KnowledgeGetResponse = KnowledgeGetResponses[keyof KnowledgeGetResponses];

export type KnowledgeUpdateData = {
  body: UpdateKnowledgeRequest;
  path: {
    id: string;
  };
  query?: never;
  url: '/knowledge/{id}';
};

export type KnowledgeUpdateResponses = {
  /**
   * The request has succeeded.
   */
  200: KnowledgeDetail;
};

export type KnowledgeUpdateResponse = KnowledgeUpdateResponses[keyof KnowledgeUpdateResponses];

export type KnowledgeSetActiveData = {
  body: UpdateKnowledgeActiveRequest;
  path: {
    id: string;
  };
  query?: never;
  url: '/knowledge/{id}/active';
};

export type KnowledgeSetActiveResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type KnowledgeSetActiveResponse = KnowledgeSetActiveResponses[keyof KnowledgeSetActiveResponses];

export type KnowledgeSetAutoLoadData = {
  body: UpdateKnowledgeAutoLoadRequest;
  path: {
    id: string;
  };
  query?: never;
  url: '/knowledge/{id}/auto-load';
};

export type KnowledgeSetAutoLoadResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type KnowledgeSetAutoLoadResponse = KnowledgeSetAutoLoadResponses[keyof KnowledgeSetAutoLoadResponses];

export type GetOverlapAnalysisData = {
  body?: never;
  path: {
    resultId: string;
  };
  query?: never;
  url: '/novelty-analysis/analysis-result/{resultId}/overlap-analysis';
};

export type GetOverlapAnalysisResponses = {
  /**
   * The request has succeeded.
   */
  200: GetNoveltyAnalysisResultOverlapResponse;
};

export type GetOverlapAnalysisResponse = GetOverlapAnalysisResponses[keyof GetOverlapAnalysisResponses];

export type GetOverlapAnalysisStatusData = {
  body?: never;
  path: {
    resultId: string;
  };
  query?: never;
  url: '/novelty-analysis/analysis-result/{resultId}/overlap-analysis/status';
};

export type GetOverlapAnalysisStatusResponses = {
  /**
   * The request has succeeded.
   */
  200: GetNoveltyAnalysisResultOverlapStatusResponse;
};

export type GetOverlapAnalysisStatusResponse =
  GetOverlapAnalysisStatusResponses[keyof GetOverlapAnalysisStatusResponses];

export type UpdateNoveltyAnalysisData = {
  body: UpdateNoveltyAnalysisRequest;
  path: {
    analysisId: string;
  };
  query?: never;
  url: '/novelty-analysis/analysis/{analysisId}';
};

export type UpdateNoveltyAnalysisResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type CancelNoveltyAnalysisData = {
  body?: never;
  path: {
    analysisId: string;
  };
  query?: never;
  url: '/novelty-analysis/analysis/{analysisId}/cancel';
};

export type CancelNoveltyAnalysisResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type GetNoveltyAnalysisFeaturesData = {
  body?: never;
  path: {
    analysisId: string;
  };
  query?: never;
  url: '/novelty-analysis/analysis/{analysisId}/features';
};

export type GetNoveltyAnalysisFeaturesResponses = {
  /**
   * The request has succeeded.
   */
  200: NoveltyFeaturesBody;
};

export type GetNoveltyAnalysisFeaturesResponse =
  GetNoveltyAnalysisFeaturesResponses[keyof GetNoveltyAnalysisFeaturesResponses];

export type GetNoveltyAnalysisResultsData = {
  body?: never;
  path: {
    analysisId: string;
  };
  query?: {
    pageNumber?: number;
    pageSize?: number;
  };
  url: '/novelty-analysis/analysis/{analysisId}/results';
};

export type GetNoveltyAnalysisResultsResponses = {
  /**
   * The request has succeeded.
   */
  200: GetNoveltyAnalysisResultsResponse;
};

export type GetNoveltyAnalysisResultsResponse2 =
  GetNoveltyAnalysisResultsResponses[keyof GetNoveltyAnalysisResultsResponses];

export type GetNoveltyAnalysisStatusData = {
  body?: never;
  path: {
    analysisId: string;
  };
  query?: never;
  url: '/novelty-analysis/analysis/{analysisId}/status';
};

export type GetNoveltyAnalysisStatusResponses = {
  /**
   * The request has succeeded.
   */
  200: GetNoveltyAnalysisStatusResponse;
};

export type GetNoveltyAnalysisStatusResponse2 =
  GetNoveltyAnalysisStatusResponses[keyof GetNoveltyAnalysisStatusResponses];

export type ReviewSearchSuggestionData = {
  body?: never;
  path: {
    suggestionId: string;
  };
  query: {
    action: SearchSuggestionReviewAction;
  };
  url: '/novelty-analysis/search-suggestion/{suggestionId}';
};

export type ReviewSearchSuggestionResponses = {
  /**
   * The request has succeeded.
   */
  200: SearchSuggestionDetail;
};

export type ReviewSearchSuggestionResponse = ReviewSearchSuggestionResponses[keyof ReviewSearchSuggestionResponses];

export type GetNoveltyAnalysesData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/novelty-analysis/{resourceType}/{resourceId}/analyses';
};

export type GetNoveltyAnalysesResponses = {
  /**
   * The request has succeeded.
   */
  200: GetNoveltyAnalysesResponse;
};

export type GetNoveltyAnalysesResponse2 = GetNoveltyAnalysesResponses[keyof GetNoveltyAnalysesResponses];

export type CreateNoveltyAnalysisData = {
  body?: CreateNoveltyAnalysisRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/novelty-analysis/{resourceType}/{resourceId}/analysis/create';
};

export type CreateNoveltyAnalysisResponses = {
  /**
   * The request has succeeded.
   */
  200: string;
};

export type CreateNoveltyAnalysisResponse = CreateNoveltyAnalysisResponses[keyof CreateNoveltyAnalysisResponses];

export type GetNoveltyFeaturesData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/novelty-analysis/{resourceType}/{resourceId}/features';
};

export type GetNoveltyFeaturesResponses = {
  /**
   * The request has succeeded.
   */
  200: NoveltyFeaturesBody;
};

export type GetNoveltyFeaturesResponse = GetNoveltyFeaturesResponses[keyof GetNoveltyFeaturesResponses];

export type FeaturizeNoveltyAnalysisData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/novelty-analysis/{resourceType}/{resourceId}/features';
};

export type FeaturizeNoveltyAnalysisResponses = {
  /**
   * The request has succeeded.
   */
  200: NoveltyFeaturesBody;
};

export type FeaturizeNoveltyAnalysisResponse =
  FeaturizeNoveltyAnalysisResponses[keyof FeaturizeNoveltyAnalysisResponses];

export type UpdateNoveltyFeaturesData = {
  body: NoveltyFeaturesBody;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/novelty-analysis/{resourceType}/{resourceId}/features';
};

export type UpdateNoveltyFeaturesResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type DeleteObjectionStatusData = {
  body: DeleteObjectionStatusRequest;
  path?: never;
  query?: never;
  url: '/office-actions-2/objection/delete';
};

export type DeleteObjectionStatusResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type BulkRerunObjectionAnalysisData = {
  body: BulkObjectionRerunRequest;
  path?: never;
  query?: never;
  url: '/office-actions-2/objection/rerun';
};

export type BulkRerunObjectionAnalysisResponses = {
  /**
   * The request has succeeded.
   */
  200: BulkObjectionRerunResponse;
};

export type BulkRerunObjectionAnalysisResponse =
  BulkRerunObjectionAnalysisResponses[keyof BulkRerunObjectionAnalysisResponses];

export type DeclineSuggestionData = {
  body?: never;
  path: {
    suggestionId: string;
  };
  query?: never;
  url: '/office-actions-2/objection/suggestion/{suggestionId}/decline';
};

export type DeclineSuggestionResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type UpdateObjectionStatusData = {
  body: UpdateObjectionStatusRequest;
  path?: never;
  query?: never;
  url: '/office-actions-2/objection/update-status';
};

export type UpdateObjectionStatusResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type GetObjectionData = {
  body?: never;
  path: {
    objectionIdentityId: string;
  };
  query?: never;
  url: '/office-actions-2/objection/{objectionIdentityId}';
};

export type GetObjectionResponses = {
  /**
   * The request has succeeded.
   */
  200: GetOfficeActionObjectionResponse;
};

export type GetObjectionResponse = GetObjectionResponses[keyof GetObjectionResponses];

export type RerunObjectionAnalysisData = {
  body?: never;
  path: {
    objectionIdentityId: string;
  };
  query?: never;
  url: '/office-actions-2/objection/{objectionIdentityId}/rerun';
};

export type RerunObjectionAnalysisResponses = {
  /**
   * The request has been accepted for processing, but processing has not yet completed.
   */
  202: unknown;
};

export type GetObjectionStatusData = {
  body?: never;
  path: {
    objectionIdentityId: string;
  };
  query?: never;
  url: '/office-actions-2/objection/{objectionIdentityId}/status';
};

export type GetObjectionStatusResponses = {
  /**
   * The request has succeeded.
   */
  200: GetObjectionStatusResponse;
};

export type GetObjectionStatusResponse2 = GetObjectionStatusResponses[keyof GetObjectionStatusResponses];

export type GetSuggestionsData = {
  body?: never;
  path: {
    objectionIdentityId: string;
  };
  query?: {
    'include-declined'?: boolean;
  };
  url: '/office-actions-2/objection/{objectionIdentityId}/suggestion';
};

export type GetSuggestionsResponses = {
  /**
   * The request has succeeded.
   */
  200: ObjectionSuggestionResponse;
};

export type GetSuggestionsResponse = GetSuggestionsResponses[keyof GetSuggestionsResponses];

export type OrgProjectAnalyticsData = {
  body?: never;
  path?: never;
  query?: {
    type?: Array<ResourceType>;
  };
  url: '/org-admin/projects/analytics';
};

export type OrgProjectAnalyticsResponses = {
  /**
   * The request has succeeded.
   */
  200: ProjectAnalyticsResponse;
};

export type OrgProjectAnalyticsResponse = OrgProjectAnalyticsResponses[keyof OrgProjectAnalyticsResponses];

export type OrgProjectQueryAnalyticsData = {
  body: QueryProjectAnalyticsRequest;
  path?: never;
  query?: never;
  url: '/org-admin/projects/analytics/query';
};

export type OrgProjectQueryAnalyticsResponses = {
  /**
   * The request has succeeded.
   */
  200: ProjectAnalyticsResponse;
};

export type OrgProjectQueryAnalyticsResponse =
  OrgProjectQueryAnalyticsResponses[keyof OrgProjectQueryAnalyticsResponses];

export type GetPatentDraftsData = {
  body?: never;
  path?: never;
  query: {
    draftingMode: DraftMode;
    patentDraftMode?: DraftMode;
    search?: string;
    pageNumber?: number;
    pageSize?: number;
  };
  url: '/patent-draft';
};

export type GetPatentDraftsResponses = {
  /**
   * The request has succeeded.
   */
  200: GetAllPatentDraftsResponse;
};

export type GetPatentDraftsResponse = GetPatentDraftsResponses[keyof GetPatentDraftsResponses];

export type CreatePatentDraftData = {
  body: CreatePatentDraftRequest;
  path?: never;
  query?: never;
  url: '/patent-draft';
};

export type CreatePatentDraftResponses = {
  /**
   * The request has succeeded.
   */
  200: string;
};

export type CreatePatentDraftResponse = CreatePatentDraftResponses[keyof CreatePatentDraftResponses];

export type ArchivePatentDraftsData = {
  body: ArchivePatentDraftsRequest;
  path?: never;
  query?: never;
  url: '/patent-draft/archive';
};

export type ArchivePatentDraftsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type CreatePatentDraftFromDisclosureData = {
  body: CreateDraftFromDisclosureRequest;
  path?: never;
  query?: {
    'disclosure-id'?: string;
  };
  url: '/patent-draft/create';
};

export type CreatePatentDraftFromDisclosureResponses = {
  /**
   * The request has succeeded.
   */
  200: string;
};

export type CreatePatentDraftFromDisclosureResponse =
  CreatePatentDraftFromDisclosureResponses[keyof CreatePatentDraftFromDisclosureResponses];

export type PutPatentDraftDraftingModeData = {
  body: PutPatentDraftDraftingModeRequest;
  path?: never;
  query?: never;
  url: '/patent-draft/drafting-mode';
};

export type PutPatentDraftDraftingModeResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type BatchDeletePatentDraftFilesData = {
  body: BatchDeletePatentDraftFilesRequest;
  path?: never;
  query?: never;
  url: '/patent-draft/file/batch';
};

export type BatchDeletePatentDraftFilesResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type CreatePatentDraftFileByPatentNumberV2Data = {
  body: PatentNumberUploadRequest;
  path: {
    patentDraftFileType: PatentDraftFileType;
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/file/upload-by-patent-number-v2/{patentDraftFileType}/{patentDraftId}';
};

export type CreatePatentDraftFileByPatentNumberV2Responses = {
  /**
   * The request has succeeded.
   */
  200: PatentNumberUploadResult;
};

export type CreatePatentDraftFileByPatentNumberV2Response =
  CreatePatentDraftFileByPatentNumberV2Responses[keyof CreatePatentDraftFileByPatentNumberV2Responses];

export type CreatePatentDraftFileData = {
  body: {
    fileName: string;
    file: unknown;
  };
  path: {
    patentDraftFileType: PatentDraftFileType;
    patentDraftId: string;
  };
  query?: {
    'convert-to-pdf'?: boolean;
  };
  url: '/patent-draft/file/upload/{patentDraftFileType}/{patentDraftId}';
};

export type CreatePatentDraftFileResponses = {
  /**
   * The request has succeeded.
   */
  200: Array<string>;
};

export type CreatePatentDraftFileResponse = CreatePatentDraftFileResponses[keyof CreatePatentDraftFileResponses];

export type DeletePatentDraftFileData = {
  body?: never;
  path: {
    fileId: string;
  };
  query?: never;
  url: '/patent-draft/file/{fileId}';
};

export type DeletePatentDraftFileResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type QueueFileForOcrData = {
  body?: never;
  path: {
    fileId: string;
  };
  query?: never;
  url: '/patent-draft/file/{fileId}/queue-ocr';
};

export type QueueFileForOcrResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type UpdatePatentDraftFileInfoData = {
  body: UpdatePatentDraftFileInfoRequest;
  path: {
    fileId: string;
  };
  query?: never;
  url: '/patent-draft/file/{fileId}/update-info';
};

export type UpdatePatentDraftFileInfoResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type GetPatentDraftFilesData = {
  body?: never;
  path: {
    patentDraftId: string;
  };
  query?: {
    patentDraftFileType?: PatentDraftFileType;
  };
  url: '/patent-draft/file/{patentDraftId}';
};

export type GetPatentDraftFilesResponses = {
  /**
   * The request has succeeded.
   */
  200: GetPatentDraftFilesResponse;
};

export type GetPatentDraftFilesResponse2 = GetPatentDraftFilesResponses[keyof GetPatentDraftFilesResponses];

export type ParseCdxCmlData = {
  body: {
    fileName: string;
    file: unknown;
    mergeFragments?: boolean;
  };
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/file/{patentDraftId}/convert-chemdraw';
};

export type ParseCdxCmlResponses = {
  /**
   * The request has succeeded.
   */
  200: ParseCdxCmlResponse;
};

export type ParseCdxCmlResponse2 = ParseCdxCmlResponses[keyof ParseCdxCmlResponses];

export type ExtractCompoundsFromDocxData = {
  body: {
    fileName: string;
    file: unknown;
  };
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/file/{patentDraftId}/extract-cdx-cml';
};

export type ExtractCompoundsFromDocxResponses = {
  /**
   * The request has succeeded.
   */
  200: ExtractCompoundsFromDocxResponse;
};

export type ExtractCompoundsFromDocxResponse2 =
  ExtractCompoundsFromDocxResponses[keyof ExtractCompoundsFromDocxResponses];

export type ExtractSpreadsheetData = {
  body: {
    fileName: string;
    file: unknown;
  };
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/file/{patentDraftId}/extract-spreadsheet';
};

export type ExtractSpreadsheetResponses = {
  /**
   * The request has succeeded.
   */
  200: ExtractSpreadsheetResponse;
};

export type ExtractSpreadsheetResponse2 = ExtractSpreadsheetResponses[keyof ExtractSpreadsheetResponses];

export type PutPatentDraftInventionDescriptionData = {
  body: PutPatentDraftInventionDescriptionRequest;
  path?: never;
  query?: never;
  url: '/patent-draft/invention-description';
};

export type PutPatentDraftInventionDescriptionResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type PutPatentDraftJurisdictionData = {
  body: PutPatentDraftJurisdictionRequest;
  path?: never;
  query?: never;
  url: '/patent-draft/jurisdiction';
};

export type PutPatentDraftJurisdictionResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type GetJurisdictionLanguagesData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/patent-draft/jurisdiction-languages';
};

export type GetJurisdictionLanguagesResponses = {
  /**
   * The request has succeeded.
   */
  200: {
    [key: string]: unknown;
  };
};

export type GetJurisdictionLanguagesResponse =
  GetJurisdictionLanguagesResponses[keyof GetJurisdictionLanguagesResponses];

export type PutPatentDraftLanguageData = {
  body: PutPatentDraftLanguageRequest;
  path?: never;
  query?: never;
  url: '/patent-draft/language';
};

export type PutPatentDraftLanguageResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type PutPatentDraftNameData = {
  body: PutPatentDraftNameRequest;
  path?: never;
  query?: never;
  url: '/patent-draft/name';
};

export type PutPatentDraftNameResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type AddPatentDraftReferencePatentFileData = {
  body: AddPatentDraftReferencePatentFileIdRequest;
  path?: never;
  query?: never;
  url: '/patent-draft/reference-patents/file';
};

export type AddPatentDraftReferencePatentFileResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type PutPatentDraftReferencePatentIdsData = {
  body: PutPatentDraftReferencePatentIdsRequest;
  path?: never;
  query?: never;
  url: '/patent-draft/reference-patents/patent-ids';
};

export type PutPatentDraftReferencePatentIdsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type PatentDraftSequenceMolTypeListData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/patent-draft/sequences/mol-types';
};

export type PatentDraftSequenceMolTypeListResponses = {
  /**
   * The request has succeeded.
   */
  200: MolTypeOptionsResponse;
};

export type PatentDraftSequenceMolTypeListResponse =
  PatentDraftSequenceMolTypeListResponses[keyof PatentDraftSequenceMolTypeListResponses];

export type GetPatentDraftData = {
  body?: never;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}';
};

export type GetPatentDraftResponses = {
  /**
   * The request has succeeded.
   */
  200: PatentDraftDetails;
};

export type GetPatentDraftResponse = GetPatentDraftResponses[keyof GetPatentDraftResponses];

export type PutContentData = {
  body: PutContentRequest;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/content';
};

export type PutContentResponses = {
  /**
   * The request has succeeded.
   */
  200: PutContentResponse;
};

export type PutContentResponse2 = PutContentResponses[keyof PutContentResponses];

export type PutContentWithCommentsData = {
  body: PutContentRequest;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/content/comments';
};

export type PutContentWithCommentsResponses = {
  /**
   * The request has succeeded.
   */
  200: PutContentResponse;
};

export type PutContentWithCommentsResponse = PutContentWithCommentsResponses[keyof PutContentWithCommentsResponses];

export type PutPatentDraftCustomInstructionsIdData = {
  body: PutPatentDraftCustomInstructionsIdRequest;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/custom-instructions-id';
};

export type PutPatentDraftCustomInstructionsIdResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type DeleteTrackedChangesData = {
  body?: never;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/delete-tracked-changes';
};

export type DeleteTrackedChangesResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ExportDraftData = {
  body?: never;
  path: {
    patentDraftId: string;
  };
  query?: {
    templateId?: string;
  };
  url: '/patent-draft/{patentDraftId}/export';
};

export type ExportDraftResponses = {
  /**
   * The request has succeeded.
   */
  200: ExportDraftResponse;
};

export type ExportDraftResponse2 = ExportDraftResponses[keyof ExportDraftResponses];

export type GenerateDraftData = {
  body?: never;
  path: {
    patentDraftId: string;
  };
  query?: {
    'template-id'?: string;
  };
  url: '/patent-draft/{patentDraftId}/generate';
};

export type GenerateDraftResponses = {
  /**
   * The request has succeeded.
   */
  200: PutContentResponse;
};

export type GenerateDraftResponse = GenerateDraftResponses[keyof GenerateDraftResponses];

export type InitTrackedChangesData = {
  body?: never;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/init-tracked-changes';
};

export type InitTrackedChangesResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type DeletePatentDraftReferencePatentFileData = {
  body?: never;
  path: {
    patentDraftId: string;
    fileId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/reference-patents/file/{fileId}';
};

export type DeletePatentDraftReferencePatentFileResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type PatentDraftSequencesDeleteAllData = {
  body?: never;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/sequences';
};

export type PatentDraftSequencesDeleteAllResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type PatentDraftSequencesListData = {
  body?: never;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/sequences';
};

export type PatentDraftSequencesListResponses = {
  /**
   * The request has succeeded.
   */
  200: ListSequencesResponse;
};

export type PatentDraftSequencesListResponse =
  PatentDraftSequencesListResponses[keyof PatentDraftSequencesListResponses];

export type PatentDraftSequencesCreateData = {
  body: CreateSequenceRequest;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/sequences';
};

export type PatentDraftSequencesCreateResponses = {
  /**
   * The request has succeeded.
   */
  200: SequenceInfo;
};

export type PatentDraftSequencesCreateResponse =
  PatentDraftSequencesCreateResponses[keyof PatentDraftSequencesCreateResponses];

export type PatentDraftSequencesDeleteBatchData = {
  body: DeleteSequencesRequest;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/sequences/batch';
};

export type PatentDraftSequencesDeleteBatchResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type PatentDraftSequencesBatchCreateData = {
  body: BatchCreateSequencesRequest;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/sequences/batch';
};

export type PatentDraftSequencesBatchCreateResponses = {
  /**
   * The request has succeeded.
   */
  200: ListSequencesResponse;
};

export type PatentDraftSequencesBatchCreateResponse =
  PatentDraftSequencesBatchCreateResponses[keyof PatentDraftSequencesBatchCreateResponses];

export type PatentDraftSequencesBulkRenumberData = {
  body: BulkRenumberSequencesRequest;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/sequences/batch';
};

export type PatentDraftSequencesBulkRenumberResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type PatentDraftSequencesExportData = {
  body?: never;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/sequences/export';
};

export type PatentDraftSequencesExportResponses = {
  /**
   * The request has succeeded.
   */
  200: Blob | File;
};

export type PatentDraftSequencesExportResponse =
  PatentDraftSequencesExportResponses[keyof PatentDraftSequencesExportResponses];

export type PatentDraftSequencesExtractFromTabularFileData = {
  body: {
    file: unknown;
    options: ExtractTabularSequenceDataRequest;
  };
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/sequences/extract-from-tabular-file';
};

export type PatentDraftSequencesExtractFromTabularFileResponses = {
  /**
   * The request has succeeded.
   */
  200: ExtractTabularSequenceDataResponse;
};

export type PatentDraftSequencesExtractFromTabularFileResponse =
  PatentDraftSequencesExtractFromTabularFileResponses[keyof PatentDraftSequencesExtractFromTabularFileResponses];

export type PatentDraftSequencesImportSequencesData = {
  body: {
    file: unknown;
  };
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/sequences/import';
};

export type PatentDraftSequencesImportSequencesResponses = {
  /**
   * The request has succeeded.
   */
  200: ListSequencesResponse;
};

export type PatentDraftSequencesImportSequencesResponse =
  PatentDraftSequencesImportSequencesResponses[keyof PatentDraftSequencesImportSequencesResponses];

export type ParseModificationsData = {
  body: {
    file: unknown;
  };
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/sequences/parse-modifications';
};

export type ParseModificationsResponses = {
  /**
   * The request has succeeded.
   */
  200: ParseModificationsResponse;
};

export type ParseModificationsResponse2 = ParseModificationsResponses[keyof ParseModificationsResponses];

export type PatentDraftSequencesGetData = {
  body?: never;
  path: {
    patentDraftId: string;
    sequenceId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/sequences/{sequenceId}';
};

export type PatentDraftSequencesGetResponses = {
  /**
   * The request has succeeded.
   */
  200: SequenceInfo;
};

export type PatentDraftSequencesGetResponse = PatentDraftSequencesGetResponses[keyof PatentDraftSequencesGetResponses];

export type PatentDraftSequencesUpdateData = {
  body: UpdateSequenceRequest;
  path: {
    patentDraftId: string;
    sequenceId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/sequences/{sequenceId}';
};

export type PatentDraftSequencesUpdateResponses = {
  /**
   * The request has succeeded.
   */
  200: SequenceInfo;
};

export type PatentDraftSequencesUpdateResponse =
  PatentDraftSequencesUpdateResponses[keyof PatentDraftSequencesUpdateResponses];

export type PutTemplateData = {
  body: PutTemplateRequest;
  path: {
    patentDraftId: string;
  };
  query?: never;
  url: '/patent-draft/{patentDraftId}/template';
};

export type PutTemplateResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ListPatentFamilyMembersData = {
  body: ListPatentFamilyMembersRequest;
  path?: never;
  query?: never;
  url: '/patent-office/family/search';
};

export type ListPatentFamilyMembersResponses = {
  /**
   * The request has succeeded.
   */
  200: ListPatentFamilyMembersResponse;
};

export type ListPatentFamilyMembersResponse2 = ListPatentFamilyMembersResponses[keyof ListPatentFamilyMembersResponses];

export type PatentOfficeFileImportFilesData = {
  body: ImportPatentOfficeFileRequest;
  path?: never;
  query?: never;
  url: '/patent-office/file/import';
};

export type PatentOfficeFileImportFilesResponses = {
  /**
   * The request has succeeded.
   */
  200: ImportPatentOfficeFileResponse;
};

export type PatentOfficeFileImportFilesResponse =
  PatentOfficeFileImportFilesResponses[keyof PatentOfficeFileImportFilesResponses];

export type DeleteAdminCustomFieldData = {
  body?: never;
  path: {
    fieldId: string;
  };
  query?: never;
  url: '/platform-admin/custom-fields/{fieldId}';
};

export type DeleteAdminCustomFieldResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type UpdateAdminCustomFieldData = {
  body: AdminCustomFieldSettings;
  path: {
    fieldId: string;
  };
  query?: never;
  url: '/platform-admin/custom-fields/{fieldId}';
};

export type UpdateAdminCustomFieldResponses = {
  /**
   * The request has succeeded.
   */
  200: AdminCustomField;
};

export type UpdateAdminCustomFieldResponse = UpdateAdminCustomFieldResponses[keyof UpdateAdminCustomFieldResponses];

export type ListAdminCustomFieldsData = {
  body?: never;
  path: {
    organizationId: string;
  };
  query?: never;
  url: '/platform-admin/organization/{organizationId}/custom-fields';
};

export type ListAdminCustomFieldsResponses = {
  /**
   * The request has succeeded.
   */
  200: ListAdminCustomFieldsResponse;
};

export type ListAdminCustomFieldsResponse2 = ListAdminCustomFieldsResponses[keyof ListAdminCustomFieldsResponses];

export type CreateAdminCustomFieldsData = {
  body: CreateAdminCustomFieldsRequest;
  path: {
    organizationId: string;
    resourceType: ResourceType;
  };
  query?: never;
  url: '/platform-admin/organization/{organizationId}/custom-fields/{resourceType}';
};

export type CreateAdminCustomFieldsResponses = {
  /**
   * The request has succeeded.
   */
  200: ListAdminCustomFieldsResponse;
};

export type CreateAdminCustomFieldsResponse = CreateAdminCustomFieldsResponses[keyof CreateAdminCustomFieldsResponses];

export type GetOrganizationSettingsData = {
  body?: never;
  path: {
    organizationId: string;
  };
  query?: never;
  url: '/platform-admin/organization/{organizationId}/settings';
};

export type GetOrganizationSettingsResponses = {
  /**
   * The request has succeeded.
   */
  200: AdminSettings;
};

export type GetOrganizationSettingsResponse = GetOrganizationSettingsResponses[keyof GetOrganizationSettingsResponses];

export type UpdateOrganizationSettingsData = {
  body: UpdateSettingsRequest;
  path: {
    organizationId: string;
  };
  query?: never;
  url: '/platform-admin/organization/{organizationId}/settings/update';
};

export type UpdateOrganizationSettingsResponses = {
  /**
   * The request has succeeded.
   */
  200: AdminSettings;
};

export type UpdateOrganizationSettingsResponse =
  UpdateOrganizationSettingsResponses[keyof UpdateOrganizationSettingsResponses];

export type ProjectFolderGetAllData = {
  body?: never;
  path?: never;
  query?: {
    access?: Array<AccessType>;
  };
  url: '/project-folders';
};

export type ProjectFolderGetAllResponses = {
  /**
   * The request has succeeded.
   */
  200: ProjectFoldersResponse;
};

export type ProjectFolderGetAllResponse = ProjectFolderGetAllResponses[keyof ProjectFolderGetAllResponses];

export type ProjectFolderCreateData = {
  body: CreateProjectFolderRequest;
  path?: never;
  query?: never;
  url: '/project-folders';
};

export type ProjectFolderCreateResponses = {
  /**
   * The request has succeeded.
   */
  200: ResourceFolderMetadata;
};

export type ProjectFolderCreateResponse = ProjectFolderCreateResponses[keyof ProjectFolderCreateResponses];

export type ProjectFolderDeleteData = {
  body?: never;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/project-folders/{folderId}';
};

export type ProjectFolderDeleteResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type ProjectFolderDeleteResponse = ProjectFolderDeleteResponses[keyof ProjectFolderDeleteResponses];

export type ProjectFolderGetData = {
  body?: never;
  path: {
    folderId: string;
  };
  query?: {
    search?: string;
    type?: Array<ResourceType>;
    'drafting-mode'?: Array<DraftMode>;
    'review-status'?: Array<string>;
    assignee?: Array<string>;
    unassigned?: boolean;
    'sort-by'?: ProjectSort;
    'sort-order'?: SortOrder;
    'page-number'?: number;
    'page-size'?: number;
  };
  url: '/project-folders/{folderId}';
};

export type ProjectFolderGetResponses = {
  /**
   * The request has succeeded.
   */
  200: ProjectFolderDetail;
};

export type ProjectFolderGetResponse = ProjectFolderGetResponses[keyof ProjectFolderGetResponses];

export type ProjectFolderUpdateData = {
  body: UpdateProjectFolderRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/project-folders/{folderId}';
};

export type ProjectFolderUpdateResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ProjectFolderRemoveItemsData = {
  body: UpdateProjectFolderItemsRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/project-folders/{folderId}/items';
};

export type ProjectFolderRemoveItemsResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type ProjectFolderRemoveItemsResponse =
  ProjectFolderRemoveItemsResponses[keyof ProjectFolderRemoveItemsResponses];

export type ProjectFolderAddItemsData = {
  body: UpdateProjectFolderItemsRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/project-folders/{folderId}/items';
};

export type ProjectFolderAddItemsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ProjectFolderQueryData = {
  body: QueryProjectsRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/project-folders/{folderId}/query';
};

export type ProjectFolderQueryResponses = {
  /**
   * The request has succeeded.
   */
  200: ProjectFolderDetail;
};

export type ProjectFolderQueryResponse = ProjectFolderQueryResponses[keyof ProjectFolderQueryResponses];

export type ListTasksData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/project-tasks/{resourceType}/{resourceId}';
};

export type ListTasksResponses = {
  /**
   * The request has succeeded.
   */
  200: Array<ProjectTask>;
};

export type ListTasksResponse = ListTasksResponses[keyof ListTasksResponses];

export type ProjectListData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
    'include-folders'?: boolean;
    type?: Array<ResourceType>;
    'drafting-mode'?: Array<DraftMode>;
    'review-status'?: Array<string>;
    assignee?: Array<string>;
    unassigned?: boolean;
    'last-used-after'?: Instant;
    'sort-by'?: ProjectSort;
    'sort-order'?: SortOrder;
    'page-number'?: number;
    'page-size'?: number;
  };
  url: '/projects';
};

export type ProjectListResponses = {
  /**
   * The request has succeeded.
   */
  200: ListProjectsResponse;
};

export type ProjectListResponse = ProjectListResponses[keyof ProjectListResponses];

export type ProjectAnalyticsData = {
  body?: never;
  path?: never;
  query?: {
    type?: Array<ResourceType>;
  };
  url: '/projects/analytics';
};

export type ProjectAnalyticsResponses = {
  /**
   * The request has succeeded.
   */
  200: ProjectAnalyticsResponse;
};

export type ProjectAnalyticsResponse2 = ProjectAnalyticsResponses[keyof ProjectAnalyticsResponses];

export type ProjectQueryAnalyticsData = {
  body: QueryProjectAnalyticsRequest;
  path?: never;
  query?: never;
  url: '/projects/analytics/query';
};

export type ProjectQueryAnalyticsResponses = {
  /**
   * The request has succeeded.
   */
  200: ProjectAnalyticsResponse;
};

export type ProjectQueryAnalyticsResponse = ProjectQueryAnalyticsResponses[keyof ProjectQueryAnalyticsResponses];

export type ProjectDeleteProjectsData = {
  body: DeleteProjectsRequest;
  path?: never;
  query?: never;
  url: '/projects/delete';
};

export type ProjectDeleteProjectsResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type ProjectDeleteProjectsResponse = ProjectDeleteProjectsResponses[keyof ProjectDeleteProjectsResponses];

export type ProjectFacetsData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
    'include-folders'?: boolean;
    'folder-id'?: string;
    type?: Array<ResourceType>;
    'draft-mode'?: Array<DraftMode>;
    'review-status'?: Array<string>;
    assignee?: Array<string>;
    unassigned?: boolean;
    'last-used-after'?: Instant;
  };
  url: '/projects/facets';
};

export type ProjectFacetsResponses = {
  /**
   * The request has succeeded.
   */
  200: ProjectFacetsResponse;
};

export type ProjectFacetsResponse2 = ProjectFacetsResponses[keyof ProjectFacetsResponses];

export type ProjectQueryFacetsData = {
  body: QueryProjectFacetsRequest;
  path?: never;
  query?: never;
  url: '/projects/facets/query';
};

export type ProjectQueryFacetsResponses = {
  /**
   * The request has succeeded.
   */
  200: ProjectFacetsResponse;
};

export type ProjectQueryFacetsResponse = ProjectQueryFacetsResponses[keyof ProjectQueryFacetsResponses];

export type ProjectQueryData = {
  body: QueryProjectsRequest;
  path?: never;
  query?: never;
  url: '/projects/query';
};

export type ProjectQueryResponses = {
  /**
   * The request has succeeded.
   */
  200: ListProjectsResponse;
};

export type ProjectQueryResponse = ProjectQueryResponses[keyof ProjectQueryResponses];

export type ProjectUpdateReviewData = {
  body: UpdateProjectReviewRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/projects/{resourceType}/{resourceId}/review';
};

export type ProjectUpdateReviewResponses = {
  /**
   * The request has succeeded.
   */
  200: ProjectReview;
};

export type ProjectUpdateReviewResponse = ProjectUpdateReviewResponses[keyof ProjectUpdateReviewResponses];

export type ProjectTrackProjectViewedData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/projects/{resourceType}/{resourceId}/track-viewed';
};

export type ProjectTrackProjectViewedResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type ProjectTrackProjectViewedResponse =
  ProjectTrackProjectViewedResponses[keyof ProjectTrackProjectViewedResponses];

export type ReferenceSignGetReferenceSignsByResourceData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}';
};

export type ReferenceSignGetReferenceSignsByResourceResponses = {
  /**
   * The request has succeeded.
   */
  200: ReferenceSignsResponse;
};

export type ReferenceSignGetReferenceSignsByResourceResponse =
  ReferenceSignGetReferenceSignsByResourceResponses[keyof ReferenceSignGetReferenceSignsByResourceResponses];

export type ReferenceSignCreateReferenceSignData = {
  body: NewReferenceSignDetails;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}';
};

export type ReferenceSignCreateReferenceSignResponses = {
  /**
   * The request has succeeded.
   */
  200: string;
};

export type ReferenceSignCreateReferenceSignResponse =
  ReferenceSignCreateReferenceSignResponses[keyof ReferenceSignCreateReferenceSignResponses];

export type ReferenceSignArchiveReferenceSignsData = {
  body: ArchiveReferenceSignsRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/archive';
};

export type ReferenceSignArchiveReferenceSignsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ReferenceSignBatchCreateReferenceSignsData = {
  body: BatchCreateReferenceSignsRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/batch';
};

export type ReferenceSignBatchCreateReferenceSignsResponses = {
  /**
   * The request has succeeded.
   */
  200: Array<string>;
};

export type ReferenceSignBatchCreateReferenceSignsResponse =
  ReferenceSignBatchCreateReferenceSignsResponses[keyof ReferenceSignBatchCreateReferenceSignsResponses];

export type ReferenceSignEditReferenceSignData = {
  body: EditReferenceSignRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/edit';
};

export type ReferenceSignEditReferenceSignResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ReferenceSignBatchEditReferenceSignsData = {
  body: BatchEditReferenceSignsRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/edit/batch';
};

export type ReferenceSignBatchEditReferenceSignsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ReferenceSignGetReferenceSignsByFigureData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
    figureId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/figure/{figureId}';
};

export type ReferenceSignGetReferenceSignsByFigureResponses = {
  /**
   * The request has succeeded.
   */
  200: ReferenceSignsResponse;
};

export type ReferenceSignGetReferenceSignsByFigureResponse =
  ReferenceSignGetReferenceSignsByFigureResponses[keyof ReferenceSignGetReferenceSignsByFigureResponses];

export type ReferenceSignBatchGenerateReferenceSignsData = {
  body: Array<string>;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/generate/batch';
};

export type ReferenceSignBatchGenerateReferenceSignsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ReferenceSignGenerateReferenceSignsForFigureData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
    figureId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/generate/figure/{figureId}';
};

export type ReferenceSignGenerateReferenceSignsForFigureResponses = {
  /**
   * The request has succeeded.
   */
  200: GeneratedReferenceSignsResponse;
};

export type ReferenceSignGenerateReferenceSignsForFigureResponse =
  ReferenceSignGenerateReferenceSignsForFigureResponses[keyof ReferenceSignGenerateReferenceSignsForFigureResponses];

export type ReferenceSignGenerateReferenceSignsFromImageData = {
  body: GenerateReferenceSignsFromImageRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/generate/image';
};

export type ReferenceSignGenerateReferenceSignsFromImageResponses = {
  /**
   * The request has succeeded.
   */
  200: GeneratedReferenceSignsResponse;
};

export type ReferenceSignGenerateReferenceSignsFromImageResponse =
  ReferenceSignGenerateReferenceSignsFromImageResponses[keyof ReferenceSignGenerateReferenceSignsFromImageResponses];

export type ReferenceSignImportReferenceSignsFromDocumentData = {
  body: ImportReferenceSignsFromDocumentRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/import/document';
};

export type ReferenceSignImportReferenceSignsFromDocumentResponses = {
  /**
   * The request has succeeded.
   */
  200: GeneratedReferenceSignsResponse;
};

export type ReferenceSignImportReferenceSignsFromDocumentResponse =
  ReferenceSignImportReferenceSignsFromDocumentResponses[keyof ReferenceSignImportReferenceSignsFromDocumentResponses];

export type ReferenceSignLinkReferenceSignData = {
  body: ReferenceSignFigureLinkRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/link';
};

export type ReferenceSignLinkReferenceSignResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ReferenceSignBatchLinkReferenceSignsData = {
  body: BatchReferenceSignFigureLinkRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/link/batch';
};

export type ReferenceSignBatchLinkReferenceSignsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ReferenceSignPlaceReferenceSignsData = {
  body: PlaceReferenceSignsRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/place';
};

export type ReferenceSignPlaceReferenceSignsResponses = {
  /**
   * The request has succeeded.
   */
  200: PlaceReferenceSignsResponse;
};

export type ReferenceSignPlaceReferenceSignsResponse =
  ReferenceSignPlaceReferenceSignsResponses[keyof ReferenceSignPlaceReferenceSignsResponses];

export type ReferenceSignPlaceReferenceSignsV2Data = {
  body: PlaceReferenceSignsV2Request;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/place/v2';
};

export type ReferenceSignPlaceReferenceSignsV2Responses = {
  /**
   * The request has succeeded.
   */
  200: PlaceReferenceSignsV2Response;
};

export type ReferenceSignPlaceReferenceSignsV2Response =
  ReferenceSignPlaceReferenceSignsV2Responses[keyof ReferenceSignPlaceReferenceSignsV2Responses];

export type ReferenceSignUnlinkReferenceSignData = {
  body: ReferenceSignFigureLinkRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/unlink';
};

export type ReferenceSignUnlinkReferenceSignResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ReferenceSignBatchUnlinkReferenceSignsData = {
  body: BatchReferenceSignFigureLinkRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/unlink/batch';
};

export type ReferenceSignBatchUnlinkReferenceSignsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ReferenceSignPutValueData = {
  body: PutReferenceSignValueRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/reference-sign/{resourceType}/{resourceId}/value';
};

export type ReferenceSignPutValueResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ResourceKnowledgeListForDocumentData = {
  body?: never;
  path: {
    documentId: string;
  };
  query?: never;
  url: '/resource-knowledge/document/{documentId}';
};

export type ResourceKnowledgeListForDocumentResponses = {
  /**
   * The request has succeeded.
   */
  200: Array<ResourceKnowledgeItem>;
};

export type ResourceKnowledgeListForDocumentResponse =
  ResourceKnowledgeListForDocumentResponses[keyof ResourceKnowledgeListForDocumentResponses];

export type ResourceKnowledgeAttachToDocumentData = {
  body: AttachResourceKnowledgeRequest;
  path: {
    documentId: string;
  };
  query?: never;
  url: '/resource-knowledge/document/{documentId}';
};

export type ResourceKnowledgeAttachToDocumentResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: ResourceKnowledgeLink;
};

export type ResourceKnowledgeAttachToDocumentResponse =
  ResourceKnowledgeAttachToDocumentResponses[keyof ResourceKnowledgeAttachToDocumentResponses];

export type ResourceKnowledgeDetachFromDocumentData = {
  body?: never;
  path: {
    documentId: string;
    knowledgeId: string;
  };
  query?: never;
  url: '/resource-knowledge/document/{documentId}/{knowledgeId}';
};

export type ResourceKnowledgeDetachFromDocumentResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type ResourceKnowledgeDetachFromDocumentResponse =
  ResourceKnowledgeDetachFromDocumentResponses[keyof ResourceKnowledgeDetachFromDocumentResponses];

export type ResourceKnowledgeTemplateShareConflictsData = {
  body?: never;
  path: {
    templateId: string;
  };
  query?: never;
  url: '/resource-knowledge/template/{templateId}/share-conflicts';
};

export type ResourceKnowledgeTemplateShareConflictsResponses = {
  /**
   * The request has succeeded.
   */
  200: KnowledgeShareConflicts;
};

export type ResourceKnowledgeTemplateShareConflictsResponse =
  ResourceKnowledgeTemplateShareConflictsResponses[keyof ResourceKnowledgeTemplateShareConflictsResponses];

export type ResourceKnowledgeResolveTemplateShareConflictsData = {
  body?: never;
  path: {
    templateId: string;
  };
  query?: never;
  url: '/resource-knowledge/template/{templateId}/share-conflicts/resolve';
};

export type ResourceKnowledgeResolveTemplateShareConflictsResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type ResourceKnowledgeResolveTemplateShareConflictsResponse =
  ResourceKnowledgeResolveTemplateShareConflictsResponses[keyof ResourceKnowledgeResolveTemplateShareConflictsResponses];

export type ResourceKnowledgeListData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/resource-knowledge/{resourceType}/{resourceId}';
};

export type ResourceKnowledgeListResponses = {
  /**
   * The request has succeeded.
   */
  200: Array<ResourceKnowledgeItem>;
};

export type ResourceKnowledgeListResponse = ResourceKnowledgeListResponses[keyof ResourceKnowledgeListResponses];

export type ResourceKnowledgeAttachData = {
  body: AttachResourceKnowledgeRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/resource-knowledge/{resourceType}/{resourceId}';
};

export type ResourceKnowledgeAttachResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: ResourceKnowledgeLink;
};

export type ResourceKnowledgeAttachResponse = ResourceKnowledgeAttachResponses[keyof ResourceKnowledgeAttachResponses];

export type ResourceKnowledgeDetachData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
    knowledgeId: string;
  };
  query?: never;
  url: '/resource-knowledge/{resourceType}/{resourceId}/{knowledgeId}';
};

export type ResourceKnowledgeDetachResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type ResourceKnowledgeDetachResponse = ResourceKnowledgeDetachResponses[keyof ResourceKnowledgeDetachResponses];

export type SequencesDeleteBatchData = {
  body: DeleteSequencesRequest;
  path?: never;
  query?: never;
  url: '/sequence/batch';
};

export type SequencesDeleteBatchResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type SequencesDeleteBatchResponse = SequencesDeleteBatchResponses[keyof SequencesDeleteBatchResponses];

export type SequencesBulkRenumberData = {
  body: BulkRenumberSequencesRequest;
  path?: never;
  query?: never;
  url: '/sequence/batch';
};

export type SequencesBulkRenumberResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type SequencesBulkRenumberResponse = SequencesBulkRenumberResponses[keyof SequencesBulkRenumberResponses];

export type SequenceMolTypesListData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/sequence/mol-types';
};

export type SequenceMolTypesListResponses = {
  /**
   * The request has succeeded.
   */
  200: MolTypeOptionsResponse;
};

export type SequenceMolTypesListResponse = SequenceMolTypesListResponses[keyof SequenceMolTypesListResponses];

export type SequencesListData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/sequence/{resourceType}/{resourceId}';
};

export type SequencesListResponses = {
  /**
   * The request has succeeded.
   */
  200: ListSequencesResponse;
};

export type SequencesListResponse = SequencesListResponses[keyof SequencesListResponses];

export type SequencesDeleteAllData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/sequence/{resourceType}/{resourceId}/all';
};

export type SequencesDeleteAllResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type SequencesDeleteAllResponse = SequencesDeleteAllResponses[keyof SequencesDeleteAllResponses];

export type SequencesBatchCreateData = {
  body: BatchCreateSequencesRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/sequence/{resourceType}/{resourceId}/batch';
};

export type SequencesBatchCreateResponses = {
  /**
   * The request has succeeded.
   */
  200: ListSequencesResponse;
};

export type SequencesBatchCreateResponse = SequencesBatchCreateResponses[keyof SequencesBatchCreateResponses];

export type SequencesExportData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/sequence/{resourceType}/{resourceId}/export';
};

export type SequencesExportResponses = {
  /**
   * The request has succeeded.
   */
  200: Blob | File;
};

export type SequencesExportResponse = SequencesExportResponses[keyof SequencesExportResponses];

export type SequencesExtractFromTabularFileData = {
  body: {
    file: unknown;
    options: ExtractTabularSequenceDataRequest;
  };
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/sequence/{resourceType}/{resourceId}/extract-from-tabular-file';
};

export type SequencesExtractFromTabularFileResponses = {
  /**
   * The request has succeeded.
   */
  200: ExtractTabularSequenceDataResponse;
};

export type SequencesExtractFromTabularFileResponse =
  SequencesExtractFromTabularFileResponses[keyof SequencesExtractFromTabularFileResponses];

export type SequencesImportSequencesData = {
  body: {
    file: unknown;
  };
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: {
    folderId?: string;
  };
  url: '/sequence/{resourceType}/{resourceId}/import';
};

export type SequencesImportSequencesResponses = {
  /**
   * The request has succeeded.
   */
  200: ListSequencesResponse;
};

export type SequencesImportSequencesResponse =
  SequencesImportSequencesResponses[keyof SequencesImportSequencesResponses];

export type SequencesParseModificationsData = {
  body: {
    file: unknown;
  };
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/sequence/{resourceType}/{resourceId}/parse-modifications';
};

export type SequencesParseModificationsResponses = {
  /**
   * The request has succeeded.
   */
  200: ParseModificationsResponse;
};

export type SequencesParseModificationsResponse =
  SequencesParseModificationsResponses[keyof SequencesParseModificationsResponses];

export type SequencesGetData = {
  body?: never;
  path: {
    sequenceId: string;
  };
  query?: never;
  url: '/sequence/{sequenceId}';
};

export type SequencesGetResponses = {
  /**
   * The request has succeeded.
   */
  200: SequenceInfo;
};

export type SequencesGetResponse = SequencesGetResponses[keyof SequencesGetResponses];

export type SequencesUpdateData = {
  body: UpdateSequenceRequest;
  path: {
    sequenceId: string;
  };
  query?: never;
  url: '/sequence/{sequenceId}';
};

export type SequencesUpdateResponses = {
  /**
   * The request has succeeded.
   */
  200: SequenceInfo;
};

export type SequencesUpdateResponse = SequencesUpdateResponses[keyof SequencesUpdateResponses];

export type GetResolvedSettingsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/settings';
};

export type GetResolvedSettingsResponses = {
  /**
   * The request has succeeded.
   */
  200: Settings;
};

export type GetResolvedSettingsResponse = GetResolvedSettingsResponses[keyof GetResolvedSettingsResponses];

export type GenerateSigmaSearchQueryData = {
  body: GenerateSigmaSearchQueryRequest;
  path?: never;
  query?: {
    'include-mistranslations'?: boolean;
  };
  url: '/sigma-search/query/generate';
};

export type GenerateSigmaSearchQueryResponses = {
  /**
   * The request has succeeded.
   */
  200: GenerateSigmaSearchQueryResponse;
};

export type GenerateSigmaSearchQueryResponse2 =
  GenerateSigmaSearchQueryResponses[keyof GenerateSigmaSearchQueryResponses];

export type CreateSigmaSearchData = {
  body: CreateSigmaSearchRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/sigma-search/{resourceType}/{resourceId}/search/create';
};

export type CreateSigmaSearchResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: CreateSigmaSearchResponse;
};

export type CreateSigmaSearchResponse2 = CreateSigmaSearchResponses[keyof CreateSigmaSearchResponses];

export type ListSigmaSearchesData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/sigma-search/{resourceType}/{resourceId}/searches';
};

export type ListSigmaSearchesResponses = {
  /**
   * The request has succeeded.
   */
  200: ListSigmaSearchesResponse;
};

export type ListSigmaSearchesResponse2 = ListSigmaSearchesResponses[keyof ListSigmaSearchesResponses];

export type DeleteSigmaSearchData = {
  body?: never;
  path: {
    searchId: string;
  };
  query?: never;
  url: '/sigma-search/{searchId}';
};

export type DeleteSigmaSearchResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type DeleteSigmaSearchResponse = DeleteSigmaSearchResponses[keyof DeleteSigmaSearchResponses];

export type GetSigmaSearchData = {
  body?: never;
  path: {
    searchId: string;
  };
  query?: never;
  url: '/sigma-search/{searchId}';
};

export type GetSigmaSearchResponses = {
  /**
   * The request has succeeded.
   */
  200: GetSigmaSearchResponse;
};

export type GetSigmaSearchResponse2 = GetSigmaSearchResponses[keyof GetSigmaSearchResponses];

export type UpdateSigmaSearchData = {
  body: UpdateSigmaSearchRequest;
  path: {
    searchId: string;
  };
  query?: never;
  url: '/sigma-search/{searchId}';
};

export type UpdateSigmaSearchResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type CalibrateSigmaSearchData = {
  body?: never;
  path: {
    searchId: string;
  };
  query?: {
    pageSize?: number;
  };
  url: '/sigma-search/{searchId}/calibrate';
};

export type CalibrateSigmaSearchResponses = {
  /**
   * The request has been accepted for processing, but processing has not yet completed.
   */
  202: unknown;
};

export type GetSigmaSearchQueryData = {
  body?: never;
  path: {
    searchId: string;
  };
  query?: never;
  url: '/sigma-search/{searchId}/query';
};

export type GetSigmaSearchQueryResponses = {
  /**
   * The request has succeeded.
   */
  200: GetSigmaSearchQueryResponse;
};

export type GetSigmaSearchQueryResponse2 = GetSigmaSearchQueryResponses[keyof GetSigmaSearchQueryResponses];

export type PutSigmaSearchQueryData = {
  body: PutSigmaSearchQueryRequest;
  path: {
    searchId: string;
  };
  query?: never;
  url: '/sigma-search/{searchId}/query';
};

export type PutSigmaSearchQueryResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type RunSigmaSearchData = {
  body?: never;
  path: {
    searchId: string;
  };
  query?: never;
  url: '/sigma-search/{searchId}/run';
};

export type RunSigmaSearchResponses = {
  /**
   * The request has been accepted for processing, but processing has not yet completed.
   */
  202: unknown;
};

export type GetSigmaSearchStatusData = {
  body?: never;
  path: {
    searchId: string;
  };
  query?: never;
  url: '/sigma-search/{searchId}/status';
};

export type GetSigmaSearchStatusResponses = {
  /**
   * The request has succeeded.
   */
  200: GetSigmaSearchStatusResponse;
};

export type GetSigmaSearchStatusResponse2 = GetSigmaSearchStatusResponses[keyof GetSigmaSearchStatusResponses];

export type CaptureSuggestionReviewsData = {
  body: CaptureSuggestionReviewsRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/telemetry/{resourceType}/{resourceId}/suggestions';
};

export type CaptureSuggestionReviewsResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type CaptureSuggestionReviewsResponse =
  CaptureSuggestionReviewsResponses[keyof CaptureSuggestionReviewsResponses];

export type ListTemplatesData = {
  body?: never;
  path?: never;
  query: {
    'resource-type': ResourceType;
    'template-type'?: Array<TemplateType>;
    language?: Array<Language>;
  };
  url: '/templates';
};

export type ListTemplatesResponses = {
  /**
   * The request has succeeded.
   */
  200: ListTemplatesResponse;
};

export type ListTemplatesResponse2 = ListTemplatesResponses[keyof ListTemplatesResponses];

export type SaveFormTemplateData = {
  body: SaveFormTemplateRequest;
  path?: never;
  query?: never;
  url: '/templates/form';
};

export type SaveFormTemplateResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: GetTemplateResponse;
};

export type SaveFormTemplateResponse = SaveFormTemplateResponses[keyof SaveFormTemplateResponses];

export type SaveTableTemplateData = {
  body: SaveTableTemplateRequest;
  path?: never;
  query?: never;
  url: '/templates/table';
};

export type SaveTableTemplateResponses = {
  /**
   * The request has succeeded and a new resource has been created as a result.
   */
  201: GetTemplateResponse;
};

export type SaveTableTemplateResponse = SaveTableTemplateResponses[keyof SaveTableTemplateResponses];

export type DeleteTemplateData = {
  body?: never;
  path: {
    templateId: string;
  };
  query?: never;
  url: '/templates/{templateId}';
};

export type DeleteTemplateResponses = {
  /**
   * There is no content to send for this request, but the headers may be useful.
   */
  204: void;
};

export type DeleteTemplateResponse = DeleteTemplateResponses[keyof DeleteTemplateResponses];

export type GetTemplateData = {
  body?: never;
  path: {
    templateId: string;
  };
  query?: never;
  url: '/templates/{templateId}';
};

export type GetTemplateResponses = {
  /**
   * The request has succeeded.
   */
  200: GetTemplateResponse;
};

export type GetTemplateResponse2 = GetTemplateResponses[keyof GetTemplateResponses];

export type UpdateTemplateData = {
  body: UpdateTemplateRequest;
  path: {
    templateId: string;
  };
  query?: never;
  url: '/templates/{templateId}';
};

export type UpdateTemplateResponses = {
  /**
   * The request has succeeded.
   */
  200: GetTemplateResponse;
};

export type UpdateTemplateResponse = UpdateTemplateResponses[keyof UpdateTemplateResponses];

export type TemporaryFileUploadTemporaryFileData = {
  body: UploadTemporaryFileRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
    fileType: string;
  };
  query?: never;
  url: '/temporary-file/{resourceType}/{resourceId}/upload/{fileType}';
};

export type TemporaryFileUploadTemporaryFileResponses = {
  /**
   * The request has succeeded.
   */
  200: UploadTemporaryFileResponse;
};

export type TemporaryFileUploadTemporaryFileResponse =
  TemporaryFileUploadTemporaryFileResponses[keyof TemporaryFileUploadTemporaryFileResponses];

export type TemporaryFileGetTemporaryFileData = {
  body?: never;
  path: {
    temporaryFileId: string;
  };
  query?: never;
  url: '/temporary-file/{temporaryFileId}';
};

export type TemporaryFileGetTemporaryFileResponses = {
  /**
   * The request has succeeded.
   */
  200: GetTemporaryFileResponse;
};

export type TemporaryFileGetTemporaryFileResponse =
  TemporaryFileGetTemporaryFileResponses[keyof TemporaryFileGetTemporaryFileResponses];

export type UserLookupData = {
  body: LookupUsersRequest;
  path?: never;
  query?: never;
  url: '/users/lookup';
};

export type UserLookupResponses = {
  /**
   * The request has succeeded.
   */
  200: LookupUsersResponse;
};

export type UserLookupResponse = UserLookupResponses[keyof UserLookupResponses];

export type ItemFolderOperationsDeleteData = {
  body?: never;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/{folderId}';
};

export type ItemFolderOperationsDeleteResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ItemFolderOperationsUpdateData = {
  body: UpdateItemFolderRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/{folderId}';
};

export type ItemFolderOperationsUpdateResponses = {
  /**
   * The request has succeeded.
   */
  200: ItemFolderMetadata;
};

export type ItemFolderOperationsUpdateResponse =
  ItemFolderOperationsUpdateResponses[keyof ItemFolderOperationsUpdateResponses];

export type ItemFolderOperationsAddItemsData = {
  body: UpdateFolderItemsRequest;
  path: {
    folderId: string;
  };
  query?: never;
  url: '/{folderId}/items';
};

export type ItemFolderOperationsAddItemsResponses = {
  /**
   * The request has succeeded.
   */
  200: unknown;
};

export type ItemFolderOperationsGetAllData = {
  body?: never;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: {
    kind?: FolderKind;
  };
  url: '/{resourceType}/{resourceId}';
};

export type ItemFolderOperationsGetAllResponses = {
  /**
   * The request has succeeded.
   */
  200: ItemFoldersResponse;
};

export type ItemFolderOperationsGetAllResponse =
  ItemFolderOperationsGetAllResponses[keyof ItemFolderOperationsGetAllResponses];

export type ItemFolderOperationsCreateData = {
  body: CreateItemFolderRequest;
  path: {
    resourceType: ResourceType;
    resourceId: string;
  };
  query?: never;
  url: '/{resourceType}/{resourceId}';
};

export type ItemFolderOperationsCreateResponses = {
  /**
   * The request has succeeded.
   */
  200: ItemFolderMetadata;
};

export type ItemFolderOperationsCreateResponse =
  ItemFolderOperationsCreateResponses[keyof ItemFolderOperationsCreateResponses];
